import { reportBaseTranslations } from './reports/base';
import { cancelledServicesTranslations } from './reports/cancelled_services';
import { dailyDriverServiceTranslations } from './reports/daily_driver_service';
import { dailyServiceFrequencyTranslations } from './reports/daily_service_frequency';
import { driverAssignmentDetailTranslations } from './reports/driver_assignment_detail';
import { missedServicesTranslations } from './reports/missed_services';
import { serviceFrequencyTodayTranslations } from './reports/service_frequency_today';
import { serviceUsersTranslations } from './reports/service_users';

/**
 * Thai (default locale). Labels follow the source product verbatim
 * (CurrentTrip_07.pdf / Cab Go design system).
 */
export const th = {
  common: {
    mobileDevicesTitle: 'อุปกรณ์มือถือ',
    mobileDevicesHint:
      'ข้อมูลที่แอปรายงาน รวมถึงอุปกรณ์ที่เคยใช้งาน สถานะยังไม่พบการออกจากระบบไม่ได้หมายความว่าเครื่องกำลังออนไลน์',
    mobileDevicesEmpty: 'ยังไม่มีข้อมูลอุปกรณ์ ข้อมูลจะแสดงหลังเข้าสู่ระบบด้วยแอปเวอร์ชันที่รองรับ',
    mobileDevicesLoggedOut: 'ออกจากระบบแล้ว',
    mobileDevicesNotLoggedOut: 'ยังไม่พบการออกจากระบบ',
    mobileDevicesOs: 'เวอร์ชันระบบ',
    mobileDevicesApp: 'เวอร์ชันแอป',
    mobileDevicesVersionBuild: '{{version}} (build {{build}})',
    mobileDevicesFirstSeen: 'พบครั้งแรก',
    mobileDevicesLastSeen: 'พบล่าสุด',
    mobileDevicesLogoutAt: 'ออกจากระบบเมื่อ',
    mobileDevicesMore: 'โหลดอุปกรณ์เพิ่มเติม',
    appName: 'แค็บโก',
    save: 'บันทึกข้อมูล',
    saving: 'กำลังบันทึก…',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    create: 'เพิ่มข้อมูล',
    edit: 'แก้ไข',
    delete: 'ลบ',
    close: 'ปิด',
    menu: 'เมนู',
    search: 'ค้นหา',
    loading: 'กำลังโหลด…',
    noData: 'ไม่มีข้อมูล',
    vehiclePlateConflict: 'ป้ายทะเบียนนี้มีอยู่แล้วในหน่วยงานและจังหวัดเดียวกัน',
    bookingAdvanceHorizonError: 'วันเวลาที่เลือกเกินระยะจองล่วงหน้าที่บริการอนุญาต กรุณาเลือกเวลาใหม่',
    bookingAdvanceLeadError: 'วันเวลาเริ่มงานใกล้เกินไป กรุณาเลือกเวลาให้ตรงกับระยะจองล่วงหน้าขั้นต่ำของบริการ',
    bookingAdvanceLimitError: 'มีงานจองล่วงหน้าครบจำนวนที่บริการอนุญาตแล้ว',
    bookingAdvanceDisabledError: 'บริการนี้ไม่รับจองล่วงหน้า กรุณาเลือกจองทันทีหรือเปลี่ยนบริการ',
    bookingInstantDisabledError: 'บริการนี้ไม่รับจองทันที กรุณาเลือกจองล่วงหน้าหรือเปลี่ยนบริการ',
    bookingEquipmentError: 'อุปกรณ์ที่เลือกไม่พร้อมให้บริการ กรุณาตรวจสอบและเลือกใหม่',
    automationDepartureRadiusError:
      'รัศมีออกจากจุดต้องมากกว่าทั้งรัศมีถึงจุดรับและรัศมีถึงจุดส่ง โดยห้ามเท่ากัน กรุณาตรวจสอบค่าที่มีผล รวมถึงค่าที่ผู้ให้บริการและพื้นที่บริการรับจากระดับก่อนหน้า',
    bookingRouteShareError: 'บริการนี้ไม่อนุญาตให้แบ่งปันเส้นทาง กรุณาเปลี่ยนตัวเลือก',
    bookingPassengerAreaError: 'จุดรับหรือจุดหมายอยู่นอกพื้นที่สิทธิ์ผู้โดยสาร กรุณาแก้ไขสถานที่หรือเลือกบริการอื่น',
    bookingServiceAreaError: 'จุดรับหรือจุดหมายอยู่นอกพื้นที่ให้บริการ กรุณาตรวจสอบสถานที่',
    bookingRetryMismatch: 'มีการจองเดิมแล้วแต่รายละเอียดไม่ตรงกัน กรุณาตรวจสอบงานเดิมก่อนเริ่มรายการใหม่',
    total: 'ทั้งหมด',
    items: 'รายการ',
    status: 'สถานะ',
    active: 'อนุญาต',
    suspended: 'ไม่อนุญาต',
    all: 'ทั้งหมด',
    clearFilters: 'ล้างตัวกรอง',
    clear: 'ล้าง',
    inactiveShort: 'ไม่ใช้งาน',
    previousPeriod: 'ช่วงเวลาก่อนหน้า',
    nextPeriod: 'ช่วงเวลาถัดไป',
    // shared date-range filter (DateRangeFilter)
    dateRangeTitle: 'เลือกช่วงเวลา',
    rangeAll: 'ทุกช่วงเวลา',
    rangeToday: 'วันนี้',
    rangeYesterday: 'เมื่อวาน',
    rangeLast7: '7 วันล่าสุด',
    rangeLast30: '30 วันล่าสุด',
    rangeThisMonth: 'เดือนนี้',
    rangeLastMonth: 'เดือนก่อน',
    rangeThisYear: 'ปีนี้',
    rangeLastYear: 'ปีที่แล้ว',
    rangeClear: 'ล้างค่า',
    rangeStart: 'วันที่เริ่มต้น',
    rangeEnd: 'วันที่สิ้นสุด',
    datePickerTitle: 'เลือกวันที่',
    dateTimePickerTitle: 'เลือกวันที่และเวลา',
    datePickerMonth: 'เดือน',
    datePickerYear: 'ปี',
    datePickerPreviousMonth: 'เดือนก่อนหน้า',
    datePickerNextMonth: 'เดือนถัดไป',
    datePickerTime: 'เวลา',
    viewDetails: 'ดูรายละเอียด',
    copy: 'คัดลอก',
    copyWebBuild: 'คัดลอกข้อมูลเวอร์ชันเว็บ',
    webBuildCopied: 'คัดลอกข้อมูลเวอร์ชันเว็บแล้ว',
    webBuildCopyFailed: 'คัดลอกไม่สำเร็จ กรุณาบันทึกเลขเวอร์ชันที่แสดง',
    back: 'กลับ',
    next: 'ต่อไป',
    yes: 'ใช่',
    no: 'ไม่',
    error: 'เกิดข้อผิดพลาด',
    forbidden: 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้',
    legalTermsTitle: 'เงื่อนไขการให้บริการ',
    legalPrivacyTitle: 'นโยบายความเป็นส่วนตัว',
    legalPlaceholder: 'เอกสารอยู่ระหว่างการจัดทำ หากมีข้อสงสัยกรุณาติดต่อผู้ให้บริการของคุณ',
    retry: 'ลองอีกครั้ง',
    required: 'จำเป็น',
    optional: 'ไม่จำเป็น',
    language: 'ภาษา',
    actions: 'การจัดการ',
    deleteConfirmTitle: 'ยืนยันการลบข้อมูล',
    deleteConfirmBody: 'การลบข้อมูลนี้ไม่สามารถกู้คืนได้ ต้องการดำเนินการต่อหรือไม่',
    add: 'เพิ่ม',
    upload: 'อัปโหลด',
    uploadTooLarge: 'ไฟล์มีขนาดใหญ่เกินไป',
    uploadWrongType: 'ชนิดไฟล์ไม่รองรับ',
    uploadFailed: 'อัปโหลดไม่สำเร็จ',
    refresh: 'รีเฟรช',
    comingSoon: 'เร็ว ๆ นี้',
    comingSoonBody: 'ฟีเจอร์นี้กำลังอยู่ระหว่างการพัฒนา และจะพร้อมใช้งานเร็ว ๆ นี้',
    // image viewer modal
    imageViewerTitle: 'ดูรูปภาพ',
    imageViewerRotateLeft: 'หมุนซ้าย 90°',
    imageViewerRotateRight: 'หมุนขวา 90°',
    imageViewerZoomIn: 'ซูมเข้า',
    imageViewerZoomOut: 'ซูมออก',
    imageViewerReset: 'รีเซ็ต',
    imageViewerOpenOriginal: 'เปิดรูปต้นฉบับในแท็บใหม่',
    webPushTitle: 'การแจ้งเตือนเมื่อไม่ได้เปิดหน้าเว็บ',
    webPushEnable: 'เปิดใช้งาน',
    webPushDisable: 'ปิดใช้งาน',
    webPushRegistering: 'กำลังเปิด…',
    webPushState_unsupported: 'เบราว์เซอร์นี้ไม่รองรับ Web Push',
    webPushState_unconfigured: 'ระบบยังไม่ได้ตั้งค่า Web Push',
    webPushState_prompt: 'ปิดอยู่ กดเปิดใช้งานเพื่ออนุญาตการแจ้งเตือน',
    webPushState_registering: 'กำลังลงทะเบียนอุปกรณ์…',
    webPushState_enabled: 'เปิดอยู่ อุปกรณ์นี้จะได้รับการแจ้งเตือน',
    webPushState_denied: 'เบราว์เซอร์บล็อกการแจ้งเตือน กรุณาอนุญาตในการตั้งค่าเว็บไซต์',
    webPushState_error: 'เปิดใช้งานไม่สำเร็จ กรุณาลองอีกครั้ง',
  },
  nav: {
    mainNav: 'เมนูหลัก',
    dashboard: 'แดชบอร์ด',
    trips: 'การเดินทาง',
    care: 'การดูแล',
    tracking: 'ติดตาม',
    passengers: 'ผู้โดยสาร',
    drivers: 'พนักงาน',
    caregivers: 'ผู้ดูแล',
    settings: 'การตั้งค่า',
    dispatchSim: 'ห้องทดสอบวงจรคำขอ',
    logout: 'ออกจากระบบ',
  },
  auth: {
    loginTitle: 'เข้าสู่ระบบ',
    loginSubtitle: 'คอนโซลผู้ให้บริการ',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    loggingIn: 'กำลังเข้าสู่ระบบ…',
    invalidCredentials: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
    sessionExpired: 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่',
  },
  // Public /account-deletion-request page — the URL the mobile apps' "ขอลบบัญชี"
  // row opens (App Store 5.1.1(v) / Play Data-safety web link). Works logged-out.
  deletion: {
    title: 'ขอลบบัญชีผู้ใช้',
    intro: 'ยืนยันหมายเลขโทรศัพท์ของคุณด้วยรหัส OTP เพื่อส่งคำขอลบบัญชีและข้อมูลส่วนตัวออกจากระบบ Cab Go',
    actorType: 'ประเภทบัญชี',
    actorPassenger: 'ผู้ใช้บริการ (แอปลูกค้า)',
    actorAgent: 'พนักงาน/ผู้ดูแล (แอปพนักงาน)',
    phone: 'หมายเลขโทรศัพท์',
    sendCode: 'ส่งรหัส OTP',
    codeSent: 'ส่งรหัสไปยังหมายเลขของคุณแล้ว',
    code: 'รหัส OTP',
    note: 'เหตุผล (ไม่จำเป็น)',
    submit: 'ส่งคำขอลบบัญชี',
    warning:
      'เมื่อคำขอได้รับการอนุมัติ ข้อมูลส่วนตัวจะถูกลบถาวรและไม่สามารถกู้คืนได้ ประวัติการเดินทางและการชำระเงินจะถูกเก็บไว้เท่าที่จำเป็นตามข้อกำหนดทางบัญชี',
    successTitle: 'ส่งคำขอเรียบร้อยแล้ว',
    successBody: 'เจ้าหน้าที่จะตรวจสอบและดำเนินการลบบัญชีของคุณโดยเร็วที่สุด',
    completedTitle: 'ดำเนินการลบบัญชีเรียบร้อยแล้ว',
    completedBody: 'คำขอลบบัญชีของคุณได้รับการดำเนินการเรียบร้อยแล้ว',
    rejectedTitle: 'คำขอไม่ได้รับการดำเนินการ',
    rejectedBody: 'คุณสามารถยืนยันหมายเลขโทรศัพท์และส่งคำขอลบบัญชีใหม่ได้',
    submitAgain: 'ส่งคำขอใหม่',
    codeInvalid: 'รหัสไม่ถูกต้องหรือหมดอายุ',
    rateLimited: 'ดำเนินการบ่อยเกินไป กรุณารอสักครู่แล้วลองใหม่',
  },
  settings: {
    amendment_applyControl: 'หยุดการเปลี่ยนงานฉุกเฉิน',
    amendment_applyControlHelp:
      'แยกจากการเปิดรับคำขอใหม่ การหยุดจะปิดคำขอที่ค้างและกันเงินที่รับไว้เพื่อคืน โดยงานเดิมและประวัติที่ยืนยันแล้วไม่เปลี่ยน',
    amendment_applyStopped: 'หยุดการเปลี่ยนรายละเอียดงานอยู่',
    amendment_applyRunning: 'อนุญาตให้เปลี่ยนรายละเอียดงาน',
    amendment_applySystemStop: 'ระบบส่วนกลางยังสั่งหยุดอยู่ แม้ผู้ให้บริการจะเปิดทำงานต่อ',
    amendment_applyReason: 'เหตุผลภายในสำหรับเปลี่ยนการควบคุม',
    amendment_applyResume: 'เปิดให้คำขอใหม่ทำงานต่อ',
    amendment_applyStop: 'หยุดการเปลี่ยนงานฉุกเฉิน',
    amendment_applyStopHelp:
      'หยุดการเปลี่ยนงานทันที ระบบจะทยอยปิดคำขอที่ค้าง ปล่อยคิวและกันเงินคืน งานที่เปลี่ยนสำเร็จแล้วจะคงเดิม',
    amendment_applyResumeHelp:
      'อนุญาตเฉพาะคำขอที่ส่งใหม่ คำขอที่สร้างก่อนหยุดยังต้องปิดและจะไม่ฟื้นกลับมา การตั้งค่าเปิดรับคำขอใหม่ยังมีผล',
    amendment_title: 'นโยบายแก้ไขการจอง',
    amendment_configure: 'ตั้งค่า',
    amendment_conflict: 'การตั้งค่าเปลี่ยนแล้ว โหลดข้อมูลล่าสุดก่อนลองใหม่',
    amendment_constraints: 'ระบุจำนวนวินาทีเต็มที่มากกว่าศูนย์ ต้องกำหนดเวลาครบก่อนเปิดใช้การแก้ไขการจอง',
    amendment_defaultOff: 'ค่าเริ่มต้น: ปิดใช้งาน',
    amendment_denied: 'ต้องมีสิทธิ์ผู้ดูแลระบบ',
    amendment_enabled: 'อนุญาตให้แก้ไขการจอง',
    amendment_help: 'ค่าที่ผู้ให้บริการไม่ได้กำหนดจะใช้ค่าระบบ คำขอที่บันทึกแล้วใช้ฉบับนโยบายที่บันทึกไว้',
    amendment_incomplete: 'ยังใช้งานไม่ได้: กำหนดเวลาไม่ครบ',
    amendment_inherit: 'ใช้ค่าระบบ',
    amendment_localValue: 'ค่าที่บันทึกไว้: {{value}}',
    amendment_noProvider: 'เลือกผู้ให้บริการเพื่อตั้งค่านโยบาย',
    amendment_off: 'ปิดใช้งาน',
    amendment_on: 'เปิดใช้งาน',
    amendment_positiveInteger: 'ระบุวินาทีจำนวนเต็มตั้งแต่ 1 ถึง 2147483647',
    amendment_reload: 'โหลดการตั้งค่าล่าสุดโดยเก็บฉบับร่าง',
    amendment_reloaded: 'โหลดข้อมูลล่าสุดแล้ว และเก็บฉบับร่างไว้',
    amendment_saved: 'บันทึกการตั้งค่าแล้ว',
    amendment_scope: 'ระดับการตั้งค่า',
    amendment_unresolved: 'ยังไม่มีค่าที่มีผลใช้',
    amendment_unset: 'ยังไม่กำหนด',
    amendment_valueSource: 'ค่าที่มีผลใช้: {{value}} วินาที · {{source}}',
    amendment_SYSTEM: 'ระบบ',
    amendment_PROVIDER: 'ผู้ให้บริการ',
    amendment_AREA: 'พื้นที่',
    amendment_customerCutoffSeconds: 'เวลาก่อนเริ่มงานที่ลูกค้าขอแก้ได้ (วินาที)',
    amendment_agentResponseSeconds: 'เวลารอคนขับตอบ (วินาที)',
    amendment_replacementSearchSeconds: 'เวลาหาคนขับทดแทน (วินาที)',
    amendment_quoteGuaranteeSeconds: 'เวลารับรองราคา (วินาที)',
    amendment_paymentSeconds: 'เวลาชำระเงิน (วินาที)',
    amendment_verificationSeconds: 'เวลาตรวจหลักฐาน (วินาที)',
    amendment_finalizationSeconds: 'เวลาบันทึกการแก้ไข (วินาที)',
    amendment_holdSeconds: 'เวลากันคิว (วินาที)',
    amendment_overallSeconds: 'อายุคำขอรวม (วินาที)',

    partnerRefreshKeys: 'โหลดข้อมูลรับรองใหม่',
    partnerInterruptedIssuance:
      'หากการออกข้อมูลรับรองถูกขัดจังหวะ ให้โหลดรายการใหม่และเพิกถอนข้อมูลรับรองที่ไม่ต้องการก่อนออกใหม่ คำขอที่ถูกขัดจังหวะอาจยังดำเนินการสำเร็จบนเซิร์ฟเวอร์',
    partnerConnections: 'การเชื่อมต่อพาร์ทเนอร์',
    partnerAdminOnly: 'เฉพาะผู้ดูแลระบบของผู้ให้บริการเท่านั้นที่จัดการการเชื่อมต่อพาร์ทเนอร์ได้',
    partnerChooseProvider: 'เลือกผู้ให้บริการเพื่อดำเนินการต่อ',
    partnerProviderContext: 'ผู้ให้บริการ: {{id}}',
    partnerServer: 'สภาพแวดล้อมเซิร์ฟเวอร์ปัจจุบัน: {{environment}}',
    partnerServerUnknown: 'ไม่สามารถแสดงสภาพแวดล้อมเซิร์ฟเวอร์ปัจจุบันได้',
    partnerSandboxAvailable: 'เซิร์ฟเวอร์นี้รองรับการเชื่อมต่อทดสอบ โดยเซิร์ฟเวอร์จะตรวจสอบทุกคำขอ',
    partnerSandboxUnavailable: 'ไม่สามารถสร้างการเชื่อมต่อทดสอบได้ ห้ามทดสอบในระบบใช้งานจริง',
    partnerCreate: 'สร้างการเชื่อมต่อ',
    partnerRetry: 'ลองอีกครั้ง',
    partnerEmpty: 'ผู้ให้บริการนี้ยังไม่มีการเชื่อมต่อพาร์ทเนอร์',
    partnerIdentity: 'ข้อมูลพาร์ทเนอร์',
    partnerNew: 'สร้างพาร์ทเนอร์ใหม่',
    partnerExisting: 'เชื่อมต่อด้วยรหัสพาร์ทเนอร์ที่มีอยู่',
    partnerId: 'รหัสพาร์ทเนอร์',
    partnerName: 'ชื่อพาร์ทเนอร์',
    partnerExplicitLink:
      'ใช้รหัสที่มีอยู่เมื่อต้องการเชื่อมต่อพาร์ทเนอร์รายนั้น ชื่อที่ตรงกันจะไม่เชื่อมต่อให้อัตโนมัติ ต้องกำหนดสิทธิ์บริการแยกต่างหาก',
    partnerSandboxCreate: 'สร้างการเชื่อมต่อทดสอบ',
    partnerUnavailable: 'การเชื่อมต่อนี้ไม่พร้อมใช้งานสำหรับผู้ให้บริการที่เลือก',
    partnerConnectionId: 'รหัสการเชื่อมต่อ',
    partnerEnvironment: 'สภาพแวดล้อมของการเชื่อมต่อ',
    partnerSandbox: 'การเชื่อมต่อทดสอบ',
    partnerKeys: 'ข้อมูลรับรอง API',
    partnerManageKeys: 'จัดการข้อมูลรับรอง',
    partnerServices: 'สิทธิ์เข้าถึงบริการ',
    partnerManageServices: 'จัดการสิทธิ์เข้าถึงบริการ',
    partnerKeysHelp:
      'ข้อมูลรับรองใช้ได้เฉพาะการเชื่อมต่อพาร์ทเนอร์กับผู้ให้บริการนี้ การเพิกถอนจะบล็อกการเรียก API ด้วยข้อมูลรับรองนั้นทันที โดยไม่กระทบข้อมูลรับรองหรือการเชื่อมต่ออื่น',
    partnerGrantHelp:
      'การปิดสิทธิ์บริการจะบล็อกงานใหม่ งานเดิมยังดูข้อมูล รับการอัปเดต และยกเลิกตามเงื่อนไขได้เมื่อข้อมูลรับรองยังใช้งานอยู่ โดยไม่ยกเลิกงานเดิม',
    partnerNoKeys: 'ยังไม่มีการออกข้อมูลรับรอง',
    partnerRevoked: 'เพิกถอนแล้ว',
    partnerRevokeNamed: 'เพิกถอน {{name}}',
    partnerRevokeConfirm: 'ยืนยันการเพิกถอน',
    partnerRevokeWarning: 'เพิกถอน {{name}} ({{prefix}}, รหัส {{id}}) หรือไม่? การเรียก API ด้วยข้อมูลรับรองนี้จะหยุดทันที',
    partnerSecretOnce:
      'คัดลอกคีย์ลับนี้และเก็บไว้อย่างปลอดภัย ระบบจะแสดงเพียงครั้งเดียว และลบออกเมื่อปิดหน้าต่างนี้หรือเปลี่ยนผู้ให้บริการ',
    partnerSecret: 'คีย์ลับที่แสดงครั้งเดียว',
    partnerServiceId: 'รหัสบริการ (Service ID)',
    partnerCopyServiceId: 'คัดลอกรหัสบริการ',
    partnerServiceIdCopyFailed: 'คัดลอกไม่สำเร็จ โปรดเลือกและคัดลอกรหัสบริการด้วยตนเอง',
    partnerCopy: 'คัดลอกคีย์ลับ',
    partnerCopied: 'คัดลอกไปยังคลิปบอร์ดแล้ว',
    partnerCopyFailed: 'คัดลอกไม่สำเร็จ โปรดเลือกและคัดลอกคีย์ลับด้วยตนเอง',
    partnerDismissSecret: 'บันทึกคีย์ลับแล้ว ซ่อนคีย์ลับ',
    partnerKeyName: 'ชื่อข้อมูลรับรอง',
    partnerSearchKeys: 'ค้นหาข้อมูลรับรอง…',
    partnerSearchServices: 'ค้นหาบริการ…',
    partnerKeyPrefix: 'คำนำหน้าคีย์ (Prefix)',
    partnerCreatedAt: 'สร้างเมื่อ',
    partnerIssueKey: 'ออกข้อมูลรับรอง',
    partnerNewKey: 'สร้างกุญแจใหม่',
    partnerCreateKeyHelp: 'ระบุชื่อเพื่อระบุตัวตนของข้อมูลรับรองนี้ รหัสลับจะแสดงเพียงครั้งเดียวหลังจากสร้างเสร็จ',
    partnerSecretOnceTitle: 'รหัสลับสำหรับเชื่อมต่อ API',
    partnerPolicyHelp: 'นโยบายพาร์ทเนอร์มีผลกับงานใหม่ งานเดิมใช้นโยบายที่บันทึกไว้เมื่อสร้างงาน',
    partnerDeferredHelp: 'การชำระภายหลังอนุญาตให้ให้บริการขณะที่ยังค้างชำระ โดยไม่เปลี่ยนยอดค้างเป็นชำระแล้ว',
    partnerDispatchHelp:
      'ค่าเริ่มต้นคือรอผู้ดูแลตรวจสอบ โหมดอัตโนมัติเริ่มเฉพาะการค้นหาครั้งแรกและการลองซ้ำภายในการค้นหานั้น เมื่อค้นหาจนหมดหรือผู้ให้บริการถอนตัวก่อนเริ่มงาน ผู้ดูแลต้องเริ่มการค้นหาใหม่เมื่องานยังเข้าเงื่อนไข',
    partnerNoServices: 'ผู้ให้บริการนี้ยังไม่มีบริการ',
    partnerPaymentPolicy: 'นโยบายการชำระเงินของพาร์ทเนอร์',
    partnerPaymentPolicyShort: 'นโยบายชำระเงิน',
    partnerDispatchPolicy: 'การเริ่มจัดหาผู้ให้บริการของพาร์ทเนอร์',
    partnerDispatchPolicyShort: 'การจัดหารถ',
    partnerServiceHeader: 'สิทธิ์บริการ',
    partnerKeyPrefixShort: 'Prefix',
    partnerPaymentPrepayShort: 'ต้องชำระก่อน',
    partnerPaymentDeferredShort: 'ชำระภายหลัง',
    partnerDispatchAutoShort: 'อัตโนมัติ',
    partnerDispatchReviewShort: 'รอตรวจสอบ',
    partnerCustomPolicyTag: 'กำหนดเอง',
    partnerDefaultPolicyTag: 'ค่าเริ่มต้น',
    partnerPolicyPREPAY_REQUIRED: 'ต้องชำระเงินก่อน',
    partnerPolicyDEFERRED: 'ชำระเงินภายหลัง',
    partnerPolicyADMIN_REVIEW: 'รอผู้ดูแลตรวจสอบ',
    partnerPolicyFULL_AUTO: 'อัตโนมัติ (การค้นหาครั้งแรก)',
    partnerAccessEnabled: 'เปิดสิทธิ์แล้ว',
    partnerAccessDisabled: 'ปิดสิทธิ์อยู่',
    partnerInherit: 'ใช้ค่าเริ่มต้นของบริการ: {{policy}}',
    partnerEffective: 'นโยบายที่มีผล: {{policy}}',
    partnerSaveAccess: 'บันทึกนโยบายสิทธิ์',
    partnerEnableAccess: 'เปิดสิทธิ์บริการ',
    partnerDisableAccess: 'ปิดสิทธิ์บริการ',
    partnerInactiveService: 'เปิดใช้งานบริการในการตั้งค่าบริการก่อนเปิดสิทธิ์',
    partnerDisableWarning: 'ปิดสิทธิ์สร้างงานใหม่สำหรับ {{name}} หรือไม่? งานเดิมจะยังเข้าถึงได้และไม่ถูกยกเลิก',
    partnerConfirmDisable: 'ยืนยันปิดสิทธิ์',
    partnerConfigure: 'ตั้งค่านโยบาย',
    partnerSecretSavedConfirm: 'ฉันได้คัดลอกและจัดเก็บคีย์ลับนี้ไว้อย่างปลอดภัยแล้ว',
    partnerCustomPolicy: 'กำหนดเอง',
    partnerDefaultPolicy: 'ค่าเริ่มต้น',
    partnerEvidenceTitle: 'หลักฐานคำขอของพาร์ทเนอร์',
    partnerEvidenceRetention: 'เก็บข้อมูล {{days}} วัน โดยแต่ละรายการแสดงวันหมดอายุ',
    partnerEvidenceEmpty: 'ไม่มีหลักฐานคำขอสำหรับการเชื่อมต่อนี้',
    partnerEvidenceLoadOlder: 'โหลดคำขอที่เก่ากว่า',
    partnerEvidenceDetails: 'รายละเอียดหลักฐานคำขอ',
    partnerEvidenceView: 'ดูหลักฐาน',
    partnerEvidenceBackToResults: 'กลับไปผลลัพธ์',
    partnerEvidenceReceivedAt: 'เวลาที่ได้รับ (เวลาไทย)',
    partnerEvidenceEndpoint: 'ปลายทาง API',
    partnerEvidenceOutcome: 'ผลลัพธ์',
    partnerEvidenceOutcome_PENDING: 'รอดำเนินการ',
    partnerEvidenceOutcome_INCOMPLETE: 'ไม่สมบูรณ์ — ไม่มีการบันทึกผลลัพธ์',
    partnerEvidenceOutcome_CREATED: 'สร้างงานแล้ว',
    partnerEvidenceOutcome_QUOTED: 'ส่งใบเสนอราคาแล้ว',
    partnerEvidenceOutcome_REPLAYED: 'การลองซ้ำแบบ idempotent',
    partnerEvidenceOutcome_REJECTED: 'ปฏิเสธคำขอ',
    partnerEvidenceRequestId: 'รหัสคำขอที่ตอบกลับ',
    partnerEvidenceEventId: 'รหัสความพยายาม',
    partnerEvidenceProviderId: 'รหัสผู้ให้บริการ',
    partnerEvidenceRelease: 'รุ่น API',
    partnerEvidenceHttpStatus: 'สถานะ HTTP',
    partnerEvidenceErrorCode: 'รหัสข้อผิดพลาด',
    partnerEvidenceCompletedAt: 'เวลาดำเนินการเสร็จ (เวลาไทย)',
    partnerEvidenceExpiresAt: 'หลักฐานหมดอายุ (เวลาไทย)',
    partnerEvidencePresence: 'สถานะการส่งแต่ละฟิลด์',
    partnerEvidenceSubmitted: 'คำขอที่ส่ง',
    partnerEvidenceSubmittedBody: 'JSON ที่แยกวิเคราะห์จากคำขอ (ปกปิดข้อมูลแล้ว)',
    partnerEvidenceSubmittedIsInstant: 'isInstant ที่ส่งมา',
    partnerEvidenceSubmittedStart: 'scheduledStart ที่ส่งมา (เขตเวลาเดิม)',
    partnerEvidenceSubmittedEnd: 'scheduledEnd ที่ส่งมา (เขตเวลาเดิม)',
    partnerEvidenceMissing: 'ไม่ได้ส่ง',
    partnerEvidenceNull: 'null',
    partnerEvidenceInterpretation: 'การตีความของเซิร์ฟเวอร์',
    partnerEvidenceEvaluatedAt: 'เวลาที่ประเมิน (เวลาไทย)',
    partnerEvidenceEffectiveInstant: 'ค่า isInstant ที่ใช้จริง',
    partnerEvidenceTrue: 'true',
    partnerEvidenceFalse: 'false',
    partnerEvidenceEnabled: 'เปิดใช้',
    partnerEvidenceDisabled: 'ปิดใช้',
    partnerEvidenceSource_SUBMITTED: 'ส่งค่ามา',
    partnerEvidenceSource_DEFAULT: 'ไม่ได้ส่ง จึงใช้ค่าเริ่มต้น true',
    partnerEvidenceResolvedStart: 'เวลาเริ่มงานตามเซิร์ฟเวอร์ (UTC)',
    partnerEvidenceResolvedEnd: 'เวลาสิ้นสุดงานตามเซิร์ฟเวอร์ (UTC)',
    partnerEvidenceBookingRules: 'กฎการจองที่ใช้ได้',
    partnerEvidenceInstantRule: 'การจองทันที: {{value}}',
    partnerEvidenceAdvanceRule: 'การจองล่วงหน้า: {{value}}',
    partnerEvidenceAdvanceLimits: 'ข้อจำกัดการจองล่วงหน้า',
    partnerEvidenceAdvanceLimitsValue:
      'ต้องจองล่วงหน้าอย่างน้อย {{lead}} นาที · ไม่เกิน {{horizon}} วัน · สูงสุด {{count}} งาน',
    partnerEvidenceStaffingDeadline: 'กำหนดเวลาจัดหาผู้ให้บริการ (UTC)',
    partnerEvidenceRequestedQuoteId: 'รหัสใบเสนอราคาที่ส่งมา',
    partnerEvidenceEffectiveQuoteId: 'รหัสใบเสนอราคาที่ใช้จริง',
    partnerEvidenceQuoteResolution: 'ผลการจับคู่ใบเสนอราคา',
    partnerEvidenceNone: 'ไม่มี',
    partnerEvidenceUnavailable: 'ไม่มีข้อมูล',
    partnerEvidencePending: 'ยังรอดำเนินการ',
    partnerEvidenceNoInterpretation: 'ไม่มีการบันทึกการตีความของเซิร์ฟเวอร์สำหรับคำขอนี้',
    partnerEvidenceCommitted: 'ผลลัพธ์ที่บันทึกสำเร็จ',
    partnerEvidenceCommitNotRecorded: 'ไม่ได้บันทึกข้อมูลผลลัพธ์งานที่สำเร็จสำหรับคำขอนี้',
    partnerEvidenceJobId: 'รหัสงาน',
    partnerEvidenceBookingId: 'รหัสการจอง',
    partnerEvidenceTripRef: 'เลขอ้างอิงงาน',
    partnerEvidenceFareQuoteId: 'รหัสใบเสนอราคาที่ผูกกับงาน',
    partnerEvidenceCommittedInstant: 'ค่า isInstant ที่บันทึก',
    partnerEvidenceCommittedStart: 'เวลาเริ่มงานที่บันทึก (UTC)',
    partnerEvidenceCommittedEnd: 'เวลาสิ้นสุดงานที่บันทึก (UTC)',
    partnerEvidenceInitialStatus: 'สถานะงานเริ่มต้น',
    partnerEvidenceCreationChannel: 'ช่องทางสร้างงาน',
    partnerEvidenceReplayJobId: 'รหัสงานเดิมของการลองซ้ำ',
    partnerEvidenceQuoteSnapshot: 'ภาพรวมใบเสนอราคา',
    partnerEvidenceQuoteCalculatedAt: 'คำนวณใบเสนอราคาเมื่อ (เวลาไทย)',
    partnerEvidenceQuoteValidUntil: 'ใบเสนอราคาหมดอายุ (เวลาไทย)',
    partnerEvidenceQuoteContractVersion: 'เวอร์ชันสัญญาใบเสนอราคา',
    partnerEvidenceQuotePricingRevision: 'เวอร์ชันราคาใบเสนอราคา',
    partnerEvidenceQuoteInstant: 'isInstant ในใบเสนอราคา',
    partnerEvidenceQuoteStart: 'เวลาเริ่มตามใบเสนอราคา (UTC)',
    partnerEvidenceQuoteEnd: 'เวลาสิ้นสุดตามใบเสนอราคา (UTC)',
    partnerEvidenceQuoteMaterialMatch: 'คำขอสร้างงานตรงกับข้อมูลใบเสนอราคา',
    partnerEvidenceMatchYes: 'ตรงกัน',
    partnerEvidenceMatchNo: 'ไม่ตรงกัน',
    partnerEvidenceMatchUnknown: 'ไม่ทราบ',
    partnerEvidenceCaptureBestEffort:
      'การเก็บหลักฐานเป็นแบบ best-effort หากหลักฐานขาดหาย หมดอายุ หรือเข้าถึงไม่ได้ จะกู้คืนไม่ได้ และรายการว่างไม่ได้ยืนยันว่าไม่มีคำขอ',
    partnerEvidenceResultJobId: 'รหัสงานที่ส่งกลับ',
    partnerEvidenceReplaySnapshotUnavailable:
      'การลองซ้ำนี้ส่งกลับงานเดิม {{jobId}} แต่ไม่มีภาพบันทึกผลการสร้างครั้งแรกในหลักฐานนี้ ข้อมูลคำขอที่ลองซ้ำไม่ใช่คำขอสร้างงานครั้งแรก',
    partnerEvidenceAttempt: 'ความพยายามเรียก API',
    partnerEvidenceFailureStage: 'ขั้นตอนที่ล้มเหลว',
    partnerEvidenceFailureStage_SCHEMA_VALIDATION: 'ตรวจสอบรูปแบบข้อมูล',
    partnerEvidenceFailureStage_SERVICE_ACCESS: 'สิทธิ์เข้าถึงบริการ',
    partnerEvidenceFailureStage_ROUTING: 'คำนวณเส้นทาง',
    partnerEvidenceFailureStage_QUOTE_MATCH: 'จับคู่ใบเสนอราคา',
    partnerEvidenceFailureStage_BOOKING_RULES: 'กฎการจอง',
    partnerEvidenceFailureStage_COMMIT: 'บันทึกฐานข้อมูล',
    partnerEvidenceFailureStage_POST_COMMIT: 'ดำเนินการหลังบันทึก',
    partnerEvidenceFailureStage_UNKNOWN: 'ไม่ทราบขั้นตอน',
    partnerEvidenceRefresh: 'โหลดหลักฐานคำขอใหม่',
    partnerEvidenceComparison: 'ค่าที่ส่ง → การตีความ → ผลลัพธ์ที่บันทึก',
    partnerEvidenceOpenWorkspace: 'เปิดหน้าหลักฐานคำขอ',
    partnerEvidenceBackToConnections: 'กลับไปหน้าการเชื่อมต่อ',
    partnerEvidenceSelectedOutsidePage: 'คำขอที่เลือกอยู่นอกผลลัพธ์ที่โหลดในขณะนี้',
    partnerEvidenceSelectAttempt: 'เลือกคำขอเพื่อเปรียบเทียบค่าที่ส่ง การตีความ และผลลัพธ์ที่บันทึก',
    partnerEvidenceNoMatches: 'ไม่พบหลักฐานที่ยังเก็บอยู่และตรงกับตัวกรองนี้',
    partnerEvidenceRange: 'ช่วงเวลาที่ได้รับคำขอ',
    partnerEvidenceRange_all: 'หลักฐานทั้งหมดที่ยังเก็บอยู่',
    partnerEvidenceRange_today: 'วันนี้ (เวลาไทย)',
    partnerEvidenceRange_24h: '24 ชั่วโมงล่าสุด',
    partnerEvidenceRange_dates: 'ช่วงวันที่ (เวลาไทย)',
    partnerEvidenceRange_times: 'วันและเวลาที่ระบุ (เวลาไทย)',
    partnerEvidenceDateFrom: 'ได้รับตั้งแต่วันที่ (รวมวันนี้)',
    partnerEvidenceDateTo: 'ได้รับถึงวันที่ (รวมวันนี้)',
    partnerEvidenceReceivedFrom: 'ได้รับตั้งแต่ (เวลาไทย รวมเวลานี้)',
    partnerEvidenceReceivedBefore: 'ได้รับก่อน (เวลาไทย ไม่รวมเวลานี้)',
    partnerEvidenceIdType: 'ประเภทรหัส',
    partnerEvidenceIdValue: 'รหัสตรงตัว',
    partnerEvidenceIdPlaceholder: 'รหัสคำขอตรงตัวหรือ UUID — ไม่ใส่ข้อมูลผู้โดยสาร',
    partnerEvidenceFilterAny: 'ทั้งหมด',
    partnerEvidenceId_request: 'รหัสคำขอ',
    partnerEvidenceId_evidence: 'รหัสความพยายาม',
    partnerEvidenceId_job: 'รหัสงาน',
    partnerEvidenceId_quote: 'รหัสใบเสนอราคา',
    partnerEvidenceCopyRequestId: 'คัดลอกรหัสคำขอ',
    partnerEvidenceCopyJobId: 'คัดลอกรหัสงาน',
    partnerEvidenceApplyFilters: 'ใช้ตัวกรอง',
    partnerEvidenceClearFilters: 'ล้างตัวกรอง',
    partnerEvidenceFilterError_invalidId:
      'เลือกประเภทรหัสและกรอกรหัสตรงตัวที่ปลอดภัย รหัสงาน ใบเสนอราคา และหลักฐานต้องเป็น UUID ส่วนรหัสคำขอใช้ตัวอักษรอังกฤษ ตัวเลข จุด ขีดล่าง หรือขีดกลางได้ไม่เกิน 128 ตัว',
    partnerEvidenceFilterError_invalidStatus: 'กรอกสถานะ HTTP เป็นจำนวนเต็มตั้งแต่ 100 ถึง 599',
    partnerEvidenceFilterError_invalidDates: 'กรอกวันที่ให้ถูกต้อง โดยวันเริ่มต้นต้องไม่อยู่หลังวันสิ้นสุด',
    partnerEvidenceFilterError_invalidDateTime: 'กรอกวันและเวลาไทยให้ถูกต้อง โดยเวลาเริ่มต้นต้องอยู่ก่อนเวลาสิ้นสุด',
    partnerEvidenceFilterError_rangeRequired: 'กรอกขอบเขตเวลาที่ได้รับคำขออย่างน้อยหนึ่งด้านสำหรับช่วงที่เลือก',
    partnerEvidenceSubmitted_true: 'true',
    partnerEvidenceSubmitted_false: 'false',
    partnerEvidenceSubmitted_missing: 'ไม่ได้ส่ง',
    partnerEvidenceSubmitted_null: 'null',
    partnerEvidenceSubmitted_invalid: 'ค่าที่ส่งไม่ถูกต้อง',
    partnerEvidenceTimezoneNote:
      'เวลาที่ส่งมาคงเขตเวลาเดิมไว้ ส่วนเวลาจากการตีความของเซิร์ฟเวอร์และผลลัพธ์ที่บันทึกแสดงเป็น UTC',
    partnerEvidenceFindRelated: 'ค้นหาคำขอที่เกี่ยวข้อง',
    partnerEvidenceRelatedAttempts: 'คำขอที่เกี่ยวข้องและยังเก็บอยู่',
    partnerEvidenceRelatedEmpty: 'ไม่พบรายการอื่นที่ตรงกันและยังเก็บอยู่ คำขอเก่า หมดอายุ หรือไม่ได้เก็บหลักฐานอาจไม่ปรากฏ',
    partnerEvidenceRelatedNoIds: 'ไม่มีรหัสงานหรือใบเสนอราคาที่บันทึกไว้สำหรับค้นหาคำขอที่เกี่ยวข้อง',

    routingSettingsTab: 'ตั้งค่า',
    routingChecksTab: 'ประวัติตรวจเส้นทาง',
    routingSwitchesTab: 'ประวัติสลับผู้ให้บริการ',
    routingExplicitSelection: 'เลือกผู้ให้บริการโดยตรง',
    routingUnsaved: 'มีการเปลี่ยนแปลงที่ยังไม่บันทึก',
    routingSaved: 'บันทึกการตั้งค่าแล้ว',
    routingTime: 'วัน–เวลา (เวลาไทย)',
    routingCaller: 'การใช้งาน',
    routingResult: 'ผลลัพธ์',
    routingResponseTime: 'เวลาตอบกลับ',
    routingActor: 'ผู้เปลี่ยน',
    routingBefore: 'ก่อนเปลี่ยน',
    routingAfter: 'หลังเปลี่ยน',
    routingSelection: 'วิธีเลือก',
    routingRecord: 'รหัสรายการ',
    routingViewRecord: 'ดูรายละเอียด {{id}}',
    routingDetails: 'รายละเอียดรายการ',
    routingAll: 'ทั้งหมด',
    routingDateRange: 'ช่วงวันที่ (เวลาไทย)',
    routingClear: 'ล้างตัวกรอง',
    routingRetry: 'ลองอีกครั้ง',
    routingNoMatches: 'ไม่พบรายการที่ตรงกับการค้นหา',
    routingEmpty: 'ยังไม่มีประวัติ',
    routingPage: 'หน้า {{page}} · แสดง {{count}} รายการ (สูงสุด 25 รายการต่อหน้า)',
    routingChecksHelp: 'ประวัติที่ระบบบันทึก เรียงใหม่สุดก่อน · ค้นหาข้อมูลที่เก็บไว้ตามช่วงวันที่ · ไม่ใช่ยอดเรียกเก็บเงินของผู้ให้บริการ',
    routingSwitchesHelp: 'ประวัติการเปลี่ยนผู้ให้บริการผ่านหน้าตั้งค่า เรียงใหม่สุดก่อน · ตัวกรองผู้ให้บริการค้นทั้งก่อนและหลังเปลี่ยน',
    routingSearchChecks: 'รหัสรายการ รหัสคำขอ หรือรหัสข้อผิดพลาด',
    routingSearchSwitches: 'ชื่อผู้เปลี่ยน หรือรหัสรายการ',
    routingProfile: 'รูปแบบการคำนวณ',
    routingDistance: 'ระยะทาง',
    routingEnvironment: 'สภาพแวดล้อม',
    routingError: 'รหัสข้อผิดพลาด',
    routingRequestId: 'รหัสคำขอ',
    routingRevision: 'เวอร์ชันการตั้งค่า',
    routingCopyId: 'คัดลอกรหัสรายการ',
    routingCopied: 'คัดลอกแล้ว',
    routingCopyFailed: 'คัดลอกไม่สำเร็จ กรุณาเลือกรหัสแล้วคัดลอก',
    routingStatusSUCCESS: 'สำเร็จ',
    routingStatusNO_ROUTE: 'ไม่พบเส้นทาง',
    routingStatusERROR: 'ผิดพลาด',
    routingStatusPENDING: 'ยังไม่ทราบผล',
    routingCaller_map_route: 'ตรวจเส้นทาง',
    routingCaller_dispatch: 'จัดสรรพนักงาน',
    routingCaller_simulator: 'จำลองการจัดสรร',
    routingCaller_seed: 'ข้อมูลตัวอย่าง',

    systemSettingsHint: 'ค่าเริ่มต้นของระบบสำหรับทุกผู้ให้บริการ การเปลี่ยนแปลงจะมีผลหลังบันทึก',
    systemSave: 'บันทึกการตั้งค่าระบบ',
    systemSaveScope: 'บันทึกทุกค่าและนโยบายอัปเดตแอปในแท็บนี้',
    systemNoUnsavedChanges: 'ไม่มีการตั้งค่าระบบที่รอบันทึก',
    systemDiscardChanges: 'ยกเลิกการแก้ไข',
    systemBookingTiming: 'ระยะเวลาการจอง',
    systemPartnerApi: 'Partner API',
    systemPartnerApiHint:
      'ใช้ค่าเดียวกับทุก endpoint ของ Partner API แต่ละ connection ระหว่าง Partner กับผู้ให้บริการมีโควตาแยกกัน โดยทุก key ใน connection ใช้ร่วมกัน ค่าที่บันทึกมีผลกับคำขอถัดไปโดยไม่ล้างโควตาที่ใช้แล้ว ข้อจำกัดความปลอดภัยอื่นของ API ยังมีผลตามเดิม',
    systemPartnerApiLimit: 'จำนวนคำขอต่อนาทีต่อ connection',
    systemPartnerApiLimitHint: 'จำนวนเต็ม {{min}}–{{max}} เว้นว่างเพื่อใช้ค่าเริ่มต้น {{default}}',
    systemPartnerApiLimitInvalid: 'กรอกจำนวนเต็ม {{min}}–{{max}} หรือเว้นว่างเพื่อใช้ค่าเริ่มต้น',
    systemMobileFeaturesTab: 'ฟีเจอร์มือถือ',
    systemMobileFeaturesHint: 'Live Activities และการบันทึกขั้นตอนสมัครงานบันทึกแยกกัน ใช้ปุ่มบันทึกในแต่ละส่วน',
    systemAutomationTab: 'งานอัตโนมัติ',
    systemAutomationHint: 'ค่าเริ่มต้นของระบบสำหรับการดำเนินงานอัตโนมัติ ตรวจสอบและบันทึกการเปลี่ยนแปลงในหน้าต่างตั้งค่า',
    systemMobileCopyProject: 'คัดลอกรหัส{{name}}',
    systemMobileTechnicalDetails: 'รายละเอียดการเชื่อมต่อ',
    systemMobileFlow: 'ขั้นตอนที่บันทึก',
    systemMobileProvider: 'ผู้ให้บริการบันทึก',
    systemMobileAgentProject: 'โปรเจกต์แอปพนักงาน',
    systemMobileCustomerProject: 'โปรเจกต์แอปลูกค้า',
    systemMobileRevision: 'เวอร์ชันการตั้งค่า',
    systemMobileNotConfigured: 'ยังไม่ได้ตั้งค่า',
    systemMobileSaved: 'ไม่มีการตั้งค่าการบันทึกที่รอบันทึก',
    systemMobileConflict: 'การตั้งค่าการบันทึกเปลี่ยนไปหลังเปิดหน้านี้ ระบบเก็บค่าที่คุณแก้ไขไว้แล้ว กรุณาโหลดค่าล่าสุดก่อนแก้ไขอีกครั้ง',
    systemMobileReload: 'ยกเลิกการแก้ไขการบันทึกและโหลดค่าล่าสุด',
    systemMobileUpdateEditHint:
      'เมื่อแก้เวอร์ชันหรือลิงก์ดาวน์โหลด ระบบจะปิดการอัปเดตของแอปและระบบนั้นจนกว่าจะตรวจสอบและเปิดอีกครั้ง บันทึกพร้อมการตั้งค่าระบบด้านล่าง',
    systemMobileUpdateOn: 'เปิดการอัปเดต',
    systemMobileUpdateOff: 'ปิดการอัปเดต',

    systemRouting: 'ผู้ให้บริการคำนวณเส้นทาง',
    systemRoutingHint: 'มีผลกับการคำนวณเส้นทางใหม่หลังบันทึก หลักฐานงานเดิมคงเดิม ไม่มีการสลับอัตโนมัติ',
    systemRoutingEnvironment: 'ค่าเริ่มต้นของ environment',
    systemRoutingEffective: 'ผู้ให้บริการที่ใช้อยู่',
    systemRoutingAudit: 'ประวัติการตรวจเส้นทางและสลับผู้ให้บริการล่าสุด 100 รายการ',
    systemTripLiveActivities: 'Live Activity ของทริป',
    systemTripLiveActivitiesHint:
      'เปิดหรือปิดการ์ดสถานะทริปบน iOS และ Android แยกสำหรับ Customer และ Agent การเปลี่ยนแปลงมีผลเฉพาะ environment นี้หลังบันทึก',
    systemTripLiveActivitiesDisableHint:
      'เมื่อปิด ระบบจะหยุดสร้างการ์ดใหม่ หยุดการเตือนที่เกี่ยวข้อง และส่งคำสั่งปิดการ์ดเดิม การส่งถึงโทรศัพท์อาจล่าช้าตามเครือข่าย',
    systemTripLiveActivitiesCustomer: 'Live Activity สำหรับ Customer',
    systemTripLiveActivitiesAgent: 'Live Activity สำหรับ Agent',
    systemTripLiveActivitiesSave: 'บันทึก Live Activity',
    systemTripLiveActivitiesConflict:
      'การตั้งค่านี้เปลี่ยนไปหลังจากที่คุณเปิดหน้านี้ ระบบยังเก็บสิ่งที่คุณแก้ไว้ กรุณาโหลดค่าล่าสุดก่อนแก้ไขอีกครั้ง',
    systemTripLiveActivitiesReload: 'ยกเลิกสิ่งที่แก้และโหลดค่าล่าสุด',
    systemMobileObservability: 'บันทึกขั้นตอนสมัครงาน',
    systemMobileObservabilityHint:
      'บันทึกบางเซสชันของการสมัครงานหลังยืนยันเบอร์โทร เพื่อช่วยตรวจสอบปัญหา หากแอปยืนยันการตั้งค่าไม่ได้จะไม่บันทึก',
    systemMobileReplayEnabled: 'เปิด session replay',
    systemMobileSampleRate: 'สัดส่วนเซสชันสมัครงานที่บันทึก (%)',
    systemMobileMinimumBuild: 'build มือถือขั้นต่ำ',
    systemMobilePlatforms: 'แพลตฟอร์มที่เปิดใช้',
    systemMobileFlavors: 'รูปแบบแอปที่เปิดใช้ (คั่นด้วยจุลภาค)',
    systemMobileMasking: 'รูปแบบการปกปิดข้อมูล',
    systemMobileMaskingDiagnosticSafe: 'Diagnostic safe (ช่องกรอกและรูปยังถูกปกปิด)',
    systemMobileMaskingStrict: 'ปกปิดแบบเข้มงวด',
    systemMobileUpdates: 'การอัปเดตแอปมือถือ',
    systemMobileUpdatesHint:
      'กำหนดเวอร์ชันล่าสุดเพื่อแจ้งเตือนให้อัปเดต และเวอร์ชันขั้นต่ำเพื่อบังคับอัปเดต ใช้เลขเวอร์ชันสามส่วน เช่น 1.4.9 คนขับสามารถทำงานที่กำลังดำเนินการให้เสร็จก่อนบังคับอัปเดต ตรวจสอบว่าดาวน์โหลดได้จริงแยกแต่ละแอปและระบบก่อนเปิดใช้งาน',
    systemMobileUpdateCustomer: 'ลูกค้า',
    systemMobileUpdateAgent: 'คนขับและผู้ดูแล',
    systemMobileUpdateMinimum: 'เวอร์ชันขั้นต่ำที่รองรับ',
    systemMobileUpdateLatest: 'เวอร์ชันล่าสุดที่ดาวน์โหลดได้',
    systemMobileUpdateStoreUrl: 'ลิงก์ดาวน์โหลดจาก Store หรือช่องทางทดสอบ',
    systemMobileUpdateEnabled: 'เปิดใช้งาน — ตรวจสอบแล้วว่าสามารถดาวน์โหลดเวอร์ชันเป้าหมายจากลิงก์นี้ได้ สำหรับแอปและระบบนี้',
    systemMobileSave: 'บันทึกการตั้งค่าขั้นตอนสมัครงาน',

    diagnosticsOlderHistory: 'ประวัติเก่ากว่านี้',
    diagnosticsLatestHistory: 'ประวัติล่าสุด',
    diagnosticsSummary:
      'หลักฐานที่คืนมาในช่วงเวลาและสภาพแวดล้อมนี้: ไม่ตรงกัน {{mismatches}} / {{comparable}} กรณีที่เทียบได้; เทียบไม่ได้ {{other}} กรณี; ไม่มีรหัสเชื่อมโยง {{unlinked}} events',
    diagnosticsTitle: 'ตรวจสอบปัญหา',
    diagnosticsCapture: 'ควบคุมการเก็บข้อมูล',
    diagnosticsInvestigate: 'ค้นหาสาเหตุ',
    diagnosticsState: 'นโยบายการเก็บข้อมูลปัจจุบัน',
    diagnosticsGlobal: 'การเก็บข้อมูลทั้งระบบ',
    diagnosticsBaseline: 'ค่าการเก็บปกติ',
    diagnosticsRevision: 'รุ่นที่บันทึก {{saved}} · รุ่นที่ระบบอ่านแล้ว {{observed}}',
    diagnosticsStale: 'ข้อมูลที่ระบบอ่านค้างอยู่ จึงปิดการเก็บข้อมูล',
    diagnosticsOneInstance: 'ผลนี้ยืนยันเฉพาะเครื่องที่ตอบคำขอ',
    diagnosticsRetentionNotice:
      'ประวัติคำสั่งใหม่เก็บ {{days}} วัน การเปลี่ยนค่ามีผลกับรายการในอนาคต ไม่รวม audit ธุรกิจและข้อมูลใน Better Stack',
    diagnosticsReason: 'เหตุผล',
    diagnosticsTurnOff: 'ปิดการเก็บข้อมูลทั้งระบบ',
    diagnosticsTurnOn: 'เปิดให้เก็บข้อมูล',
    diagnosticsRetentionDays: 'อายุประวัติคำสั่ง (1–3650 วัน)',
    diagnosticsSaveRetention: 'ใช้ค่านี้กับรายการใหม่',
    diagnosticsUnresolved: 'ยังไม่ทราบผลคำสั่ง ตรวจสอบใบรับคำสั่งก่อนสั่งใหม่',
    diagnosticsResolve: 'ตรวจสอบผลคำสั่ง',
    diagnosticsNewCommand: 'อ่านสถานะล่าสุดเพื่อเริ่มคำสั่งใหม่',
    diagnosticsTemporary: 'เก็บข้อมูลชั่วคราว',
    diagnosticsScope: 'ขอบเขต',
    diagnosticsTargetId: 'รหัสเป้าหมาย',
    diagnosticsProviderId: 'รหัสผู้ให้บริการ',
    diagnosticsMinutes: 'ระยะเวลา (1–60 นาที)',
    diagnosticsStart: 'เริ่มเก็บชั่วคราว',
    diagnosticsStop: 'หยุด',
    diagnosticsTarget: 'เป้าหมาย',
    diagnosticsGlobalGate: 'การเก็บข้อมูลระดับระบบ',
    diagnosticsCaptureAdded: 'เพิ่มการเก็บข้อมูล',
    diagnosticsCaptureRemoved: 'ยกเลิกการเก็บข้อมูล',
    diagnosticsAuditRetention: 'ประวัติรายการนี้เก็บ {{days}} วัน ตามนโยบายก่อนเปลี่ยนค่า',
    diagnosticsPreProviderNotice:
      'การเก็บเฉพาะผู้ให้บริการเริ่มเมื่อข้อมูลผูกกับผู้ให้บริการแล้ว หากต้องการเส้นทางที่ผู้โดยสารค้นหาก่อนเลือกผู้ให้บริการ ให้ Agent P หรือผู้ดูแลระบบเปิดเก็บทั้ง environment หรือ journey ที่ระบุก่อนทดสอบ ข้อมูลเส้นทางที่ไม่ได้เก็บไว้จะเรียกย้อนหลังไม่ได้',
    diagnosticsEnabled: 'เปิด',
    diagnosticsDisabled: 'ปิด',
    diagnosticsMetadata: 'ข้อมูลเหตุการณ์',
    diagnosticsEnableBaseline: 'เปิดการเก็บข้อมูลตามปกติ',
    diagnosticsDisableBaseline: 'ปิดการเก็บข้อมูลตามปกติ',
    diagnosticsHistoryHelp: 'ค้นหาประวัติที่ยังเก็บอยู่ด้วยชื่อผู้ดำเนินการ รหัสเป้าหมาย หรือรหัสบันทึก ตามสิทธิ์ที่คุณเข้าถึงได้',
    diagnosticsHistorySearch: 'ค้นหาประวัติ',
    diagnosticsHistorySearchHint: 'ชื่อผู้ดำเนินการ รหัสเป้าหมาย หรือรหัสบันทึก',
    diagnosticsHistoryAction: 'การเปลี่ยนแปลง',
    diagnosticsAllActions: 'ทุกการเปลี่ยนแปลง',
    diagnosticsClearFilters: 'ล้างตัวกรอง',
    diagnosticsHistoryNoMatches: 'ไม่พบประวัติที่ตรงกับตัวกรอง',
    diagnosticsHistoryEmpty: 'ยังไม่มีประวัติการควบคุมที่เก็บอยู่',
    diagnosticsHistoryTime: 'วันและเวลา',
    diagnosticsHistoryActor: 'ผู้ดำเนินการ',
    diagnosticsDetails: 'รายละเอียด',
    diagnosticsViewDetails: 'ดูรายละเอียด',
    diagnosticsHistoryPage: 'หน้า {{page}} · {{count}} รายการ',
    diagnosticsPreviousPage: 'หน้าก่อนหน้า',
    diagnosticsNextPage: 'หน้าถัดไป',
    diagnosticsChanges: 'สิ่งที่เปลี่ยนแปลง',
    diagnosticsSetting: 'การตั้งค่า',
    diagnosticsBefore: 'ก่อนเปลี่ยน',
    diagnosticsAfter: 'หลังเปลี่ยน',
    diagnosticsPolicyRevision: 'รุ่นการตั้งค่า',
    diagnosticsAuditId: 'รหัสบันทึก',
    diagnosticsResult: 'ผลการตรวจสอบ',
    diagnosticsNoEvidence: 'ไม่พบหลักฐานจากการค้นหานี้',
    diagnosticsEvent: 'เหตุการณ์',
    diagnosticsEventId: 'รหัสเหตุการณ์',
    diagnosticsHistory: 'ประวัติการควบคุม',
    diagnosticsExpires: 'หมดอายุ',
    diagnosticsCleanup: 'รายการรอล้าง {{due}} · สำเร็จล่าสุด {{last}} · ล้มเหลว {{failures}} ครั้ง',
    diagnosticsEvidenceNotice:
      'ค้นย้อนหลังได้สูงสุด 14 วัน หากข้อมูลขาดหรือได้ไม่ครบ จะยังยืนยันราคาไม่ได้ ข้อมูลจาก client เป็นเพียงหลักฐานประกอบ',
    diagnosticsJourneyId: 'รหัสการตรวจสอบ (ไม่บังคับ)',
    diagnosticsHours: 'ย้อนหลัง (ชั่วโมง สูงสุด 336)',
    diagnosticsAmounts: 'ราคาเสนอ {{quote}} บาท · ราคาจอง {{booking}} บาท',
    diagnosticsEvidence: 'รายละเอียดหลักฐาน',
    diagnosticsPartial: 'ยังมีหลักฐานเพิ่มเติม โปรดจำกัดช่วงเวลาหรือรหัสการตรวจสอบก่อนสรุปผล',
    diagnosticsReason_INCIDENT: 'ตรวจสอบเหตุการณ์',
    diagnosticsReason_VERIFICATION: 'ทดสอบระบบ',
    diagnosticsReason_ROUTINE: 'งานประจำ',
    diagnosticsReason_COST_CONTROL: 'ควบคุมค่าใช้จ่าย',
    diagnosticsScope_PROVIDER: 'ผู้ให้บริการ',
    diagnosticsScope_TRIP: 'ทริป',
    diagnosticsScope_JOURNEY: 'เส้นทางการตรวจสอบ',
    diagnosticsScope_ENVIRONMENT: 'ทั้งสภาพแวดล้อม',
    diagnosticsResult_MATCH: 'ตรงกัน',
    diagnosticsResult_MISMATCH: 'ไม่ตรงกัน',
    diagnosticsResult_INSUFFICIENT_EVIDENCE: 'หลักฐานไม่เพียงพอ',
    diagnosticsResult_NOT_APPLICABLE: 'ไม่อยู่ในเงื่อนไขเปรียบเทียบ',
    diagnosticsAction_DIAGNOSTICS_GLOBAL_CHANGED: 'เปลี่ยนการเก็บทั้งระบบ',
    diagnosticsAction_DIAGNOSTICS_BASELINE_CHANGED: 'เปลี่ยนการเก็บปกติ',
    diagnosticsAction_DIAGNOSTICS_CAPTURE_STARTED: 'เริ่มเก็บชั่วคราว',
    diagnosticsAction_DIAGNOSTICS_CAPTURE_STOPPED: 'หยุดเก็บชั่วคราว',
    diagnosticsAction_DIAGNOSTICS_RETENTION_CHANGED: 'เปลี่ยนอายุประวัติ',

    title: 'การตั้งค่า',
    menu: 'เมนู',
    navGroupOrganization: 'องค์กร',
    navGroupService: 'การให้บริการ',
    navGroupPolicy: 'นโยบาย',
    navGroupReasons: 'เหตุผลและคะแนน',
    navGroupDeletedAccounts: 'บัญชีที่ถูกลบ',
    permissions: 'สิทธิ์การเข้าถึง',
    targetProvider: 'Provider ปลายทาง',
    capability: 'รายการสิทธิ์',
    org: 'ข้อมูลองค์กร',
    serviceBookingChannels: 'ช่องทางที่เปิดให้จอง',
    serviceNoBookingChannels: 'ปิดทุกช่องทาง',
    serviceChannelWeb: 'Web (ผู้ดูแล/Operator)',
    serviceChannelMobile: 'แอปลูกค้า (Mobile)',
    serviceChannelPartner: 'Partner API',
    servicePartners: 'พาร์ทเนอร์ที่เปิดให้ใช้บริการ',
    servicePartnerSettings: 'การรับงานจากพาร์ทเนอร์',
    servicePartnerNewJobsHelp: 'ใช้กับงานใหม่ งานเดิมใช้นโยบายเดิม',
    servicePartnerDefaults: 'ค่าเริ่มต้นสำหรับพาร์ทเนอร์',
    servicePartnerDefaultsHelp: 'ใช้เมื่อไม่ได้กำหนดค่าเฉพาะรายพาร์ทเนอร์',
    servicePartnerDisabledHelp: 'ปิดรับงานใหม่จาก Partner API การเลือกพาร์ทเนอร์และนโยบายเดิมยังคงเก็บไว้',
    servicePartnerNoneSelected: 'ยังไม่ได้เลือกพาร์ทเนอร์ จึงยังไม่มีพาร์ทเนอร์สร้างงานใหม่ได้',
    servicePartnerNoConnections: 'ยังไม่มีการเชื่อมต่อพาร์ทเนอร์',
    servicePartnerCustomize: 'ตั้งค่าเฉพาะ',
    servicePartnerCustomizeFor: 'ตั้งค่าเฉพาะสำหรับ {{name}}',
    servicePartnerInherited: 'ใช้ค่าเริ่มต้น',
    servicePartnerOverride: 'กำหนดเฉพาะ',
    servicePartnerDeferredHelp: 'เริ่มบริการได้ก่อนชำระ ยอดค้างชำระยังคงอยู่',
    servicePartnerAutoHelp: 'เริ่มค้นหาครั้งแรกอัตโนมัติ หากค้นหาหมดหรือผู้ให้บริการถอนตัวก่อนเริ่มงาน ผู้ดูแลต้องเริ่มค้นหาใหม่',
    partnerServicesMoved: 'กำหนดช่องทางและพาร์ทเนอร์ที่ใช้บริการได้ในหน้าบริการ',
    serviceGroups: 'กลุ่มการให้บริการ',
    vehicles: 'ยานพาหนะ',
    orgUsers: 'ผู้ใช้ในองค์กร',
    passengerGroups: 'กลุ่มผู้โดยสาร',
    serviceAreas: 'พื้นที่ให้บริการ',
    dispatchPolicy: 'นโยบายการกระจายงาน',
    driverDocumentPolicy: 'ข้อกำหนดเอกสาร Agent',
    driverDocumentPolicyHelp: 'นโยบายเวอร์ชันใหม่มีผลเฉพาะใบสมัครที่ส่งหลังเปิดใช้ โดยไม่เปลี่ยน snapshot ของใบสมัครเดิม',
    driverDocumentPolicyVersion: 'เวอร์ชันที่ใช้งาน {{version}}',
    driverDocumentPolicyConfirm: 'ยืนยันเปิดใช้ข้อกำหนดเอกสารนี้หรือไม่ ใบสมัครเดิมจะยังใช้เวอร์ชันตอนส่งสมัคร',
    driverDocumentPolicyHistory: 'ประวัติข้อกำหนด',
    driverDocumentPolicyActivatedBy: 'เปิดใช้โดย {{actor}} · {{date}}',
    driverApplicationPolicy: 'ข้อกำหนดข้อมูลรถของผู้สมัคร Agent',
    driverApplicationPolicyHelp: 'กำหนดข้อมูลรถที่ผู้สมัครทักษะขับรถต้องกรอก เวอร์ชันใหม่ไม่เปลี่ยนใบสมัครเดิม',
    driverApplicationPolicyVersion: 'เวอร์ชันที่ใช้งาน {{version}}',
    driverApplicationPolicyConfirm: 'เปิดใช้ข้อกำหนดข้อมูลรถนี้หรือไม่ ใบสมัครเดิมจะใช้เวอร์ชันตอนส่ง',
    driverApplicationPolicyHistory: 'ประวัติข้อกำหนด',
    driverApplicationPolicyHistoryRow: 'เวอร์ชัน {{version}} · {{actor}} · {{date}}',
    vehicleField_make: 'ยี่ห้อ',
    vehicleField_model: 'รุ่น',
    vehicleField_color: 'สี',
    vehicleField_registrationYear: 'ปีจดทะเบียน',
    vehicleFieldRequirement_REQUIRED: 'จำเป็น',
    vehicleFieldRequirement_OPTIONAL: 'ไม่บังคับ',
    driverDocumentType_DRIVER_LICENSE: 'ใบอนุญาตขับขี่รถยนต์',
    driverDocumentType_PUBLIC_DRIVER_LICENSE: 'ใบอนุญาตขับรถสาธารณะ',
    driverDocumentType_COMPULSORY_MOTOR_INSURANCE: 'พ.ร.บ. รถยนต์',
    driverDocumentType_VOLUNTARY_MOTOR_INSURANCE: 'ประกันภัยรถยนต์ภาคสมัครใจ',
    driverDocumentType_VEHICLE_PHOTO: 'รูปยานพาหนะ',
    driverDocumentRequirement_REQUIRED: 'จำเป็น',
    driverDocumentRequirement_OPTIONAL: 'ไม่จำเป็น',
    driverDocumentRequirement_DISABLED: 'ไม่ใช้งาน',
    equipment: 'อุปกรณ์ในการให้บริการ',
    reasons: 'การระบุเหตุผล',
    ratingReasons: 'การให้คะแนนความพึงพอใจ',

    // org
    orgName: 'ชื่อองค์กร',
    orgContactDetails: 'ข้อมูลติดต่อและที่อยู่',
    orgAvailabilitySettings: 'ความพร้อมรับงานและตำแหน่ง',
    orgCode: 'รหัสองค์กร',
    branch: 'สำนักงาน/สาขา',
    hq: 'สำนักงานใหญ่',
    branchOffice: 'สาขา',
    orgType: 'ประเภทองค์กร',
    address: 'ที่อยู่',
    country: 'ประเทศ',
    province: 'จังหวัด',
    district: 'เขต/อำเภอ',
    subDistrict: 'แขวง/ตำบล',
    postcode: 'รหัสไปรษณีย์',
    phone: 'หมายเลขโทรศัพท์',
    email: 'อีเมล',
    website: 'เวปไซต์',
    workingHours: 'เวลาทำการ',
    bankAccount: 'บัญชีรับชำระเงิน',
    bankName: 'ธนาคาร',
    bankAccountName: 'ชื่อบัญชี',
    bankAccountNo: 'เลขที่บัญชี',
    availabilityBufferBeforeMin: 'เวลาเว้นก่อนงาน',
    availabilityBufferAfterMin: 'เวลาเว้นหลังงาน',
    availabilityBufferValue: '{{count}} นาที',
    availabilityBufferHint: 'ขยายช่วงเวลาของงานที่ยังไม่สิ้นสุดด้วยเวลาเว้นก่อนและหลังงาน โดยกำหนดแต่ละค่าได้ 0–1440 นาที',
    driverLocationStaleAfter: 'เวลาตัดพนักงานเมื่อไม่ได้รับตำแหน่ง (วินาที)',
    driverLocationStaleAfterValue: '{{count}} นาที',
    driverLocationStaleAfterEffectiveValue: 'เวลาที่ระบบใช้จริง: {{count}} นาที',
    driverLocationStaleAfterHint: 'ถือว่าพนักงานไม่พร้อมรับงานใหม่ เมื่อไม่ได้รับตำแหน่งเกินเวลานี้ (120–3600 วินาที)',
    agentSelfRegistration: 'การสมัครผ่านแอปพนักงาน',
    agentSelfRegistrationEnabled: 'เปิดรับสมัครพนักงาน',
    agentSelfRegistrationDisabled: 'ปิดรับสมัครพนักงาน',
    agentSelfRegistrationHint: 'เมื่อปิด องค์กรนี้จะไม่แสดงในหน้าสมัคร Agent และ API จะปฏิเสธคำขอสมัครโดยตรง',
    agentOfferFare: 'ค่าบริการของงาน',
    agentOfferFareShown: 'แสดงในข้อเสนองานเข้าของ Agent',
    agentOfferFareHidden: 'ซ่อนในข้อเสนองานเข้าของ Agent',
    agentOfferFareHint:
      'แสดงค่าบริการของงานในข้อเสนองานเข้าของ Agent ไม่ใช่รายได้หรือค่าตอบแทนของ Agent ค่าบริการอาจเปลี่ยนตามการให้บริการจริง การเปลี่ยนการตั้งค่ามีผลเมื่อดึงข้อเสนองานครั้งถัดไป ข้อเสนอที่แสดงอยู่แล้วอาจยังไม่อัปเดต',
    promptPay: 'พร้อมเพย์',
    promptPayEdit: 'แก้ไขพร้อมเพย์',
    promptPayStatus: 'สถานะพร้อมเพย์',
    promptPayEnabled: 'เปิดใช้พร้อมเพย์',
    promptPayDisabled: 'ปิดใช้พร้อมเพย์',
    promptPayAmountMode: 'ยอดเงินใน QR',
    promptPayIncludeAmount: 'ระบุยอดเงินใน QR',
    promptPayExcludeAmount: 'ไม่ระบุยอดเงินใน QR',
    promptPayAmountModeHint: 'เมื่อไม่ระบุยอด ผู้ชำระต้องกรอกยอดเงินเองใน Mobile Banking',
    promptPayProxyType: 'ประเภทปลายทาง',
    promptPayProxyPHONE: 'หมายเลขโทรศัพท์',
    promptPayProxyTAX_ID: 'เลขประจำตัวผู้เสียภาษี',
    promptPayProxyValue: 'หมายเลขพร้อมเพย์',
    promptPayDisplayName: 'ชื่อผู้รับ',
    promptPayUpdatedAt: 'แก้ไขล่าสุด',
    promptPayInvalidValue: 'หมายเลขพร้อมเพย์ไม่ถูกต้อง',
    promptPayPreview: 'ตัวอย่าง: {{type}} {{value}}',
    promptPayRecipientWarning: 'CabGo ไม่ได้ตรวจสอบชื่อผู้รับกับธนาคาร',
    promptPayConfirmTitle: 'ยืนยันการเปลี่ยนพร้อมเพย์',
    promptPayConfirmBody: 'การเปลี่ยนแปลงนี้จะมีผลกับ QR ใหม่ทันที ต้องการดำเนินการต่อหรือไม่',
    systemSettings: 'การตั้งค่าระบบ',
    // หัวข้อหมวดหมู่ของ capability matrix (การตั้งค่า → สิทธิ์การเข้าถึง)
    permGroupDriverDocuments: 'เอกสารพนักงาน',
    permGroupPassengerRelations: 'ความสัมพันธ์กับผู้ใช้บริการ',
    permGroupServiceGroups: 'กลุ่มบริการ',
    permGroupDispatchPolicy: 'นโยบายจัดสรรงาน',
    permGroupAccessControl: 'การควบคุมการเข้าถึง',
    agentLoginCodes: 'รหัสเข้าใช้แอปพนักงาน',
    loginCodesCapability: 'จัดการรหัสเข้าใช้แอปพนักงาน (ADMIN เท่านั้น)',
    loginCodesIntro: 'ออกรหัสชั่วคราวให้พนักงานที่ไม่ได้รับ SMS โดยใช้รหัสนี้ในหน้ากรอก OTP ของแอปพนักงานได้จนกว่าจะหมดอายุ',
    loginCodesIdentity: 'ผู้ดูแลต้องตรวจสอบตัวตนของผู้ขอรหัสก่อนส่งมอบ และระบุเหตุผลทุกครั้งที่ออกรหัส',
    loginCodesForbidden: 'ฟีเจอร์นี้ใช้ได้เฉพาะ ADMIN ที่ได้รับสิทธิ์จัดการรหัสเข้าใช้แอปพนักงาน',
    loginCodesDisabled: 'Provider นี้ยังไม่ได้เปิดใช้การออกรหัสเข้าใช้แอปพนักงาน ติดต่อผู้ดูแลระบบเพื่อเปิดสิทธิ์ในหน้าสิทธิ์การเข้าถึง',
    loginCodesKeyMissing: 'ระบบยังไม่พร้อมสำหรับการออกรหัสหรือแสดงรหัส กรุณาติดต่อผู้ดูแลระบบ',
    loginCodesSelectProvider: 'เลือก Provider เพื่อดูและจัดการรหัส',
    loginCodesNew: 'ออกรหัสใหม่',
    loginCodesPhone: 'หมายเลขโทรศัพท์พนักงาน',
    loginCodesPhoneHint: 'ใช้หมายเลขที่พนักงานจะกรอกในแอป เช่น 0812345678 หรือ +66812345678',
    loginCodesPhoneInvalid: 'กรอกหมายเลขโทรศัพท์ที่ถูกต้อง เช่น 0812345678 หรือ +66812345678',
    loginCodesReason: 'เหตุผลในการออกรหัส',
    loginCodesReasonRequired: 'กรุณาระบุเหตุผล',
    loginCodesValidity: 'อายุรหัส (นาที)',
    loginCodesValidityHint: 'ค่าเริ่มต้น 60 นาที กำหนดได้ 1–1,440 นาที นับจากเวลาออกรหัส',
    loginCodesValidityInvalid: 'กรอกจำนวนนาทีเต็มตั้งแต่ 1 ถึง 1,440',
    loginCodesGenerate: 'ออกรหัส',
    loginCodesGenerating: 'กำลังออกรหัส…',
    loginCodesIssued: 'ออกรหัสเรียบร้อยแล้ว กดแสดงรหัสเพื่อดูและส่งมอบให้พนักงาน',
    loginCodesHistory: 'รหัสปัจจุบันและประวัติ',
    loginCodesHistoryHint: 'รายการนี้แสดงข้อมูลการออกรหัสเท่านั้น กดแสดงรหัสเฉพาะรายการที่ต้องการใช้งาน',
    loginCodesEmpty: 'ยังไม่มีประวัติการออกรหัสสำหรับ Provider นี้',
    loginCodesLoadFailed: 'โหลดรายการรหัสไม่สำเร็จ กรุณาลองใหม่',
    loginCodesActionFailed: 'ดำเนินการไม่สำเร็จ กรุณาลองใหม่',
    loginCodesAccessLost: 'สิทธิ์หรือสถานะของรหัสเปลี่ยนไป กรุณาโหลดรายการใหม่',
    loginCodesRefresh: 'โหลดรายการใหม่',
    loginCodesMore: 'โหลดประวัติเพิ่ม',
    loginCodesIssuer: 'ออกโดย',
    loginCodesIssuedAt: 'ออกรหัสเมื่อ',
    loginCodesExpiresAt: 'หมดอายุเมื่อ',
    loginCodesRevokedAt: 'ยกเลิกเมื่อ',
    loginCodesStatus: 'สถานะรหัส',
    loginCodesStatus_ACTIVE: 'ใช้ได้',
    loginCodesStatus_EXPIRED: 'หมดอายุ',
    loginCodesStatus_REVOKED: 'ยกเลิกแล้ว',
    loginCodesActions: 'จัดการรหัส',
    loginCodesReveal: 'แสดงรหัส',
    loginCodesRevealing: 'กำลังแสดงรหัส…',
    loginCodesRevealFor: 'แสดงรหัสสำหรับ {{phone}}',
    loginCodesCopy: 'คัดลอกรหัส',
    loginCodesCopyPhone: 'คัดลอกหมายเลขโทรศัพท์ {{phone}}',
    loginCodesCopyFailed: 'คัดลอกรหัสเข้าใช้ไม่สำเร็จ กรุณาเลือกรหัสและคัดลอกด้วยตนเอง',
    loginCodesPhoneCopyFailed: 'คัดลอกหมายเลขโทรศัพท์ไม่สำเร็จ กรุณาเลือกหมายเลขและคัดลอกด้วยตนเอง',
    loginCodesHide: 'ซ่อนรหัส',
    loginCodesSecretTitle: 'รหัสเข้าใช้สำหรับ {{phone}}',
    loginCodesReusable: 'ใช้รหัสนี้ซ้ำได้จนกว่าจะหมดอายุหรือถูกยกเลิก เซสชันที่เข้าสู่ระบบแล้วจะใช้งานต่อได้ตามปกติ',
    loginCodesRevoke: 'ยกเลิกรหัส',
    loginCodesRevokeFor: 'ยกเลิกรหัสสำหรับ {{phone}}',
    loginCodesRevokeTitle: 'ยืนยันยกเลิกรหัส',
    loginCodesRevokeBody: 'รหัสสำหรับ {{phone}} จะใช้ไม่ได้ทันที พนักงานที่เข้าสู่ระบบแล้วจะยังใช้งานต่อได้',
    loginCodesRevoked: 'ยกเลิกรหัสเรียบร้อยแล้ว',
    loginCodesRegenerateTitle: 'ออกรหัสใหม่แทนรหัสเดิม?',
    loginCodesRegenerateBody: 'หมายเลข {{phone}} มีรหัสที่ใช้ได้อยู่แล้ว การออกรหัสใหม่จะยกเลิกรหัสเดิมทันที',
    loginCodesRegenerate: 'ออกรหัสใหม่แทน',
    permGroupOther: 'สิทธิ์อื่น ๆ',
    systemLegal: 'เอกสารทางกฎหมาย',
    systemLegalHint: 'ลิงก์ที่เปิดจากหน้าเงื่อนไขและนโยบายความเป็นส่วนตัวบนเว็บและแอปมือถือ เว้นว่างเพื่อแสดงหน้าชั่วคราวของระบบ',
    systemTermsUrl: 'URL เงื่อนไขการให้บริการ',
    systemPrivacyUrl: 'URL นโยบายความเป็นส่วนตัว',
    systemSupport: 'การช่วยเหลือ',
    systemSupportHint: 'อีเมลปลายทางของปุ่ม "รายงานปัญหา" ในแอปมือถือ',
    systemSupportEmail: 'อีเมลฝ่ายสนับสนุน',
    // ความถี่ตำแหน่งของพนักงาน (issue #233) — seconds, blank = API default.
    systemAgentLocation: 'ตำแหน่งของพนักงาน',
    systemAgentLocationHint:
      'ความถี่การส่งตำแหน่งของแอปพนักงาน — ค่าว่าง = ค่าเริ่มต้นของระบบ (ออนไลน์รอรับงาน 60 วินาที / ระหว่างให้บริการ 15 วินาที)',
    systemAgentLocationIdle: 'ขณะออนไลน์รอรับงาน (วินาที)',
    systemAgentLocationTrip: 'ระหว่างให้บริการ (วินาที)',
    systemOperatorStaffing: 'การจัดพนักงานสำหรับงานล่วงหน้าจากเจ้าหน้าที่',
    systemOperatorStaffingHint: 'กำหนดว่างานล่วงหน้าที่เจ้าหน้าที่สร้างต้องมีพนักงานก่อนเวลารับกี่นาที (0–1,440 นาที)',
    systemOperatorStaffingLeadMinutes: 'เวลานำสำหรับจัดพนักงาน (นาที)',
    systemQuoteGuarantee: 'การรับประกันราคาประเมิน',
    systemQuoteGuaranteeHint: 'ระยะเวลาที่เส้นทางและราคาจากระบบยังรับประกันสำหรับทุกผู้ให้บริการ (1–60 นาที)',
    systemQuoteGuaranteeMinutes: 'เวลารับประกันราคา (นาที)',
    systemCustomerServiceModeOrder: 'ลำดับประเภทบริการสำหรับลูกค้า',
    systemCustomerServiceModeOrderHint:
      'กำหนดลำดับการแสดงประเภทบริการในขั้นตอนการจองใหม่ของแอปลูกค้า โดยไม่เปลี่ยนเงื่อนไขการให้บริการ',
    systemServiceModeRIDE_AND_CARE: 'รับส่งและดูแล',
    systemServiceModeCARE: 'ดูแล',
    systemServiceModeRIDE: 'รับส่ง',
    systemServiceModeTRAVEL: 'เดินทาง',
    systemServiceModeMoveUp: 'เลื่อน {{mode}} ขึ้น',
    systemServiceModeMoveDown: 'เลื่อน {{mode}} ลง',
    systemServiceModeResetDefault: 'คืนค่าเป็นลำดับเริ่มต้น',
    // คำขอลบบัญชี — SUPER_ADMIN queue behind the public deletion-request form.
    deletionRequests: 'คำขอลบบัญชี',
    deletionRequestsTotal: 'คำขอทั้งหมด',
    deletionRequestedAt: 'วันที่ขอ',
    deletionActor: 'ประเภทบัญชี',
    deletionActorPassenger: 'ผู้ใช้บริการ',
    deletionActorAgent: 'พนักงาน',
    deletionAccount: 'บัญชีที่ตรงกัน',
    deletionNoAccount: 'ไม่พบบัญชี',
    deletionNote: 'เหตุผลจากผู้ขอ',
    deletionStatusPending: 'รอดำเนินการ',
    deletionStatusCompleted: 'ลบแล้ว',
    deletionStatusRejected: 'ปฏิเสธ',
    deletionComplete: 'ลบบัญชี',
    deletionCompleteConfirmBody:
      'ข้อมูลส่วนตัวของบัญชีนี้จะถูกลบถาวรและบัญชีจะไม่สามารถเข้าสู่ระบบได้อีก ต้องการดำเนินการต่อหรือไม่',
    deletionReject: 'ปฏิเสธคำขอ',
    deletionResolutionNote: 'หมายเหตุการดำเนินการ',
    deletionRejectNotePlaceholder: 'ระบุเหตุผลที่ปฏิเสธ',
    deletionProcessedBy: 'ดำเนินการโดย',
    deletionRequestDetail: 'รายละเอียดคำขอ',
    deletedAgents: 'บัญชีพนักงานที่ถูกลบ',
    deletedAgentsTotal: 'บัญชีในคลัง',
    deletedAgentSearchPlaceholder: 'ค้นหาด้วยรหัสภายในหรือผู้ให้บริการ',
    deletedAgentDetail: 'คลังบัญชีพนักงานที่ถูกลบ',
    internalAgentId: 'รหัสพนักงานภายใน',
    deletedAt: 'วันที่ลบ',
    formerSkills: 'ทักษะเดิม',
    retainedTrips: 'ประวัติการเดินทาง',
    completedTrips: 'การเดินทางที่สำเร็จ',
    retainedPayments: 'รายการชำระเงิน',
    retainedRatings: 'คะแนนรีวิว',
    retainedHistory: 'ประวัติที่เก็บรักษา',
    tripReference: 'เลขที่การเดินทาง',
    paymentSummary: '{{count}} รายการชำระเงิน',
    ratingSummary: '{{stars}} ดาว',
    deletedPassengers: 'ผู้โดยสารที่ถูกลบ',
    deletedPassengersTotal: 'บัญชีในคลัง',
    deletedPassengerSearchPlaceholder: 'ค้นหาด้วยรหัสผู้ใช้',
    deletedPassengerDetail: 'คลังผู้โดยสารที่ถูกลบ',
    internalPassengerId: 'รหัสผู้ใช้',
    uploadLogo: 'อัปโหลดโลโก้',
    removeLogo: 'ลบโลโก้',
    serviceHealth: 'สถานะระบบ',
    svcDatabase: 'ฐานข้อมูล',
    svcCache: 'แคช (Redis)',
    svcStorage: 'ที่เก็บไฟล์',
    healthOk: 'ปกติ',
    healthDown: 'ขัดข้อง',
    healthDisabled: 'ปิดใช้งาน',

    // service group
    fullName: 'ชื่อเต็ม',
    shortName: 'ชื่อย่อ',
    category: 'ประเภท',
    welfare: 'สวัสดิการ',
    commercial: 'เพื่อธุรกิจ',
    serviceConditions: 'เงื่อนไขการให้บริการ',
    providerSkills: 'ทักษะของผู้ให้บริการ',
    skillDrive: 'ขับรถ',
    skillCare: 'ดูแล',
    eligibleGroups: 'กลุ่มผู้โดยสารที่ให้บริการ',
    bookingStyle: 'รูปแบบการเรียกบริการ',
    instant: 'ทันที',
    advance: 'ล่วงหน้า',
    usageLimits: 'จำนวนครั้งการรับบริการ',
    perWeek: 'ต่อสัปดาห์',
    perMonth: 'ต่อเดือน',
    unlimited: 'ไม่จำกัด',
    upToNTimes: 'ไม่เกิน {{n}} ครั้ง',
    advanceMinLead: 'จองล่วงหน้าอย่างน้อย',
    advanceMaxHorizon: 'จองล่วงหน้าได้สูงสุด',
    advanceMaxCount: 'จองล่วงหน้าได้ไม่เกิน',
    minutes: 'นาที',
    days: 'วัน',
    times: 'ครั้ง',
    hours: 'ชม.',
    allowRouteShare: 'อนุญาตให้แบ่งปันเส้นทาง',
    bookingStyleShort: 'การเรียกบริการ',
    // service-group mode selector (รูปแบบการให้บริการ)
    serviceGroupMode: 'รูปแบบการให้บริการ',
    sgModeRideAndCare: 'รับส่งและดูแล',
    sgModeCare: 'ดูแล',
    sgModeRide: 'รับส่ง',
    sgModeTravel: 'เดินทาง',

    // pricing designer (ค่าบริการ) — FR-W-SET-PRICE-010
    pricing: 'ค่าบริการ',
    pricingSetup: 'รูปแบบและการปรับราคา',
    pricingModelScope: 'รูปแบบที่เลือกใช้กับทุกแพ็กเกจในบริการนี้',
    pricingUpliftScope: 'ใช้กับราคาและอัตราของทุกแพ็กเกจ',
    pricingUpliftDetails: 'เงื่อนไขการปรับราคา',
    pricingPackages: 'แพ็กเกจค่าบริการ',
    pricingPackageNumber: 'แพ็กเกจที่ {{number}}',
    pricingEmptyHelp: 'เพิ่มแพ็กเกจเพื่อกำหนดราคา หากบันทึกโดยไม่มีแพ็กเกจ จะล้างค่าบริการของบริการนี้',
    pricingInvalidHelp: 'ตรวจสอบค่าที่แสดงข้อผิดพลาดก่อนบันทึก หากยุบรายละเอียดแพ็กเกจไว้ ให้เปิดตรวจสอบด้วย',
    pricingBufferUnit: 'หน่วย{{name}}',
    pricingBufferValue: 'ค่า{{name}}',
    pricingRateType: 'วิธีคิดอัตรา',
    pricingTierNumber: 'ขั้นที่ {{number}}',
    pricingTierContext: '{{axis}} ขั้นที่ {{number}}',
    pricingTierHelp: 'เว้นช่องถึงของขั้นสุดท้ายว่าง เพื่อใช้กับระยะทางหรือเวลาที่เหลือ',
    pricingWindowNumber: 'ช่วงเวลาพิเศษที่ {{number}}',
    pricingWindowStart: 'เริ่มเวลา',
    pricingWindowEnd: 'สิ้นสุดเวลา',
    pricingSurchargeUnit: 'หน่วยค่าบริการเพิ่ม',
    noPricing: 'ยังไม่มีการกำหนดราคา',
    pricingModel: 'รูปแบบการกำหนดค่าบริการ',
    pricingUplift: 'รวมเปอร์เซ็นต์เพิ่มในค่าบริการ',
    pricingUpliftPercent: 'เปอร์เซ็นต์เพิ่มราคา',
    pricingUpliftHelp:
      'ใช้กับทุกแพ็กเกจและอัตราค่าบริการ ลูกค้าเห็นราคาหลังปรับแล้ว ยอดแต่ละรายการปัดเป็นบาทและจัดสรรเศษให้ตรงยอดรวม งานเดิมยังใช้เงื่อนไขราคาที่จองไว้',
    pricingUpliftInvalid: 'ระบุเปอร์เซ็นต์ตั้งแต่ 0 ถึง 100 และทศนิยมไม่เกินสองตำแหน่ง',
    pricingFlat: 'เหมาจ่ายและส่วนเกิน',
    pricingMetered: 'จ่ายตามจริง',
    pricingFlatDesc: 'คิดราคาเหมาจ่ายต่อครั้ง รวมระยะทาง/เวลาที่กำหนด แล้วคิดค่าส่วนเกินเพิ่มเติม',
    pricingMeteredDesc: 'คิดราคาตามระยะทางและเวลาจริงเป็นขั้นบันได',
    pkgName: 'ชื่อแพ็กเกจ',
    price: 'ราคา',
    perTrip: 'บาท/ครั้ง',
    flatCoverage: 'การเหมาจ่าย',
    maxDistance: 'ระยะทางไม่เกิน',
    maxDuration: 'ระยะเวลาไม่เกิน',
    overageRates: 'อัตราค่าบริการส่วนเกิน',
    overageBuffer: 'ระยะผ่อนผันก่อนคิดค่าบริการส่วนเกิน',
    distanceOverageBuffer: 'ผ่อนผันระยะทาง',
    timeOverageBuffer: 'ผ่อนผันระยะเวลา',
    highBufferWarning: 'ค่าสูงกว่า 100% กรุณาตรวจสอบก่อนบันทึก',
    pOverageDistance: 'ระยะทาง',
    pOverageTime: 'ระยะเวลา',
    bahtPerKm: 'บาท/กม.',
    bahtPerHour: 'บาท/ชม.',
    specialConditions: 'เงื่อนไขพิเศษ',
    instantSurcharge: 'เรียกบริการ "ทันที"',
    timeWindow: 'ช่วงเวลาพิเศษ',
    addPricing: 'เพิ่มค่าบริการ',
    removePricing: 'ลบค่าบริการนี้',
    addTier: 'เพิ่มขั้น',
    addTimeWindow: 'เพิ่มช่วงเวลา',
    removeRow: 'ลบ',
    rest: 'ที่เหลือ',
    distanceKmAxis: 'ระยะทาง (กิโลเมตร)',
    durationHoursAxis: 'ระยะเวลา (ชั่วโมง)',
    baht: 'บาท',
    percent: '%',
    tierFrom: 'จาก',
    tierTo: 'ถึง',
    tierRate: 'อัตรา',
    nonNegativeValue: 'ค่าต้องไม่น้อยกว่า 0',
    rateFlat: 'เหมา',
    ratePerUnit: 'ต่อหน่วย',

    // vehicles
    plate: 'เลขทะเบียน',
    plateProvince: 'จังหวัด',
    make: 'ชื่อผู้ผลิต',
    model: 'รุ่น',
    year: 'ปีรุ่น',
    registrationYear: 'ปีจดทะเบียน',
    color: 'สีตัวรถ',
    vehicleType: 'ประเภท',
    seats: 'จำนวนที่นั่ง',
    callName: 'ชื่อเรียก',
    van: 'รถตู้',
    pickup: 'รถกระบะ',
    ambulance: 'รถพยาบาล',
    sedan: 'รถเก๋ง',
    other: 'อื่นๆ',

    // org users
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    gender: 'เพศ',
    employeeCode: 'รหัสพนักงาน',
    position: 'ตำแหน่ง',
    department: 'แผนก',
    role: 'หน้าที่',
    roleOfficer: 'เจ้าหน้าที่ประจำศูนย์',
    roleManager: 'ผู้จัดการ',
    roleAdmin: 'แอดมิน',
    roleOfficerDesc: 'ทำหน้าที่สร้างงาน กระจายงาน ติดตามความคืบหน้าของงานในแต่ละวัน ดูแลข้อมูลลูกค้า',
    roleManagerDesc: 'เข้าถึงข้อมูลทั้งหมด อนุมัติการสมัครของพนักงานและผู้ดูแล เรียกดูรายงาน',
    roleAdminDesc: 'กำหนดและตั้งค่าการทำงานของระบบทั้งหมด เช่น สร้างบริการใหม่ กำหนดพื้นที่ให้บริการ และอื่นๆ',
    passwordNew: 'รหัสผ่าน',
    passwordConfirm: 'ยืนยันรหัสผ่าน',

    // passenger groups
    groupName: 'ชื่อกลุ่ม',
    // passenger-group areas + members (FR-W-SET-PAXGROUP-010)
    paxGroupAreas: 'พื้นที่บริการของกลุ่ม',
    paxGroupAllAreas: 'ทุกพื้นที่',
    paxGroupMembers: 'สมาชิกในกลุ่ม',
    paxGroupManageMembers: 'จัดการสมาชิก',
    paxGroupMemberCount: 'จำนวนสมาชิก',
    paxGroupMembersCount: '{{n}} คน',
    paxGroupAdd: 'เพิ่ม',
    paxGroupRemove: 'นำออก',
    paxGroupAddPlaceholder: 'ค้นหาผู้โดยสารเพื่อเพิ่มเข้ากลุ่ม (ชื่อหรือเบอร์โทร)',
    paxGroupSearchMembers: 'ค้นหาสมาชิกในกลุ่ม',
    description: 'คำอธิบาย',
    pgCivilServant: 'ข้าราชการ',
    pgGeneral: 'คนทั่วไป',
    pgChildYouth: 'เด็กและเยาวชน',
    pgMen: 'บุรุษ',
    pgUnderprivileged: 'ผู้ด้อยโอกาส',
    pgDisabled: 'ผู้พิการ',
    pgElderly: 'ผู้สูงอายุ',
    pgWomen: 'สตรี',

    // service areas
    areaSize: 'ขนาดพื้นที่',
    dispatchConditions: 'เงื่อนไขการกระจายงาน',
    manageDispatchPolicy: 'จัดการนโยบาย',
    dispatchPolicyManagedElsewhere:
      'การตั้งค่ารัศมีค้นหาพนักงานและการส่งต่องานอยู่ในหน้านโยบายแบบมีเวอร์ชัน ค่าเดิมระดับพื้นที่ที่ใช้เฉพาะการกระจายงานยังเก็บไว้เพื่อรองรับการย้อนระบบ ตั้งค่าระยะอนุโลมนอกขอบเขตที่ยังใช้ตรวจสิทธิ์การจองได้ในรายละเอียดพื้นที่ให้บริการ',
    driverSearchRadius: 'รัศมีการค้นหาพนักงาน',
    redispatchRadius: 'รัศมีการส่งต่องาน',
    outOfAreaRange: 'ระยะอนุโลมนอกขอบเขต',
    outOfAreaRangeInvalid: 'กรอกจำนวนเต็มตั้งแต่ 0 ขึ้นไป',
    serviceAreaBoundaryLegend: 'ขอบเขตพื้นที่ให้บริการ',
    outOfAreaRangePreviewLegend: 'ระยะอนุโลมประมาณ {{km}} กม.',
    outOfAreaRangePreviewDefaultLegend: 'ระยะอนุโลมประมาณ {{km}} กม. (ค่าเริ่มต้น)',
    outOfAreaRangeHint:
      'โหมดเดินทางตรวจทั้งจุดเริ่มต้นและจุดหมาย ส่วน CARE ตรวจเฉพาะจุดเริ่มต้น/จุดนัดหมาย ระบบวัดแต่ละจุดที่ต้องตรวจถึงขอบรูปหลายเหลี่ยมของพื้นที่ให้บริการที่ใกล้ที่สุด ค่า 0 หมายถึงไม่อนุโลมระยะนอกขอบเขต โดยการทำงานของจุดที่อยู่ตรงขอบไม่เปลี่ยนแปลง ค่านี้ไม่ใช่รัศมีค้นหาพนักงานใน Dispatch Policy V2',
    outOfAreaRangeNoGeometryHint: 'ค่านี้ยังไม่มีผลจนกว่าจะวาดขอบเขต เพราะพื้นที่ให้บริการที่ไม่มีขอบเขตถือว่าไม่จำกัดพื้นที่',
    redispatchInterval: 'ระยะเวลาการส่งต่องาน',
    redispatchAttempts: 'จำนวนครั้งการส่งต่องาน',
    dispatchStrategy: 'รูปแบบการกระจายงาน',
    dispatchStrategySequential: 'ทีละราย (Sequential)',
    dispatchStrategyBroadcast: 'พร้อมกัน (Broadcast)',
    dispatchFanout: 'จำนวนคำขอพร้อมกัน',
    km: 'กม.',
    sqKm: 'ตร.กม.',
    seconds: 'วินาที',

    // equipment
    equipmentName: 'ชื่ออุปกรณ์',
    medical: 'ทางการแพทย์',
    general: 'ทั่วไป',

    // reasons
    reasonLabel: 'เหตุผล',
    serviceMode: 'รูปแบบบริการ',
    modeTrip: 'การเดินทาง',
    modeCare: 'การดูแล',
    event: 'เหตุการณ์',
    eventCancel: 'ยกเลิกงาน',
    eventReject: 'ปฏิเสธการรับงาน',
    allowedAuthors: 'ผู้มีสิทธิ์ใช้งาน',
    authorProviderStaff: 'พนักงานผู้ให้บริการ',
    authorOrgUser: 'ผู้ใช้ในองค์กร',
    authorPassenger: 'ผู้รับบริการ',
    authorAgent: 'พนักงาน',

    // rating reasons
    scoreThreshold: 'ระดับของคะแนน',
    below3: 'ต่ำกว่า 3 คะแนน',
    below4: 'ต่ำกว่า 4 คะแนน',

    // reasons list + detail drawer (การระบุเหตุผล / การให้คะแนนความพึงพอใจ)
    reasonsTotal: 'เหตุผลสนับสนุนทั้งหมด',
    scoreGiven: 'คะแนนที่ให้',
    by: 'โดย',
    aboutReason: 'เกี่ยวกับเหตุผลนี้',
    details: 'รายละเอียด',
    createEntity: 'สร้าง{{name}}',
    editEntity: 'แก้ไข{{name}}',
    createdDate: 'วันที่สร้าง',
    reasonStatus: 'สถานะเหตุผล',
    reasonName: 'ชื่อ',
    passengerFacingReason: 'เหตุผลที่แสดงต่อผู้โดยสาร',
    reasonTranslationTh: 'คำแปลเหตุผล — ไทย (ไม่บังคับ)',
    reasonTranslationEn: 'คำแปลเหตุผล — อังกฤษ (ไม่บังคับ)',
    passengerReasonTranslationTh: 'คำแปลสำหรับผู้โดยสาร — ไทย (ไม่บังคับ)',
    passengerReasonTranslationEn: 'คำแปลสำหรับผู้โดยสาร — อังกฤษ (ไม่บังคับ)',
    viaMobileApp: 'ผ่านทางโมบายแอปพลิเคชั่น',
    viaWebConsole: 'ผ่านทางเว็บคอนโซล',
    createReasonTitle: 'สร้างการระบุเหตุผล',
    editReasonTitle: 'แก้ไขการระบุเหตุผล',
    createRatingTitle: 'สร้างการให้คะแนนความพึงพอใจ',
    editRatingTitle: 'แก้ไขการให้คะแนนความพึงพอใจ',
    createReasonAction: 'สร้างเหตุผล',

    // service areas (พื้นที่ให้บริการ)
    areasTotal: 'พื้นที่ให้บริการทั้งหมด',
    aboutArea: 'เกี่ยวกับพื้นที่ให้บริการนี้',
    areaName: 'ชื่อพื้นที่',
    serviceGroupCount: 'จำนวนกลุ่มการให้บริการ',
    areaUnlinked: 'ยังไม่ถูกใช้งาน',
    areaUnlinkedHint: 'ยังไม่มีกลุ่มการให้บริการที่เปิดใช้งานอ้างถึงขอบเขตนี้ จึงยังไม่มีผลกับการจอง — เปิดกลุ่มบริการแล้วเลือกพื้นที่นี้',
    groupAreas: 'พื้นที่ให้บริการ',
    groupAreasUnconstrained: 'ไม่ได้กำหนด — ให้บริการทุกพื้นที่',
    groupAreasHint:
      'เลือกพื้นที่ที่กลุ่มบริการนี้ครอบคลุม โหมดเดินทางตรวจทั้งจุดเริ่มต้นและจุดหมาย ส่วน CARE ตรวจเฉพาะจุดเริ่มต้น/จุดนัดหมาย จุดที่ต้องตรวจซึ่งอยู่นอกทุกขอบเขตและเกินระยะอนุโลมนอกขอบเขตจะจองไม่ได้ ถ้าไม่เลือกเลย = ให้บริการทุกพื้นที่',
    orgSites: 'พื้นที่ของหน่วยงาน',
    siteType: 'ประเภท',
    siteTypeParking: 'พื้นที่จอดรถ',
    siteTypeTerminal: 'ท่ารถ',
    siteTypeOffice: 'สำนักงาน',
    siteTypeDepot: 'โรงซ่อมบำรุง',
    siteTypeOther: 'อื่นๆ',
    drawBoundary: 'วาดขอบเขต',
    resetBoundary: 'รีเซท',
    removeBoundary: 'ลบขอบเขต',
    finishBoundary: 'เสร็จสิ้น',
    useProvinceBoundary: 'ใช้ขอบเขตจังหวัด',
    provinceBoundaryFailed: 'โหลดขอบเขตจังหวัดไม่สำเร็จ',
    provinceBoundarySource: 'ขอบเขตจังหวัด: กรมแผนที่ทหาร เผยแพร่ผ่าน UN OCHA (CC BY-IGO 3.0)',
    deleteSite: 'ลบพื้นที่',
    deleteWarningTitle: 'แจ้งเตือนการลบข้อมูล',
    deleteSiteWarning: 'การลบพื้นที่ของหน่วยงานไม่สามารถกู้คืนได้ กรุณาพิมพ์ว่า {{phrase}} และกดยืนยัน',
    confirmDeleteAction: 'ยืนยันการลบข้อมูล',
    createAreaTitle: 'สร้างพื้นที่ให้บริการ',
    createAreaAction: 'สร้างพื้นที่ใหม่',
    editAreaTitle: 'แก้ไขพื้นที่ให้บริการ',
    selectProvince: 'เลือกจังหวัด',
    region: 'ภาค',
    regionNorth: 'ภาคเหนือ',
    regionNortheast: 'ภาคตะวันออกเฉียงเหนือ',
    regionCentral: 'ภาคกลาง',
    regionEast: 'ภาคตะวันออก',
    regionWest: 'ภาคตะวันตก',
    regionSouth: 'ภาคใต้',

    // org users (ผู้ใช้ในองค์กร)
    usersTotal: 'ผู้ใช้ในองค์กรทั้งหมด',
    aboutEmployee: 'เกี่ยวกับพนักงานคนนี้',
    personalInfo: 'ข้อมูลส่วนตัว',
    accountAccess: 'บัญชีและการเข้าถึง',
    createUserTitle: 'สร้างผู้ใช้ใหม่',
    editUserTitle: 'ผู้ใช้',
    genderMale: 'ชาย',
    genderFemale: 'หญิง',
    employeeStatus: 'สถานะพนักงาน',
    memberSince: 'วันเริ่มต้นการเป็นสมาชิก',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    newPassword: 'รหัสผ่านใหม่',
    confirmNewPassword: 'ยืนยันรหัสผ่านใหม่',
    passwordMismatch: 'รหัสผ่านไม่ตรงกัน',
    createOption: 'สร้าง',
    showPassword: 'แสดงรหัสผ่าน',
    hidePassword: 'ซ่อนรหัสผ่าน',

    // provider onboarding (สิทธิ์ PROVIDER_ONBOARDING_CREATE — issue #415)
    providerOnboarding: 'สร้าง Provider',
    onboardingSubtitle: 'สร้าง Provider ใหม่พร้อมบัญชี ADMIN เริ่มต้นในขั้นตอนเดียว',
    onboardingProviderName: 'ชื่อ Provider',
    onboardingCodeHint: 'ระบบจะสร้างรหัสองค์กรให้โดยอัตโนมัติ และแสดงหลังบันทึกสำเร็จ',
    onboardingAdminFirstName: 'ชื่อของ ADMIN เริ่มต้น',
    onboardingAdminLastName: 'นามสกุลของ ADMIN เริ่มต้น',
    onboardingAdminEmail: 'อีเมล ADMIN เริ่มต้น',
    onboardingAdminPassword: 'รหัสผ่าน ADMIN เริ่มต้น',
    onboardingEmailInvalid: 'รูปแบบอีเมลไม่ถูกต้อง',
    onboardingPasswordTooShort: 'รหัสผ่านต้องยาวอย่างน้อย 8 ตัวอักษร',
    onboardingReceiptTitle: 'สร้าง Provider สำเร็จ',
    onboardingReceiptAdmin: 'ADMIN เริ่มต้นของ Provider ใหม่',
    onboardingReceiptContext: 'การทำงานยังคงอยู่ในองค์กรปัจจุบันของคุณ',
    onboardingForbidden: 'คุณไม่มีสิทธิ์ใช้งานฟีเจอร์นี้',

    // org (ข้อมูลองค์กร)
    orgsTotal: 'องค์กรทั้งหมด',
    aboutOrg: 'เกี่ยวกับองค์กรนี้',
    hqOfficeLocation: 'ที่ทำการสำนักงานใหญ่',
    orgStatus: 'สถานะองค์กร',
    orgTypeState: 'หน่วยงานรัฐวิสาหกิจ',
    orgTypePrivate: 'หน่วยงานเอกชน',
    orgTypeGovernment: 'หน่วยงานรัฐ',
    orgTypeOther: 'อื่นๆ',
    editOrgTitle: 'ข้อมูลองค์กร',
    createOrgTitle: 'สร้างองค์กรใหม่',
    roleSuperAdmin: 'ซูเปอร์แอดมิน',
  },
  trips: {
    avoidTollsNote: 'ระบบเลือกเส้นทางหลีกเลี่ยงทางด่วนเมื่อทำได้ ราคานี้ไม่รวมค่าทางด่วน',
    amendment_previous: 'เดิม',
    amendment_unchanged: 'คงเดิม',
    amendment_readOnly: 'ไม่สามารถเปลี่ยนได้',
    amendment_locationUpdated: 'เปลี่ยนพิกัดสถานที่',
    amendment_currentComparison: 'เปรียบเทียบบริการที่มีผลอยู่กับคำขอนี้ ไม่ใช่ภาพก่อนและหลังการแก้ไขในอดีต',
    amendment_history: 'ประวัติคำขอ',
    amendment_deliveryDetails: 'รายละเอียดการส่งการแจ้งเตือน',
    amendment_nextConsent: 'รอผู้โดยสารยินยอมให้ค้นหาผู้ให้บริการใหม่',
    amendment_nextAgent: 'ผู้ให้บริการต้องตรวจสอบและตอบรับรายละเอียดนี้ เจ้าหน้าที่ยังไม่ต้องดำเนินการ',
    amendment_nextPayment: 'รอชำระส่วนต่างหรือตรวจสอบการรับเงิน ดูหลักฐานการชำระเงินด้านล่าง',
    amendment_nextApply: 'ระบบกำลังดำเนินการเปลี่ยนแปลง โปรดรอการยืนยัน',
    amendment_searchGroup: 'การค้นหาผู้ให้บริการ · {{count}} เหตุการณ์ที่โหลด',
    amendment_auditUnknown: 'กิจกรรมคำขอเปลี่ยนแปลง',
    amendment_error_AMENDMENT_MINIMUM_LEAD_TIME:
      'เวลานัดหมายใกล้เกินระยะจองล่วงหน้าขั้นต่ำของบริการ โปรดเลือกเวลาที่ช้ากว่านี้แล้วตรวจสอบใหม่',
    amendment_error_AMENDMENT_VEHICLE_CAPACITY_UNKNOWN:
      'รถที่มอบหมายยังไม่ระบุจำนวนที่นั่ง โปรดบันทึกจำนวนที่นั่งจริงก่อนขอเปลี่ยนแปลง',
    amendment_error_AMENDMENT_VEHICLE_CAPACITY_INSUFFICIENT:
      'จำนวนที่นั่งรถไม่พอสำหรับคำขอนี้ โปรดตรวจสอบจำนวนผู้เดินทางและความจุรถ',
    amendment_error_AMENDMENT_VEHICLE_UNAVAILABLE: 'รถที่มอบหมายไม่พร้อมใช้งาน โปรดตรวจสอบรถและสถานะ',
    amendment_error_AMENDMENT_AGENT_UNAVAILABLE: 'ผู้ให้บริการที่มอบหมายไม่พร้อมรับการเปลี่ยนแปลง โปรดตรวจสอบการมอบหมาย',
    amendment_error_AMENDMENT_AGENT_AREA_UNSUITABLE:
      'ผู้ให้บริการที่มอบหมายไม่ให้บริการในพื้นที่รับใหม่ โปรดตรวจสอบจุดรับและพื้นที่ให้บริการของผู้ให้บริการ',
    amendment_error_AMENDMENT_AGENT_SKILLS_UNSUITABLE: 'ผู้ให้บริการที่มอบหมายไม่มีทักษะที่จำเป็น โปรดตรวจสอบการมอบหมาย',
    amendment_error_AMENDMENT_VEHICLE_SHARING_UNSUPPORTED: 'รถที่มอบหมายไม่รองรับเงื่อนไขร่วมเส้นทางของการจอง',
    amendment_error_AMENDMENT_ROUTE_SHARE_IMMUTABLE: 'ไม่สามารถเปลี่ยนความยินยอมร่วมเส้นทางผ่านคำขอแก้ไขได้',
    amendment_event_AMENDMENT_SEARCH_STARTED: 'เริ่มค้นหาผู้ให้บริการใหม่',
    amendment_event_AMENDMENT_SEARCH_COMPLETED: 'จบรอบค้นหาผู้ให้บริการ',
    amendment_event_AMENDMENT_SEARCH_CANDIDATE_SKIPPED: 'ข้ามผู้สมัคร',
    amendment_event_AMENDMENT_OFFERED: 'ส่งข้อเสนอการเปลี่ยนแปลง',
    amendment_event_AMENDMENT_OFFER_TIMED_OUT: 'ข้อเสนอการเปลี่ยนแปลงหมดเวลา',
    amendment_event_AMENDMENT_OFFER_RESPONDED: 'ผู้ให้บริการตอบข้อเสนอการเปลี่ยนแปลง',
    amendment_event_AMENDMENT_REPLACEMENT_CONSENT: 'บันทึกหรือร้องขอความยินยอมค้นหาผู้ให้บริการใหม่',
    amendment_event_AMENDMENT_APPLY_STARTED: 'เริ่มดำเนินการเปลี่ยนแปลง',
    amendment_event_AMENDMENT_APPLY_COMPLETED: 'เสร็จสิ้นรอบดำเนินการเปลี่ยนแปลง',
    amendment_event_BOOKING_AMENDMENT_APPLIED: 'การเปลี่ยนแปลงการจองมีผลแล้ว',
    amendment_event_BOOKING_AMENDMENT_WITHDRAWN: 'ถอนคำขอเปลี่ยนแปลง',
    amendment_event_AMENDMENT_CLOSED: 'ปิดคำขอเปลี่ยนแปลง',
    amendment_event_AMENDMENT_RECEIPT_CONFIRMED: 'ยืนยันการรับเงินคำขอเปลี่ยนแปลง',
    amendment_event_AMENDMENT_REFUND_CONFIRMED: 'ยืนยันคืนเงินคำขอเปลี่ยนแปลง',
    amendment_event_AMENDMENT_REFUND_TRANSFER_CONFIRMED: 'ยืนยันการโอนคืนเงิน',
    amendment_event_AMENDMENT_RECONCILIATION_REFUND_RESERVED: 'กันเงินสำหรับคืน',
    amendment_event_AMENDMENT_TRANSPORT_ACKNOWLEDGED: 'ตรวจสอบการส่งการแจ้งเตือน',
    amendment_event_AMENDMENT_PROOF_REVIEW: 'หลักฐานการชำระเงินรอตรวจสอบ',
    amendment_event_AMENDMENT_PROOF_REJECTED: 'ปฏิเสธหลักฐานการชำระเงิน',

    amendment_followUp: 'ส่วนนี้ยังไม่มีปุ่มให้ผู้ให้บริการตอบรับหรือจัดการเงินของคำขอแก้ไข งานเดิมยังดำเนินต่อระหว่างรอคำขอ',
    amendment_title: 'การขอแก้ไขการจอง',
    amendment_request: 'ขอแก้ไขการจอง',
    amendment_preview: 'ตรวจสอบราคาและรายละเอียด',
    amendment_submit: 'ส่งคำขอแก้ไข',
    amendment_close: 'ปิด',
    amendment_summaryFinancePending: 'มีรายการเงินที่ต้องดำเนินการ',
    amendment_summaryPayment: 'รอชำระส่วนต่างหรือตรวจสอบหลักฐาน',
    amendment_summaryUnavailable: 'ไม่สามารถขอแก้ไขได้ในสถานะหรือเงื่อนไขของงานนี้',
    amendment_summaryService: 'ประเภทงาน',
    amendment_summarySchedule: 'รูปแบบการนัดหมาย',
    amendment_showUnchanged: 'ดูข้อมูลที่ไม่เปลี่ยนแปลง',
    amendment_hideUnchanged: 'ซ่อนข้อมูลที่ไม่เปลี่ยนแปลง',
    amendment_field: 'รายการ',
    amendment_requestedAt: 'ส่งคำขอเมื่อ',
    amendment_respondBy: 'ตอบรับภายใน',
    amendment_changedDetails: 'รายละเอียดที่ขอเปลี่ยน',
    amendment_calculationDetails: 'รายละเอียดการคำนวณ',
    amendment_copyRecord: 'คัดลอกรหัสอ้างอิงรายการ',
    amendment_noDifferences: 'ไม่พบความแตกต่างในข้อมูลที่เปรียบเทียบ',
    amendment_summaryRequest: 'คำขอปัจจุบัน',
    amendment_summaryNoActive: 'ไม่มีคำขอที่รอดำเนินการ',
    amendment_summaryCanRequest: 'คุณสามารถส่งคำขอแก้ไขรายละเอียดงานได้',
    amendment_summaryNoHistory: 'ยังไม่มีประวัติคำขอที่สิ้นสุดแล้ว',
    amendment_summaryDetails: 'ดูรายละเอียดและประวัติ',
    amendment_originalRemains: 'งานที่ยืนยันแล้วมีผลตามเดิมจนกว่าคำขอนี้จะเปลี่ยนงานสำเร็จ',
    amendment_confirmed: 'งานที่ยืนยันแล้ว',
    amendment_proposed: 'รายละเอียดที่เสนอ',
    amendment_scheduledStart: 'เวลาเริ่มงาน',
    amendment_scheduledEnd: 'เวลาสิ้นสุดงาน',
    amendment_pickupApptAt: 'เวลานัดรับ',
    amendment_arriveByAt: 'เวลาที่ต้องไปถึง',
    amendment_stationary: 'เวลารอที่กำหนด (นาที)',
    amendment_notSet: 'ไม่ได้ระบุ',
    amendment_unavailable: 'ยังไม่มีข้อมูล',
    amendment_share: 'ยินยอมเดินทางร่วม',
    amendment_yes: 'ใช่',
    amendment_no: 'ไม่ใช่',
    amendment_link: 'งานต่อเนื่อง',
    amendment_linked: 'ต่อเนื่องจากงานเดิม',
    amendment_independent: 'งานอิสระ',
    amendment_fare: 'ค่าบริการ (บาท)',
    amendment_financeUnavailable:
      'ยังไม่มีสรุปยอดชำระและคืนเงินในส่วนนี้ โปรดตรวจสอบรายการชำระเงิน ไม่ได้หมายความว่ายอดคงเหลือเป็นศูนย์',
    amendment_money: 'ผลต่อการชำระเงิน (บาท)',
    amendment_waiver: 'ยอดยกเว้นที่ใช้ (ไม่ใช่เงินรับ)',
    amendment_available: 'เงินรับยืนยันแล้วที่ใช้ได้',
    amendment_topup: 'ยอดที่ต้องจ่ายเพิ่ม',
    amendment_refund: 'ยอดที่ต้องคืนเพิ่ม',
    amendmentFinance_refundTransfer: 'บันทึกคืนเงินรวมในครั้งเดียว',
    amendmentFinance_selectedRefunds: 'ยอดรอคืนที่เลือก {{count}} รายการ',
    amendmentFinance_selectRefundItem: 'รวมรายการนี้ในการคืนเงิน',
    amendmentFinance_selectRefund: 'รวมยอดคืนรายการ {{id}}',
    amendmentProof_title: 'หลักฐานการชำระเงินสำหรับแก้ไขงาน',
    amendmentProof_RESERVED: 'กำลังอัปโหลด',
    amendmentProof_PENDING: 'รอผู้ดูแลตรวจสอบ — ยังไม่ยืนยันรับเงิน',
    amendmentProof_REJECTED: 'หลักฐานถูกปฏิเสธ — ส่งใหม่ได้',
    amendmentProof_CONFIRMED: 'ผู้ดูแลยืนยันรับเงินแล้ว',
    amendmentProof_UPLOAD_FAILED: 'อัปโหลดไม่สำเร็จ — ส่งรูปใหม่อีกครั้ง',
    amendmentProof_notCash: 'สลิปที่แนบเป็นหลักฐานเท่านั้น ผู้ดูแลยืนยันจึงถือว่ารับเงินแล้ว แม้คำขอแก้ไขจะปิดไปแล้ว',
    amendmentProof_confirm: 'ยืนยันรับเงินจากหลักฐานนี้',
    amendmentProof_reject: 'ปฏิเสธหลักฐานนี้',
    amendmentProof_rejectionReason: 'เหตุผลที่แสดงให้ลูกค้า',
    amendmentProof_cashConsent: 'ฉันตรวจสอบหลักฐานนี้แล้วและยืนยันว่าได้รับเงินจริงตามจำนวนที่ระบุ',
    amendmentProof_submitted: 'ส่งเมื่อ',
    amendmentProof_view: 'ดูหลักฐานการชำระเงิน',
    amendmentProof_upload: 'ส่งหลักฐานการชำระเงิน',
    amendmentProof_image: 'รูปสลิป',
    amendmentProof_uploadRetry:
      'การลองใหม่จะส่งคำขอรูปเดิม หากอัปโหลดล้มเหลวแล้ว ให้ปิดและเริ่มส่งใหม่ ตรวจสอบรายการก่อนส่งซ้ำ',
    amendmentProof_pendingCount: 'หลักฐานรอตรวจสอบทั้งหมดของงานนี้ {{count}} รายการ',
    amendmentProof_uploadRevision: 'แนบหลักฐานสำหรับคำขอครั้งที่ {{revision}}',
    amendmentProof_empty: 'ยังไม่มีหลักฐานการชำระเงินสำหรับแก้ไขงาน',
    amendmentFinance_title: 'การรับเงินและคืนเงินจากการแก้ไขงาน',
    amendmentFinance_receive: 'ยืนยันรับเงินจริง',
    amendmentFinance_refund: 'ยืนยันคืนเงินจริง',
    amendmentFinance_reserve: 'กันยอดเพื่อคืนเงิน',
    amendmentFinance_confirm: 'ยืนยันรายการนี้',
    amendmentFinance_retry: 'ลองยืนยันรายการเดิมอีกครั้ง',
    amendmentFinance_confirmHelp: 'บันทึกเมื่อรับเงินจริงหรือคืนเงินจริงแล้วเท่านั้น การแนบสลิปอย่างเดียวยังไม่ถือว่ายืนยันเงิน',
    amendmentFinance_reserveHelp: 'กันยอดนี้ไว้เพื่อคืนเงิน ขั้นตอนนี้ยังไม่ถือว่าคืนเงินแล้ว',
    amendmentFinance_amount: 'จำนวนเงิน (บาทเต็ม)',
    amendmentFinance_reference: 'เลขอ้างอิงธุรกรรม',
    amendmentFinance_proof: 'อ้างอิงหลักฐานที่ตรวจสอบแล้ว',
    amendmentFinance_cashConsent: 'ฉันตรวจสอบหลักฐานแล้ว และยืนยันว่ารับหรือคืนเงินจริงแล้ว',
    amendmentFinance_reserveConsent: 'ฉันยืนยันให้กันยอดนี้ไว้เพื่อคืนเงิน',
    amendmentFinance_retryHelp:
      'รายการอาจถูกปฏิเสธหรือยังไม่ทราบผล การลองใหม่จะส่งรายการเดิมโดยไม่สร้างคำขอใหม่ ก่อนเริ่มรายการอื่นให้โหลดข้อมูลใหม่และตรวจว่าบันทึกแล้วหรือไม่',
    amendmentFinance_maximum: 'จำนวนเงินสูงสุดที่ดำเนินการได้',
    amendmentFinance_target: 'รายการที่เกี่ยวข้อง',
    amendmentFinance_asOf: 'ข้อมูล ณ {{time}}',
    amendmentFinance_received: 'ยอดรับเงินที่บันทึกแล้ว',
    amendmentFinance_refunded: 'ยอดคืนเงินจริงแล้ว',
    amendmentFinance_reserved: 'ยอดกันไว้รอคืนเงิน',
    amendmentFinance_uninitialized: 'ยังไม่ได้เริ่มบัญชีการแก้ไขงาน ยอดรวมนี้ยังไม่พร้อมแสดง โปรดตรวจสอบข้อมูลการชำระเงินเดิม',
    amendmentFinance_receiveRevision: 'บันทึกรับเงินสำหรับคำขอครั้งที่ {{revision}}',
    amendmentFinance_receipts: 'รายการรับเงินที่บันทึกแล้ว',
    amendmentFinance_noReceipts: 'ไม่มีรายการรับเงินในบัญชีการแก้ไขงานนี้',
    amendmentFinance_adminConfirmed: 'ผู้ดูแลยืนยันแล้ว',
    amendmentFinance_legacy: 'ข้อมูลการชำระเงินเดิม',
    amendmentFinance_record: 'รหัสอ้างอิงรายการ',
    amendmentFinance_proofRecorded: 'มีการบันทึกอ้างอิงหลักฐาน',
    amendmentFinance_noProof: 'ไม่มีอ้างอิงหลักฐานที่บันทึกไว้',
    amendmentFinance_reconciliation: 'เงินที่รอตรวจสอบจัดสรร',
    amendmentFinance_noReconciliation: 'ไม่มีเงินที่จัดสรรไว้รอตรวจสอบ',
    amendmentFinance_availableRefund: 'ยอดที่กันเพื่อคืนเงินได้',
    amendmentFinance_refunds: 'รายการที่ต้องคืนเงิน',
    amendmentFinance_noRefunds: 'ไม่มีรายการที่ต้องคืนเงินในบัญชีนี้',
    amendment_moneyHelp: 'ยอดรอคืนที่กันไว้ใช้กับคำขอนี้ไม่ได้ สลิปเป็นหลักฐานรอตรวจ เจ้าหน้าที่ยืนยันจึงถือว่ารับเงินหรือคืนเงินแล้ว',
    amendment_detach: 'เสนอเปลี่ยนขากลับเป็นงานอิสระ',
    amendment_reason: 'เหตุผล',
    amendment_withdrawRetryHelp: 'ยังเก็บเหตุผลที่กรอกไว้ โปรดตรวจสอบสถานะคำขอล่าสุดก่อนลองถอนคำขออีกครั้ง',
    amendment_retryHelp: 'ยังเก็บข้อมูลที่กรอกไว้ โปรดตรวจสอบข้อมูลล่าสุดและขอราคาอีกครั้งหากเงื่อนไขเปลี่ยน',
    amendment_freshPrice: 'ราคานี้เป็นราคาใหม่ที่ต้องได้รับความยินยอม',
    amendment_originalPrice: 'คำนวณตามข้อตกลงราคาที่มีหลักฐาน',
    amendment_expires: 'ราคาใช้ได้ถึง {{time}}',
    amendment_expiredPreview: 'ราคาที่ตรวจสอบหมดอายุแล้ว โปรดตรวจสอบใหม่',
    amendment_freshConsent: 'ยินยอมราคาใหม่และยอดชำระที่แสดง',
    amendment_detachConsent: 'ยินยอมให้เสนอขากลับเป็นงานอิสระ โดยงานต่อเนื่องเดิมยังมีผลจนกว่าเปลี่ยนงานสำเร็จ',
    amendment_revision: 'คำขอครั้งที่ {{revision}}',
    amendment_deadline: 'ขั้นตอนนี้สิ้นสุดเวลา {{time}}',
    amendment_review: 'ดูรายละเอียด',
    amendment_withdraw: 'ถอนคำขอ',
    amendment_confirmWithdraw: 'ยืนยันถอนคำขอ',
    amendment_reload: 'โหลดใหม่',
    amendment_empty: 'ยังไม่มีคำขอแก้ไข',
    amendment_more: 'โหลดคำขอก่อนหน้า',
    amendment_state_PENDING_AGENT: 'รอผู้ให้บริการรับข้อเสนอ',
    amendment_state_PENDING_PAYMENT: 'รอยืนยันการชำระเพิ่ม',
    amendment_state_READY_TO_COMMIT: 'ยอมรับแล้ว รอเปลี่ยนงาน',
    amendment_state_APPLIED: 'เปลี่ยนงานแล้ว',
    amendment_state_EXPIRED: 'หมดเวลา',
    amendment_state_WITHDRAWN: 'ถอนคำขอแล้ว',
    amendment_state_REJECTED: 'ปฏิเสธแล้ว',
    amendment_state_SUPERSEDED: 'คำขอเปลี่ยนแปลงปิดแล้ว',
    amendment_timing_CONTINUATION_SERVICE_BOUNDARY_REQUIRED:
      'งานต่อเนื่องยังไม่มีเวลาเริ่มที่ยืนยัน โปรดเสนอเป็นงานอิสระพร้อมเวลาเริ่ม',
    amendment_timing_CUTOFF_REACHED: 'เลยเวลาที่ขอแก้ไขได้แล้ว',
    amendment_timing_INSUFFICIENT_QUOTE_VALIDITY: 'อายุเส้นทางหรือราคาสั้นเกินกว่าจะดำเนินการครบ โปรดตรวจสอบใหม่',
    automation_waiveAmount: 'ยอดที่จะยกเว้น',
    automation_afterReview: 'ยอดคงค้างของงานหลังตรวจสอบ',
    automation_configure: 'ตั้งค่า',
    automation_save: 'บันทึกการตั้งค่า',
    automation_discardHelp: 'มีการแก้ไขที่ยังไม่บันทึก ต้องการละทิ้งการแก้ไขหรือไม่?',
    automation_discard: 'ละทิ้งการแก้ไข',
    automation_keepEditing: 'แก้ไขต่อ',
    automation_arrivalGroup: 'ตรวจจับการถึงจุดรับและจุดส่ง',
    automation_pickupGroup: 'รับผู้โดยสารอัตโนมัติ',
    automation_completionGroup: 'จบงานอัตโนมัติ',
    automation_sharedGroup: 'เงื่อนไขออกจากจุดและเวลานับถอยหลังร่วมกัน',
    automation_default: 'ใช้ค่าเริ่มต้นของระบบ',
    automation_inheritSystem: 'ใช้ค่าจากระบบ',
    automation_inheritProvider: 'ใช้ค่าจากผู้ให้บริการ',
    automation_savedValue: 'ค่าที่บันทึกและมีผล: {{value}} · {{source}}',
    automation_range: 'กรอกจำนวนเต็มระหว่าง {{min}}–{{max}}',
    automation_radiusRange: 'ตั้งค่าได้ {{min}}–{{max}} เมตร โดยกรอกเป็นจำนวนเต็ม',
    automation_departureHelp:
      'รัศมีออกจากจุดต้องมากกว่ารัศมีถึงจุดรับและจุดส่งทั้งสองค่า รวมถึงค่าที่รับจากระดับก่อนหน้า โดยห้ามเท่ากัน เช่น หากรัศมีถึงทั้งสองจุดเป็น {{arrival}} เมตร ต้องตั้งรัศมีออกจากจุดอย่างน้อย {{departure}} เมตร',
    automation_policyTiming:
      'การแก้ไขมีผลหลังบันทึกสำหรับงานที่เริ่มใหม่ งานที่เริ่มแล้วใช้ค่าที่บันทึกไว้ตอนเริ่มงาน ช่องว่างใช้ค่าจากระดับก่อนหน้าและจะยืนยันค่าที่มีผลหลังบันทึก',
    automation_pickupHelp:
      'เมื่อเข้าเงื่อนไข ระบบแจ้งผู้ขับและเริ่มนับถอยหลัง เวลาเริ่มนับถอยหลังเป็นจุดเริ่มคิดระยะและเวลา ผู้ขับยกเลิกได้พร้อมระบุเหตุผล',
    automation_completionHelp:
      'จบงานหมายถึงส่งผู้โดยสารแล้ว เมื่อเข้าเงื่อนไข ระบบแจ้งผู้ขับและเริ่มนับถอยหลัง โดยหยุดคิดระยะและเวลาที่จุดเริ่มนับถอยหลัง',
    automation_sharedHelp:
      'ใช้ค่าชุดนี้ร่วมกันกับการรับผู้โดยสารและจบงาน ต้องมีข้อมูล GPS และการส่งแจ้งเตือนที่เข้าเงื่อนไขก่อนดำเนินการอัตโนมัติ',
    automation_savedRule:
      'เงื่อนไขที่บันทึกอยู่: ออกจากจุดเกิน {{radius}} เมตร ต่อเนื่อง {{dwell}} วินาที → นับถอยหลัง {{countdown}} (เมื่อเปิดใช้งานและเข้าเงื่อนไขอื่นครบ)',
    automation_countdownSeconds: '{{count}} วินาที',
    automation_countdownOneMinute: '1 นาที',
    automation_countdownMinutes: '{{count}} นาที',
    automation_countdownOneMinuteSeconds: '1 นาที {{seconds}} วินาที',
    automation_countdownMinutesSeconds: '{{minutes}} นาที {{seconds}} วินาที',
    automation_warningExample:
      'ตัวอย่าง: แผน 20 กม. + อนุโลม 4 กม. + เกณฑ์เตือน 20% ของแผน (4 กม.) = เตือนที่ 28 กม. เกณฑ์เตือนไม่ใช่การเพิ่มระยะอนุโลมฟรี',
    automation_loading: 'กำลังโหลดข้อมูลการทำงานอัตโนมัติ…',
    automation_meters: '{{value}} เมตร',
    automation_km: 'กม.',
    automation_minutes: 'นาที',
    automation_unknown: 'ยังประเมินไม่ได้',
    automation_counting: 'รอผู้ขับตอบกลับ',
    automation_remaining: 'เหลือ {{seconds}} วินาที',
    automation_elapsedSeconds: '{{seconds}} วินาที จาก{{baseline}}',
    automation_waitServer: 'ครบกำหนดแล้ว กำลังรอยืนยันผลจากระบบ',
    automation_anchor: 'เวลาเริ่มนับถอยหลัง',
    automation_deadline: 'เวลาครบกำหนด',
    automation_stale: 'ข้อมูลอาจไม่เป็นปัจจุบัน โหลดใหม่ก่อนดำเนินการ',
    automation_activeAttempts: 'กำลังดำเนินการ',
    automation_evidenceHelp:
      'GPS เป็นหลักฐานการถึงจุด ไม่ยืนยันว่าผู้โดยสารขึ้นหรือลงรถ จุดเริ่มและสิ้นสุดคิดเงินอาจต่างจากเวลาที่เปลี่ยนสถานะจริง',
    automation_noEvidence: 'ยังไม่มีหลักฐานการถึงจุดที่เข้าเงื่อนไข ไม่ได้หมายความว่าไม่เคยถึงจุด',
    automation_OUTBOUND: 'เที่ยวไป',
    automation_RETURN: 'เที่ยวกลับ',
    automation_qualifiedAt: 'เวลายืนยันการถึงจุด',
    automation_entryAt: 'เวลาเข้าเขต',
    automation_receivedAt: 'เวลารับข้อมูล',
    automation_gpsQuality: 'ห่างจากจุด {{distance}} เมตร · ความแม่นยำ GPS {{accuracy}} เมตร',
    automation_viewEvidence: 'ดูหลักฐานบนแผนที่',
    automation_job: 'เลขงาน',
    automation_outstanding: 'ยอดคงค้างของงาน',
    automation_waiveImpact:
      'ยกเว้นยอดส่วนเกินคงค้างทั้งหมด ไม่คืนเงินที่ชำระแล้วและไม่ถือเป็นการรับเงิน การจองครั้งถัดไปยังต้องผ่านการตรวจยอดค้างอื่นตามปกติ',
    automation_approveImpact: 'ยืนยันยอดส่วนเกินเพื่อเข้าสู่ขั้นตอนเรียกเก็บตามปกติ การอนุมัติไม่ถือว่าชำระแล้ว',
    automation_confirmReview: 'ยืนยันการตรวจสอบ',
    automation_closureHelp:
      'เลือกเวลาสิ้นสุดบริการจากหลักฐาน แล้วดูผลคำนวณก่อนยืนยัน ระบบยังบันทึกเวลาที่เจ้าหน้าที่ดำเนินการจริงแยกไว้',
    automation_serviceTotal: 'ค่าบริการรวม',
    automation_billableMetrics: 'ระยะและเวลาที่ใช้คำนวณ',
    automation_closureReviewPending: 'หลังปิดงานยังต้องตรวจสอบยอดส่วนเกินก่อนจองหรือเริ่มงานถัดไป',
    automation_closureNoReview: 'ผลประเมินนี้ไม่ต้องตรวจสอบส่วนเกินเพิ่มเติม ยอดคงค้างยังต้องชำระตามปกติ',
    automation_gpsPickup: 'GPS ตรวจพบถึงจุดรับ',
    automation_gpsDropoff: 'GPS ตรวจพบถึงจุดส่ง',

    automation_title: 'การทำงานอัตโนมัติของงาน',
    automation_help:
      'บันทึกหลักฐานถึงจุดหลังเริ่มงาน การเปลี่ยนสถานะอัตโนมัติปิดเป็นค่าเริ่มต้น ตั้งรัศมีถึงจุดรับและจุดส่งแยกกัน ส่วนรัศมีออกจากจุดใช้ร่วมกันและต้องมากกว่าทั้งสองค่า',
    automation_effective: 'ค่าที่ใช้: {{value}} ({{source}})',
    automation_inherit: 'ใช้ค่าจากลำดับก่อนหน้า',
    automation_off: 'ปิด',
    automation_on: 'เปิด',
    automation_SYSTEM: 'ระบบ',
    automation_PROVIDER: 'ผู้ให้บริการ',
    automation_SERVICE_AREA: 'พื้นที่บริการ',
    automation_pickupArrivalEnabled: 'เปลี่ยนสถานะถึงจุดรับอัตโนมัติ',
    automation_dropoffArrivalEnabled: 'เปลี่ยนสถานะถึงจุดส่งอัตโนมัติ',
    automation_pickupEnabled: 'นับถอยหลังรับผู้โดยสารอัตโนมัติ',
    automation_completionEnabled: 'นับถอยหลังจบงานอัตโนมัติ',
    automation_pickupRadiusM: 'รัศมีถึงจุดรับ (เมตร)',
    automation_dropoffRadiusM: 'รัศมีถึงจุดส่ง (เมตร)',
    automation_arrivalDwellSec: 'เวลายืนยันอยู่ในจุด (วินาที)',
    automation_departureRadiusM: 'รัศมีออกจากจุด (เมตร)',
    automation_departureDwellSec: 'เวลายืนยันออกจากจุด (วินาที)',
    automation_countdownSec: 'เวลานับถอยหลังให้ตอบกลับ (วินาที)',
    automation_warningPercent: 'เตือนระยะส่วนเกินเพิ่มเติม (%)',
    automation_warningHelp: 'ค่าที่ใช้ {{value}}% บวกจากแผนและระยะอนุโลมในราคา',
    automation_review: 'ตรวจสอบยอดส่วนเกิน',
    automation_reviewNotRequired: 'ไม่ต้องตรวจสอบยอดส่วนเกิน เนื่องจากไม่มีค่าใช้จ่ายเพิ่มเติม',
    automation_PENDING: 'รอตรวจสอบ',
    automation_APPROVED: 'อนุมัติแล้ว',
    automation_WAIVED: 'ยกเว้นแล้ว',
    automation_reason: 'เหตุผล',
    automation_approve: 'อนุมัติยอดส่วนเกิน',
    automation_waive: 'ยกเว้นยอดส่วนเกินคงค้างทั้งหมด',
    automation_closure: 'ปิดงานที่เริ่มบริการแล้ว',
    automation_effectiveAt: 'เวลาสิ้นสุดบริการที่มีผล (เวลากรุงเทพฯ)',
    automation_preview: 'ดูผลก่อนปิดงาน',
    automation_confirmClosure: 'ยืนยันปิดงาน',
    automation_distanceWarning: 'เกณฑ์ตรวจสอบระยะทาง',
    automation_unevaluable: 'ข้อมูลไม่เพียงพอที่จะประเมิน',
    automation_exceeded: 'ถึงเกณฑ์แจ้งเตือนแล้ว',
    automation_withinThreshold: 'ยังไม่ถึงเกณฑ์',
    automation_planGrace: 'แผน + ระยะอนุโลม',
    automation_observedThreshold: 'ระยะที่ตรวจพบ / เกณฑ์แจ้งเตือน',
    automation_candidate: 'ยอดคงค้างที่คำนวณได้',
    automation_waived: 'ยอดคงค้างที่ยกเว้น',
    automation_noReceipt: 'การยกเว้นไม่ถือเป็นการรับเงิน',
    automation_evidence: 'หลักฐานการถึงจุดอัตโนมัติ',
    automation_attempts: 'การดำเนินการอัตโนมัติ',
    automation_ARRIVAL_PICKUP: 'ถึงจุดรับ',
    automation_ARRIVAL_DROPOFF: 'ถึงจุดส่ง',
    automation_PICKUP: 'รับผู้โดยสาร',
    automation_COMPLETION: 'จบงาน',
    automation_NOTIFYING: 'กำลังส่งแจ้งเตือน',
    automation_APPLIED: 'ดำเนินการแล้ว',
    automation_CANCELLED: 'ยกเลิกแล้ว',
    automation_FAILED: 'ต้องให้เจ้าหน้าที่ตรวจสอบ',
    automation_reviewBeforeBooking: 'เจ้าหน้าที่ต้องตรวจสอบให้เสร็จก่อนจองหรือเริ่มบริการงานถัดไป',
    automation_billingStart: 'เริ่มคิดระยะและเวลา',
    automation_billingEnd: 'สิ้นสุดคิดระยะและเวลา',
    automation_closeUnavailable: 'เฉพาะผู้ดูแลระบบสามารถปิดงานที่ยังดำเนินการอยู่ได้',

    reasonCurrentWording: 'ข้อความเหตุผลปัจจุบัน',
    traceBillingMixed: 'บางช่วงรวมในการคำนวณระยะทางจริง',
    tracePolicyLoading: 'กำลังโหลดนโยบายตำแหน่ง…',
    tracePolicyLoadFailed: 'โหลดนโยบายตำแหน่งไม่สำเร็จ',
    tracePolicySaveFailed: 'บันทึกนโยบายตำแหน่งไม่สำเร็จ',

    traceExportCsv: 'ส่งออก CSV ดิบ',
    traceExportGeojson: 'ส่งออก GeoJSON ดิบ',
    traceExportFailed: 'ส่งออกไม่สำเร็จหรือไม่มีสิทธิ์ส่งออก',
    traceException: 'ข้อยกเว้นตำแหน่ง',
    traceGapDetails: 'รายละเอียดช่วง GPS ขาดหาย',
    traceGap_TIME_GAP: 'ไม่มีข้อมูล GPS ต่อเนื่อง',
    traceGap_IMPLIED_SPEED: 'ตำแหน่ง GPS กระโดดผิดปกติ',
    traceGap_UNTRUSTED_POINT: 'จุด GPS ไม่น่าเชื่อถือ',
    traceGapSeconds: '{{count}} วินาที',
    traceGapInterval: 'ห่างจากจุดก่อนหน้า {{count}} วินาที',
    tracePolicy: 'นโยบายตำแหน่งงาน',
    traceRetentionDays: 'ระยะเก็บข้อมูลสำหรับงานใหม่ (วัน)',
    tracePickupRadius: 'รัศมีแจ้งเตือนจุดรับ (ม.)',
    traceDropoffRadius: 'รัศมีแจ้งเตือนจุดส่ง (ม.)',
    traceInheritProvider: 'เว้นรัศมีว่างเพื่อใช้ค่าของผู้ให้บริการ',
    traceRetentionHelp: '30–3650 วัน ใช้กับงานใหม่เท่านั้น ไม่เปลี่ยนวันหมดอายุเดิม รัศมี 50–10000 ม.',
    traceWarningActivation: 'เปิดใช้คำเตือนตำแหน่งสถานะ',
    traceWarningDependency: 'การเปิดคำเตือนต้องรอระบบประเมินเหตุการณ์และแอปเจ้าหน้าที่ที่รองรับ',
    traceSavePolicy: 'บันทึกนโยบายตำแหน่ง',
    tracePolicyInvalid: 'ระบุรัศมีเป็นจำนวนเต็ม 50–10000 ม. และระยะเก็บข้อมูล 30–3650 วัน',
    traceSaving: 'กำลังบันทึก…',
    traceSaved: 'บันทึกแล้ว',
    tracePolicyConflict: 'นโยบายนี้มีการเปลี่ยนแปลง กรุณาโหลดใหม่ก่อนบันทึก',
    traceReloadPolicy: 'โหลดนโยบายใหม่',

    traceLayers: 'ชั้นข้อมูลแผนที่',
    tracePlanned: 'เส้นทางที่วางแผน',
    tracePlannedShort: 'แผน',
    traceActual: 'เส้นทางที่เดินทางจริง',
    traceActualShort: 'เดินทาง',
    traceEvents: 'เหตุการณ์สถานะ',
    traceEventsShort: 'สถานะ',
    traceFit: 'แสดงเส้นทางทั้งหมด',
    traceMore: 'เครื่องมือเพิ่มเติม',
    traceLegend: 'ช่วงของเส้นทางจริง',
    tracePhasePickup: 'เดินทางไปรับ',
    tracePhaseOutbound: 'บริการขาไป',
    tracePhaseTransition: 'ช่วงเปลี่ยนผ่าน',
    tracePhaseCare: 'ดูแล',
    tracePhaseReturnWait: 'รอขากลับ',
    tracePhaseReturn: 'บริการขากลับ',
    traceBillingIncluded: 'รวมในการคำนวณระยะทางจริง',
    traceBillingExcluded: 'ไม่รวมในการคำนวณระยะทางจริง',
    traceBillingUnknown: 'ไม่ได้บันทึกการรวมคำนวณระยะทางจริง',
    traceLoading: 'กำลังโหลดเส้นทางจริง…',
    traceFailed: 'โหลดเส้นทางจริงไม่สำเร็จ กรุณาลองอีกครั้ง',
    traceAuthFailed: 'สิทธิ์การเข้าถึงเปลี่ยนแปลง ล้างข้อมูลตำแหน่งแล้ว',
    traceExpired: 'ข้อมูลตำแหน่งหมดอายุแล้ว ข้อมูลแผนการเดินทางยังคงอยู่',
    traceNoTrace: 'ไม่มีข้อมูลเส้นทาง GPS ที่บันทึกไว้สำหรับงานนี้',
    traceRetry: 'ลองอีกครั้ง',
    traceConnected: 'เชื่อมต่อสด',
    traceReconnecting: 'กำลังเชื่อมต่อใหม่ · ตรวจสอบข้อมูลล่าสุด',
    traceLastCapture: 'บันทึก GPS ล่าสุด',
    tracePointCounts: 'จุด GPS: รับแล้ว {{accepted}} จุด · แสดง {{returned}} จุด',
    traceCoverageStart: 'เริ่มบันทึกตำแหน่ง',
    traceCoverageEnd: 'สิ้นสุดการบันทึกตำแหน่ง',
    traceMaxGap: 'ช่วงขาดหายของ GPS ที่นานที่สุด',
    traceOverrideGps: 'GPS ไม่แม่นยำ',
    traceOverrideMeeting: 'จุดนัดพบไม่ถูกต้อง',
    traceOverridePassenger: 'ผู้โดยสารขอเปลี่ยนจุดนัดพบ',
    traceOverrideEmergency: 'เหตุฉุกเฉิน',
    traceOverrideOther: 'อื่น ๆ',
    traceOverrideUnknown: 'ไม่รู้จักเหตุผลการยืนยันตำแหน่ง',
    traceOverrideNote: 'หมายเหตุการยืนยันตำแหน่ง',
    traceTimelineLoading: 'กำลังโหลดเหตุการณ์สถานะ…',
    traceTimelineFailed: 'โหลดเหตุการณ์สถานะไม่สำเร็จ โปรดลองอีกครั้ง',
    traceTimelineEmpty: 'ยังไม่มีเหตุการณ์สถานะที่บันทึกไว้',
    traceOverflow: 'ข้อมูลเส้นทางเกินขีดจำกัดการแสดงผล ใช้การส่งออกข้อมูลดิบหากมีสิทธิ์ หรือเลือกเที่ยวอื่น',
    traceQuality: 'จำนวนตัวอย่างคุณภาพต่ำ',
    traceQualityDetails: 'คุณภาพเส้นทาง GPS',
    traceQualityReviewTitle: 'ควรตรวจสอบคุณภาพเส้นทาง',
    traceQualityHandledTitle: 'ระบบจัดการข้อมูล GPS ผิดปกติแล้ว',
    traceQualityUnknownTitle: 'ยังประเมินผลต่อค่าโดยสารไม่ได้',
    traceQualityReviewBody:
      'พบช่วงข้อมูล GPS ผิดปกติ {{count}} ช่วง ระบบไม่เชื่อมเส้นผ่านช่วงเหล่านี้เพื่อหลีกเลี่ยงการแสดงและคำนวณระยะทางที่ผิด',
    traceQualityImpactTitle: 'ผลกระทบ',
    traceQualityMapImpact: 'เส้นทางบนแผนที่',
    traceQualityMapImpactValue: 'ตัดการเชื่อมต่อ {{count}} ช่วงที่ข้อมูลไม่น่าเชื่อถือ',
    traceQualityDistanceImpact: 'ระยะทางจริง',
    traceQualityDistanceGps: 'คำนวณจากเฉพาะช่วง GPS ที่เชื่อถือได้ ช่วงที่ถูกตัดออกไม่ถูกนับ',
    traceQualityDistanceNotGps: 'ระยะทางจริงไม่ได้มาจาก GPS รายการเหล่านี้จึงไม่ได้กำหนดระยะทางจริง',
    traceQualityBillingImpact: 'ค่าโดยสาร',
    traceQualityBillingGps: 'การชำระใช้ระยะทาง GPS ควรตรวจเส้นทางเมื่อมีข้อโต้แย้งเรื่องระยะทางหรือค่าโดยสาร',
    traceQualityBillingPlanned: 'การชำระใช้ระยะทางตามแผน ไม่ได้ใช้ช่วง GPS ที่ผิดปกติเหล่านี้',
    traceQualityBillingUnknown: 'ไม่มีข้อมูลแหล่งระยะทางที่ใช้ชำระ ให้ตรวจสอบในแท็บค่าบริการ',
    traceQualityDistanceComparison: 'ตามแผน {{planned}} กม. · วัดจริง {{actual}} กม.',
    traceQualityNextTitle: 'ควรทำอะไรต่อ',
    traceQualityNextReview: 'หากมีข้อโต้แย้ง ให้เปรียบเทียบเส้นทางจริงกับแผนและเหตุการณ์รับ–ส่งก่อนยืนยันค่าใช้จ่าย',
    traceQualityNextNoAction:
      'ระบบตัดช่วงที่ไม่น่าเชื่อถือออกแล้ว ไม่ต้องดำเนินการเพิ่มเติมเว้นแต่มีข้อโต้แย้งเรื่องเส้นทางหรือค่าโดยสาร',
    traceQualityNextUnknown: 'ตรวจสอบแหล่งระยะทางในแท็บค่าบริการ หากมีข้อโต้แย้งให้เปรียบเทียบกับแผนและเหตุการณ์รับ–ส่ง',
    traceQualitySummaryTitle: 'สรุปข้อมูลผิดปกติ',
    traceQualityBillingWindowCount: 'มี {{count}} ช่วงอยู่ในช่วงที่ใช้คำนวณระยะทางจริง',
    traceQualityTechnicalTitle: 'รายละเอียดทางเทคนิค',
    traceQualityTechnicalHelp: 'ใช้เมื่อต้องวิเคราะห์ข้อมูล GPS หรือส่งต่อให้ทีมสนับสนุน',
    traceQualityFilterLabel: 'ประเภทความผิดปกติ',
    traceQualityFilterAll: 'ทั้งหมด ({{count}})',
    traceQualityTableTime: 'เวลาที่พบ',
    traceQualityTableType: 'ประเภท / ช่วงการเดินทาง',
    traceQualityTableMovement: 'ความผิดปกติ',
    traceQualityTablePosition: 'ตำแหน่ง GPS',
    traceQualityInsideBillingWindow: 'อยู่ในช่วงคำนวณระยะทางจริง',
    traceQualityOutsideBillingWindow: 'ไม่อยู่ในช่วงคำนวระยะทางจริง',
    traceQualityJumpDistance: 'ระยะทางระหว่างจุด {{distance}}',
    traceQualityImpliedSpeed: 'ความเร็วโดยประมาณ {{speed}} กม./ชม.',
    traceQualityMetersShort: 'ม.',
    traceQualityKmShort: 'กม.',
    traceQualityPositionFrom: 'จาก',
    traceQualityPositionTo: 'ไปที่',
    traceQualityAccuracy: 'ความแม่นยำ {{from}} → {{to}} ม.',
    traceNotRecorded: 'ไม่ได้บันทึก',
    traceGaps: 'ช่วงขาดหายของ GPS: {{count}} เส้นหยุดเมื่อข้อมูลขาดหายหรือไม่น่าเชื่อถือ',
    traceAllHidden: 'ซ่อนชั้นเส้นทางและเหตุการณ์ทั้งหมดแล้ว',
    traceEventDetail: 'รายละเอียดเหตุการณ์สถานะ',
    traceEventTime: 'เวลาเกิดเหตุการณ์',
    traceCaptureTime: 'เวลาบันทึก GPS',
    traceCoordinates: 'พิกัด',
    traceAccuracy: 'ความแม่นยำ',
    traceSource: 'แหล่งที่มาของตำแหน่ง',
    traceDirect: 'GPS โดยตรง',
    traceFallback: 'ใช้ GPS ใกล้เคียงแทน',
    traceInferred: 'อนุมานจาก GPS ใกล้เคียง',
    traceWarning: 'ผลการประเมินคำเตือน',
    traceDistance: 'ระยะห่างจากจุดเป้าหมาย',
    traceRadius: 'รัศมีแจ้งเตือน',
    traceOverride: 'เหตุผลที่ยืนยันดำเนินการ',
    traceMeters: '{{value}} ม.',
    traceViewEvent: 'ดูรายละเอียด',
    traceWarning_NONE: 'ไม่มีคำเตือน',
    traceWarning_OUTSIDE_RADIUS: 'อยู่นอกรัศมีแจ้งเตือน',
    traceWarning_LOCATION_UNAVAILABLE: 'ไม่มีข้อมูลตำแหน่ง',
    traceWarning_LOW_ACCURACY: 'GPS มีความแม่นยำต่ำ',

    routingOutbound: 'ผู้ให้บริการเส้นทางขาไป',
    routingReturn: 'ผู้ให้บริการเส้นทางขากลับ',
    routingUnknown: 'ไม่มีข้อมูลบันทึก',

    currentTitle: 'การเดินทางในเวลานี้',
    totalTrips: 'การเดินทางทั้งหมด',
    provider: 'ผู้ให้บริการ',
    serviceGroup: 'กลุ่มการให้บริการ',
    serviceArea: 'พื้นที่บริการ',
    dateRange: 'ช่วงเวลา',
    unassignedOnly: 'ยังไม่ได้มอบหมาย',
    jobsCount: '{{n}} งาน',

    // boards (FR-W-BOARD-010)
    boardInProgress: 'กำลังดำเนินการ',
    boardAdvance: 'นัดหมายล่วงหน้า',
    staffingQueueFilter: 'คิวจัดพนักงาน ({{n}})',
    staffingStateNOT_STARTED: 'พร้อมเริ่มจัดพนักงาน',
    staffingStateSEARCHING_AUTO: 'กำลังค้นหาอัตโนมัติ',
    staffingStateWAITING_MANUAL_ACCEPTANCE: 'รอพนักงานตอบรับ',
    staffingStateRETRY_NEEDED: 'ต้องค้นหาใหม่',
    staffingStateREADY: 'พร้อมเริ่มจัดพนักงาน',
    staffingUrgencyCritical: 'วิกฤต',
    staffingUrgencyWarning: 'ใกล้กำหนด',
    staffingUrgencyNormal: 'ปกติ',
    staffingTimeRemaining: 'เหลือ {{time}}',
    staffingSearchCount: 'ค้นหาแล้ว {{n}} ครั้ง',
    staffingDeadline: 'ต้องสำเร็จก่อน {{time}}',
    boardCompleted: 'เสร็จสิ้น',
    boardCancelled: 'ยกเลิก',
    advanceTitle: 'การเดินทางล่วงหน้า',
    completedTitle: 'การเดินทางที่เสร็จสิ้น',
    cancelledTitle: 'การเดินทางที่ยกเลิก',

    // job actions (FR-W-JOB-010/020)
    reassignTitle: 'เปลี่ยนเจ้าหน้าที่ที่ให้บริการ',
    reassignCurrent: 'เจ้าหน้าที่ปัจจุบัน: {{name}}',
    sendReassignOffer: 'ส่งคำขอให้ยืนยัน',
    reassignOfferPending: 'เจ้าหน้าที่เดิมยังรับผิดชอบงานนี้จนกว่าคนใหม่จะกดยอมรับคำขอ',
    reassignTripStarted: 'งานนี้เริ่มแล้วและไม่สามารถเปลี่ยนเจ้าหน้าที่ได้',
    offerTaken: 'พนักงานคนอื่นรับงานนี้แล้ว กรุณารีเฟรชเพื่อดูสถานะล่าสุด',
    offerExpired: 'คำขอนี้หมดเวลาแล้ว กรุณารีเฟรชเพื่อดูสถานะล่าสุด',
    offerAlreadyResolved: 'คำขอนี้ถูกดำเนินการแล้ว กรุณารีเฟรชเพื่อดูสถานะล่าสุด',
    editJobTitle: 'แก้ไขรายละเอียดงาน',
    editPlacesRequired: 'กรุณาระบุจุดเริ่มต้นและจุดหมาย',
    editConflict: 'ข้อมูลถูกแก้ไขโดยผู้ใช้ท่านอื่น กรุณาโหลดข้อมูลล่าสุดแล้วแก้ไขอีกครั้ง',
    editReload: 'โหลดข้อมูลล่าสุด',

    // board columns
    jobRef: 'เลขอ้างอิงงาน',
    searchJobRef: 'ค้นหาด้วยเลขอ้างอิงงาน',
    colCreated: 'วันเวลาที่สร้างงาน',
    colScheduledFor: 'วันเวลานัดหมาย',
    colPerformed: 'วันเวลาที่ดำเนินการ',
    colCancelledBy: 'ยกเลิกโดย',
    colCancelledAt: 'ยกเลิกเมื่อ',
    colCancelReason: 'เหตุผลการยกเลิก',
    startsInDays: 'ในอีก {{n}} วัน',
    startsToday: 'ภายในวันนี้',
    colPassenger: 'ผู้โดยสาร',
    colLocation: 'สถานที่',
    colDriver: 'พนักงาน',
    colStatus: 'สถานะ',
    colChat: 'ข้อความ',
    colPassengerName: 'ชื่อผู้โดยสาร',
    driverRole: 'พนักงาน',
    searchingStaff: 'ค้นหาพนักงาน',
    dispatchFailedPill: 'จัดสรรไม่สำเร็จ',
    elapsedAgo: 'ผ่านมาแล้ว {{t}}',
    inAnother: 'ในอีก {{t}}',
    minutesShort: 'น',
    hoursShort: 'ชม',

    // trip statuses (ENUM-TRIP-STATUS)
    stDraft: 'ฉบับร่าง',
    stUnassigned: 'ยังไม่ได้มอบหมาย',
    stScheduled: 'รอเริ่มงาน',
    stAssigned: 'รับงาน',
    stAwaitingPayment: 'รอการชำระเงิน',
    stEnRoutePickup: 'กำลังไปรับ',
    stArrivedPickup: 'ถึงจุดรับ',
    stInProgress: 'กำลังไปส่ง',
    stArrivedDropoff: 'ถึงจุดส่ง',
    stCareGivingStart: 'กำลังดูแล',
    stCareGivingFinish: 'ดูแลเสร็จแล้ว',
    stReturnWaiting: 'รอเดินทางกลับ',
    stReturnRiding: 'กำลังเดินทางกลับ',
    stReturnDropping: 'ถึงจุดส่ง (ขากลับ)',
    stCompleted: 'เสร็จสมบูรณ์',
    stAwaitingOverage: 'รอชำระส่วนเกิน',
    stCancelled: 'ยกเลิก',
    stMissed: 'พลาดการเดินทาง',

    // service-mode badges (fixed color taxonomy)
    modeRideCare: 'รับส่ง + ดูแล',
    modeCare: 'ดูแล',
    modeRide: 'รับส่ง',
    modeTravel: 'เดินทาง',

    // detail panel
    aboutTrip: 'เกี่ยวกับการเดินทางนี้',
    currentStatus: 'สถานะปัจจุบัน',
    updatedAgo: 'อัพเดทเมื่อ {{t}}ที่แล้ว',
    step: 'ขั้นตอน',
    lifecycleElapsed: 'เวลาตั้งแต่สร้างงาน',
    statusElapsed: 'อยู่ในสถานะนี้มา {{t}}',
    statusEnteredAt: 'เข้าสถานะเมื่อ {{time}}',
    statusClosedAt: 'ปิดงานเมื่อ {{time}}',
    statusCancelledAt: 'ยกเลิกเมื่อ {{time}}',
    statusMissedAt: 'พลาดงานเมื่อ {{time}}',
    statusAtMeeting: 'ถึงจุดนัดพบ',
    statusContextDraft: 'ฉบับร่างนี้ยังไม่เข้าสู่การจัดพนักงาน',
    statusContextUnassigned: 'ยังไม่มีพนักงานรับงานนี้',
    statusContextSearching: 'กำลังค้นหาพนักงาน',
    statusContextScheduledReady: 'มีพนักงานรับงานแล้ว รอเริ่มบริการตามนัดหมาย',
    statusContextScheduledUnassigned: 'ยังรอจัดพนักงานสำหรับนัดหมายนี้',
    statusContextAssigned: 'พนักงานรับงานแล้ว รอเริ่มเดินทาง',
    statusContextTravelToPickup: 'พนักงานกำลังเดินทางไปจุดรับผู้โดยสาร',
    statusContextTravelToMeeting: 'พนักงานกำลังเดินทางไปจุดนัดพบ',
    statusContextAwaitPickup: 'ถึงจุดรับแล้ว รอรับผู้โดยสาร',
    statusContextArrivedMeeting: 'ถึงจุดนัดพบแล้ว รอเริ่มดูแล',
    statusContextTravelToDropoff: 'กำลังพาผู้โดยสารเดินทางไปจุดส่ง',
    statusContextBeginCare: 'รอพนักงานเริ่มดูแล',
    statusContextCare: 'กำลังให้การดูแล',
    statusContextBeginReturn: 'รอเริ่มเดินทางกลับ',
    statusContextReturnTravel: 'กำลังเดินทางขากลับ',
    statusContextConfirmFinish: 'รอพนักงานยืนยันจบการให้บริการ',
    statusContextPaymentPending: 'รอลูกค้าชำระเงินหรือส่งหลักฐานการชำระเงิน',
    statusContextPaymentProof: 'มีหลักฐานรอเจ้าหน้าที่ตรวจสอบ ยังไม่ถือว่ายืนยันรับเงินแล้ว',
    statusContextPaymentRejected: 'หลักฐานถูกปฏิเสธ รอลูกค้าส่งใหม่',
    statusContextPaymentUnknown: 'ข้อมูลการชำระเงินยังไม่พร้อม โปรดตรวจสอบรายการชำระเงิน',
    statusContextPartnerPayment: 'พาร์ทเนอร์รับผิดชอบการชำระเงิน ไม่เรียกเก็บจากผู้โดยสาร',
    statusContextServiceFinished: 'จบการให้บริการแล้ว ยังอยู่ระหว่างจัดการยอดส่วนเกิน',
    statusContextOverageReview: 'รอเจ้าหน้าที่ตรวจสอบส่วนเกินก่อนยืนยันยอดเรียกเก็บ',
    statusContextMissed: 'ไม่ได้เริ่มให้บริการ ดูรายละเอียดที่มีบันทึกในเส้นเวลา',
    statusContextMissedDispatch: 'การค้นหาพนักงานสิ้นสุดโดยไม่มีผู้ตอบรับงาน',
    statusViewPayment: 'ดูการชำระเงิน',
    statusViewDispatch: 'ดูการจัดพนักงาน',
    statusPaymentDueBy: 'กำหนดชำระ: {{time}}',
    servicePlanAndResults: 'แผนและผลการให้บริการ',
    plannedServiceDuration: 'เวลาบริการตามแผน',
    totalDistance: 'ระยะทางทั้งหมด',
    jobDetails: 'รายละเอียดงาน',
    creationChannel: 'ช่องทางสร้างงาน',
    creationChannelWeb: 'เว็บไซต์',
    creationChannelMobileApp: 'แอปมือถือ',
    creationChannelPartnerApi: 'พาร์ทเนอร์ API',
    creationChannelUnknown: 'ไม่ทราบ',
    originLabel: 'จุดเริ่มต้น',
    destinationLabel: 'จุดปลายทาง',
    destinationShort: 'จุดหมาย',
    pickupAppt: 'เวลานัดรับตัว',
    tabMapTimeline: 'แผนที่และเส้นเวลา',
    tabFare: 'ค่าบริการ',
    tabChat: 'ข้อความ',
    tabNotes: 'บันทึกภายใน',
    tabRatings: 'เรทติ้ง',
    options: 'ตัวเลือก',
    confirmPayment: 'ยืนยันการชำระเงิน',
    changeStaff: 'เปลี่ยนเจ้าหน้าที่ที่บริการ',
    cancelTrip: 'ยกเลิก',
    cancelTripTitle: 'ยกเลิกการเดินทาง',
    cancelReason: 'เหตุผล',
    internalCancellationReason: 'เหตุผลภายในสำหรับการยกเลิก',
    passengerCancellationReason: 'เหตุผลที่แจ้งผู้โดยสาร',
    passengerCancellationReasonFallback: 'การจองนี้ถูกยกเลิก กรุณาติดต่อเจ้าหน้าที่หากต้องการความช่วยเหลือ',
    staffingQueueActions: 'คิวจัดพนักงาน',
    staffingQueueStart: 'เริ่มจัดหาพนักงาน',
    staffingQueueRetry: 'ค้นหาใหม่',
    staffingQueueViewSearch: 'ดูการค้นหา',
    staffingQueueDialogLabel: 'คิวจัดพนักงานสำหรับงาน {{ref}}',
    staffingQueueCloseHint: 'การปิดหน้าต่างนี้จะไม่หยุดการค้นหาพนักงาน',
    noteLabel: 'บันทึก',
    roundTrip: 'ไป-กลับ',
    oneWay: 'เที่ยวเดียว',
    freeService: 'ให้บริการฟรี',
    noFareYet: 'ยังไม่มีค่าโดยสาร',
    noMessages: 'ยังไม่มีข้อความ',
    noNotes: 'ยังไม่มีบันทึกภายใน',
    notesPlaceholder: 'เพิ่มบันทึกภายใน (เจ้าหน้าที่เห็นเท่านั้น)…',
    notesAdd: 'บันทึก',
    noRatings: 'ยังไม่มีเรทติ้ง',

    // ratings (เรทติ้ง) — FR-W-RATE-010
    ratingGiverPassenger: 'ลูกค้า',
    ratingGiverAgent: 'เจ้าหน้าที่',
    ratingNoComment: 'ไม่มีความคิดเห็นเพิ่มเติม',
    ratingStarsAria: '{{n}} ดาว',
    // Positive-tag vocabulary — mirrors the mobile `ratingTag*` l10n keys. An
    // unknown tag is an operator-authored reason label and renders verbatim.
    ratingTagPolite: 'มีมารยาท',
    ratingTagProfessional: 'เป็นมืออาชีพ',
    ratingTagPunctual: 'ตรงต่อเวลา',
    ratingTagGoodDriving: 'ขับรถดี',
    ratingTagAttentive: 'ดูแลเอาใจใส่',
    ratingTagWellDressed: 'แต่งกายสุภาพ',

    // chat (ข้อความ) — FR-W-CHAT-010
    chatSend: 'ส่ง',
    chatSending: 'กำลังส่ง…',
    chatPlaceholder: 'พิมพ์ข้อความ…',
    chatAttachImage: 'แนบรูปภาพ',
    chatSystemMessage: 'ข้อความระบบ',
    chatPaymentTitle: 'รายละเอียดการชำระเงิน',
    chatBankName: 'ธนาคาร',
    chatAccountNo: 'เลขที่บัญชี',
    chatAccountName: 'ชื่อบัญชี',
    chatAmount: 'จำนวนเงิน',
    chatDeadline: 'ชำระภายใน',
    chatWindowClosed: 'ปิดการสนทนาแล้ว (เกิน 24 ชั่วโมงหลังการเดินทางเสร็จสิ้น)',
    chatNoMessages: 'ยังไม่มีข้อความ',
    chatLoadEarlier: 'โหลดข้อความก่อนหน้า ({{count}})',
    chatImageAlt: 'รูปภาพในการสนทนา',
    chatImageTitle: 'รูปภาพในการสนทนา',
    paid: 'ชำระแล้ว',
    outstanding: 'ค้างชำระ',

    // payment verify queue + records (FR-W-PAY-010 / RULE-PAY-020/030)
    slipQueueBadge: 'รอตรวจสลิป',
    amendmentDelivery_BOOKING_AMENDMENT_APPLIED: 'แก้ไขการจองแล้ว',
    amendmentDelivery_AMENDMENT_OFFER_AVAILABLE: 'ข้อเสนอสำหรับคนขับ',
    amendmentDelivery_AMENDMENT_REPLACEMENT_CONSENT: 'ขอความยินยอมหาคนขับทดแทน',
    amendmentDelivery_AMENDMENT_PAYMENT_REQUIRED: 'ชำระเงินเพิ่ม',
    amendmentDelivery_AMENDMENT_PROOF_REVIEW: 'ตรวจหลักฐานชำระเงิน',
    amendmentDelivery_AMENDMENT_PROOF_REJECTED: 'ปฏิเสธหลักฐาน',
    amendmentDelivery_AMENDMENT_CLOSED: 'ปิดคำขอ',
    amendmentDelivery_PASSENGER: 'ผู้โดยสาร',
    amendmentDelivery_OPERATOR: 'เจ้าหน้าที่',
    amendmentDelivery_OFFER_AGENT: 'คนขับที่ได้รับข้อเสนอ',
    amendmentDelivery_ACCEPTED_AGENT: 'คนขับที่ตอบรับ',
    amendmentDelivery_PREVIOUS_AGENT: 'คนขับเดิม',
    amendmentDelivery_RELEASED_AGENT: 'คนขับที่ยกเลิกข้อเสนอ',
    amendmentDelivery_ACCEPTED: 'ผู้ให้บริการรับข้อความแล้ว',
    amendmentDelivery_NO_DEVICE: 'ไม่มีอุปกรณ์รับแจ้งเตือน',
    amendmentDelivery_DISABLED: 'ปิดการส่งแจ้งเตือน',
    amendmentDelivery_FAILED: 'ส่งไม่สำเร็จ',
    amendmentDelivery_SUPPRESSED: 'ระงับการส่ง',
    amendmentDelivery_TRANSPORT_LIMIT_REACHED: 'ครบจำนวนครั้งหรือหมดเวลาส่ง',
    amendmentDelivery_SYNTHETIC_DELIVERY_DISABLED: 'ปิดการส่งข้อมูลจำลอง',
    amendmentDelivery_UNKNOWN: 'ไม่มีข้อมูล',
    amendmentDelivery_empty: 'ไม่มีรายการการส่งแจ้งเตือนที่รอตรวจสอบ',
    amendmentDelivery_title: 'ตรวจสอบการส่งแจ้งเตือน',
    amendmentDelivery_explanation:
      'การรับทราบจะปิดรายการตรวจสอบนี้ ไม่ส่งข้อความซ้ำ ไม่ยืนยันว่าผู้รับได้รับข้อความ และไม่เปลี่ยนการจองหรือการชำระเงิน',
    amendmentDelivery_reason: 'เหตุผล: {{reason}} · ผลการส่ง: {{outcome}} · จำนวนครั้ง: {{attempts}}',
    amendmentDelivery_acknowledge: 'รับทราบปัญหาการส่ง',
    amendmentDelivery_more: 'ยังมีรายการเพิ่มเติม เมื่อจัดการรายการนี้แล้ว ระบบจะแสดงรายการถัดไป',
    amendmentQueue_title: 'ตรวจคำขอแก้ไขการจอง (ทุกสถานะงาน)',
    slipQueueFilter: 'รอตรวจสลิป ({{n}})',
    paymentKind: 'ประเภทการชำระเงิน',
    paymentKindBase: 'ค่าบริการตั้งต้น',
    paymentKindOverage: 'ค่าบริการส่วนเกิน',
    payStatusPendingSlip: 'รอสลิป',
    payStatusSlipSubmitted: 'รอตรวจสลิป',
    payStatusVerified: 'ยืนยันแล้ว',
    payStatusRejected: 'สลิปไม่ผ่าน',
    payStatusWaived: 'ยกเว้นแล้ว',
    payStatusRefundPending: 'รอดำเนินการคืนเงิน',
    payStatusRefunded: 'คืนเงินแล้ว',
    payCheckGotProof: 'ได้รับหลักฐานการชำระเงิน',
    payCheckAmountMatches: 'ตรวจสอบยอดเงินถูกต้อง',
    payCheckFoundInAccount: 'พบรายการเงินเข้าในบัญชี',
    amountDue: 'ยอดที่ต้องชำระ',
    amountReceivedLabel: 'จำนวนเงินที่ได้รับ',
    paymentDueBy: 'กำหนดชำระภายใน',
    paymentRecords: 'บันทึกการชำระเงิน',
    refundAmount: 'ยอดคืนเงิน',
    partnerPaymentManaged: 'การชำระเงินของพาร์ทเนอร์',
    partnerPaymentManagedBody: 'พาร์ทเนอร์และผู้ให้บริการจัดการภายนอกระบบ',
    partnerRefundApproved: 'ยอดอนุมัติคืนเงิน (บาท)',
    partnerRefundUndecided: 'ยังไม่บันทึกการตัดสินใจ',
    partnerRefundPending: 'ยอดรอคืนเงิน (บาท)',
    partnerRefundActual: 'ยอดคืนเงินจริง (บาท)',
    partnerRecordAmount: 'จำนวนเงิน (บาท); การตัดสินใจใช้ยอดอนุมัติรวม ระบุ 0 หากไม่คืนเงิน',
    partnerRecordReceipt: 'บันทึกรับเงินภายนอก',
    partnerRecordDecision: 'บันทึกการตัดสินใจคืนเงิน',
    partnerRecordRefund: 'บันทึกคืนเงินจริงภายนอก',
    refundExternalReference: 'เลขอ้างอิงการคืนเงินภายนอก',
    refundNote: 'บันทึกการคืนเงิน',
    markRefunded: 'บันทึกว่าคืนเงินแล้ว',
    verificationLog: 'ประวัติการตรวจสอบ',
    partialPaymentHint: 'รับบางส่วน — งานจะยังไม่เดินต่อจนกว่าจะชำระครบ',
    waiveRemainder: 'ยกเว้นยอดคงเหลือ (ปล่อยงานให้เดินต่อ)',
    rejectSlip: 'สลิปไม่ถูกต้อง',
    rejectSlipTitle: 'ปฏิเสธสลิปการชำระเงิน',
    rejectSlipHint: 'ระบบจะแจ้งผู้โดยสารให้ส่งสลิปใหม่ และงานจะยังคงรอชำระเงิน',
    rejectReasonLabel: 'เหตุผล',
    slipImageAlt: 'สลิปการชำระเงิน',
    slipImageTitle: 'สลิปการชำระเงิน',
    promptPayQrTitle: 'QR PromptPay',
    promptPayQrAlt: 'คิวอาร์โค้ดชำระเงิน PromptPay',
    promptPayRecipient: 'ผู้รับเงิน',
    promptPayValue: 'ปลายทาง PromptPay',
    promptPayGeneratedAt: 'สร้างเมื่อ',
    promptPayVerifyWarning: 'ตรวจสอบชื่อผู้รับเงินใน Mobile Banking ก่อนชำระเงิน',
    promptPayOpenAmountInstruction: 'QR นี้ไม่ระบุยอด กรุณากรอก {{amount}} บาทใน Mobile Banking',
    promptPayDownload: 'ดาวน์โหลด PNG',

    // timeline
    colDateTime: 'วัน-เวลา',
    colDuration: 'ระยะเวลา',
    colBy: 'โดย',
    evCreated: 'สร้างการเดินทาง',
    evAssigned: 'มอบหมายงาน',
    evAccepted: 'รับงาน',
    evStarted: 'เริ่มงาน',
    evArrivedPickup: 'ถึงจุดรับตัว',
    evPickedUp: 'รับผู้โดยสารแล้ว',
    evArrivedDropoff: 'ถึงจุดส่งตัว',
    evCareStarted: 'เริ่มดูแล',
    evCareFinished: 'ดูแลเสร็จ',
    evReturnStarted: 'เริ่มเดินทางกลับ',
    evReturnPickedUp: 'รับขึ้นรถ (ขากลับ)',
    evReturnArrivedDropoff: 'ถึงจุดส่ง (ขากลับ)',
    evCompleted: 'เสร็จสมบูรณ์',
    evPaymentVerified: 'ยืนยันการชำระเงิน',
    evPaymentRejected: 'ปฏิเสธสลิปการชำระเงิน',
    evEdited: 'แก้ไขรายละเอียดงาน',
    evReassigned: 'เปลี่ยนเจ้าหน้าที่',
    evCancelled: 'ยกเลิกงาน',
    evAgentWithdrew: 'พนักงานที่รับงานถอนตัว',
    evDispatchFailed: 'จัดสรรไม่สำเร็จ — ไม่พบพนักงาน',
    subCreated: 'รอมอบหมายงาน',
    subAssigned: 'รอการรับงาน',
    subAccepted: 'รอเริ่มงาน',
    subStarted: 'กำลังไปรับ',
    subArrivedPickup: 'รอผู้โดยสาร',
    subPickedUp: 'กำลังไปส่ง',
    actorOfficer: 'เจ้าหน้าที่ประจำศูนย์',
    actorAgent: 'พนักงาน',
    actorPassenger: 'ผู้เรียกบริการ',
    actorSystem: 'ระบบ',
    actorPartner: 'พาร์ตเนอร์',
    actorUnknown: 'ไม่ทราบผู้ดำเนินการ',
    durationDHM: '{{d}} วัน {{h}} ชั่วโมง {{m}} นาที',

    // create modal
    createTitle: 'สร้างการเดินทางใหม่',
    stepOf: 'ขั้นที่ {{a}} จาก {{b}}',
    passengerInfo: 'ข้อมูลผู้โดยสาร',
    resetAll: 'เริ่มต้นใหม่ทั้งหมด',
    recentCalls: 'การเรียกบริการล่าสุด',
    recentCallsHint: 'กดเพื่อนำเส้นทางทั้งหมดกลับมาใช้',
    searchPassenger: 'ค้นหาผู้โดยสารที่เกี่ยวข้องด้วยชื่อ หรือกรอกหมายเลขโทรศัพท์ให้ครบ',
    addPassengerWithPhone: 'เพิ่มผู้โดยสารใหม่ด้วยหมายเลขโทรศัพท์ "{{phone}}"',
    newPassengerTitle: 'ผู้โดยสารใหม่',
    duplicatePhone: 'หมายเลขโทรศัพท์ซ้ำ',
    bookingReadinessChecking: 'กำลังตรวจสอบสถานะการชำระเงิน…',
    bookingReadinessUnavailable: 'ไม่สามารถยืนยันได้ว่าลูกค้าสร้างงานได้หรือไม่ กรุณารีเฟรชก่อนดำเนินการต่อ',
    bookingDebtTitle: 'ไม่สามารถสร้างงานได้ เนื่องจากมียอดค้างชำระ',
    bookingDebtVisibleSummary: 'ลูกค้ามียอดค้างชำระกับผู้ให้บริการของคุณ {{amount}} บาท',
    bookingDebtHiddenMessage:
      'ไม่สามารถสร้างงานนี้ได้ เนื่องจากลูกค้ามียอดค้างชำระใน CabGo กรุณาแจ้งให้ลูกค้าเปิด CabGo เพื่อชำระเงินหรือตรวจสอบสถานะ',
    bookingDebtMixedMessage: 'ลูกค้ายังต้องดำเนินการเพิ่มเติมใน CabGo การชำระเฉพาะรายการที่แสดงอาจยังไม่ทำให้สร้างงานได้',
    bookingDebtRefresh: 'รีเฟรชสถานะการชำระเงิน',
    bookingDebtOpenTrip: 'เปิดงาน {{ref}}',
    fareSummary: 'สรุปค่าบริการ',
    fareCalculatedAt: 'คำนวณ ณ {{time}}',
    fareUsageSummary: 'ระยะทางที่ใช้ทั้งหมด {{distance}} กม. · ระยะเวลาที่ใช้ทั้งหมด {{time}} ชม.',
    fareHint: 'เมื่อเริ่มต้นกรอกข้อมูล ระบบจะคำนวณระยะทาง รวมถึงระยะเวลาการทำงานให้โดยอัตโนมัติ',
    quoteComputing: 'กำลังคำนวณราคา…',
    quoteRetry: 'คำนวณราคาใหม่',
    quoteOutOfAreaConfirm: 'ยืนยันขอราคานอกพื้นที่',
    bookingResultUnknown: 'ยังยืนยันผลการจองไม่ได้ กรุณาตรวจสอบผลการจองเดิมอีกครั้งก่อนเริ่มรายการใหม่',
    bookingRetryResult: 'ตรวจสอบผลการจองอีกครั้ง',
    bookingSubmitting: 'กำลังตรวจสอบผลการจอง…',
    bookingOpenOriginal: 'เปิดงานที่จองไว้',
    bookingRecoveryChecking: 'กำลังตรวจสอบข้อมูลการจองที่บันทึกไว้…',
    bookingRecoveryLoadError:
      'เปิดข้อมูลการจองเดิมไม่ได้ กรุณาลองอีกครั้ง หากยังมีปัญหาให้ตรวจสอบรายการงานในแท็บอื่นก่อนเริ่มรายการใหม่',
    bookingRecoverySaveError: 'บันทึกข้อมูลเพื่อกู้คืนการจองไม่ได้ กรุณาลองอีกครั้งก่อนส่งจอง',
    bookingRecoveryRetry: 'ลองบันทึกหรือกู้คืนอีกครั้ง',
    bookingRecoveryRestored: 'กู้คืนข้อมูลการจองแล้ว กรุณาตรวจสอบข้อมูลและราคาล่าสุดก่อนยืนยัน',
    bookingRecoveryDiscard: 'ทิ้งแบบร่างและเริ่มใหม่',
    bookingRecoveryInspectTrips: 'เปิดรายการงานในแท็บอื่น',
    bookingRetryMismatchUnresolved:
      'พบหลักฐานการจองเดิมที่ไม่ตรงกัน กรุณาเปิดรายการงานในแท็บอื่นเพื่อตรวจสอบก่อนเริ่มรายการใหม่',
    quoteRefreshedReview: 'คำนวณเส้นทางและราคาใหม่แล้ว กรุณาตรวจสอบและยืนยันอีกครั้ง',
    confirmRefreshedFare: 'ยืนยันราคาล่าสุดและสร้างงาน',
    quoteUnavailable: 'ขอราคาไม่สำเร็จ กรุณาลองอีกครั้ง',
    quoteRequired: 'กรุณารอราคาล่าสุดก่อนสร้างงาน หากราคาหมดอายุให้คำนวณใหม่',
    bookingAdvanceWindow: 'จองล่วงหน้าได้สูงสุด {{days}} วัน · เลือกเวลาเริ่มงานได้ถึง {{time}}',
    computingRoute: 'กำลังคำนวณเส้นทาง…',
    routeRetry: 'คำนวณเส้นทางไม่สำเร็จ ลองอีกครั้ง',
    quoteExpiredRefresh: 'ราคานี้หมดอายุแล้ว กรุณาตรวจสอบเส้นทางและราคาใหม่ก่อนสร้างงาน',
    editRouteUnavailable: 'คำนวณเส้นทางไม่สำเร็จ กรุณาลองอีกครั้ง',
    fareTotals:
      'ระยะทางขาไป – {{out}} กม. ระยะทางขากลับ – {{back}} กม. รวม {{total}} กม. ระยะเวลาการทำงานรวม {{time}}',
    baseFare: 'ค่าบริการพื้นฐาน',
    baseFareBasis: 'รวม {{km}} กม. แรก และ {{h}} ชั่วโมงแรก',
    overageDistance: 'ส่วนเกิน – ระยะทาง',
    overageDistanceBasis: 'ระยะทางเกิน {{km}} กม. × {{rate}} บาท/กม.',
    overageTime: 'ส่วนเกิน – ระยะเวลาทำงาน',
    overageTimeBasis: 'เวลาเกินจริง {{actual}} ชม. · คิดเป็น {{billed}} ชม. × {{rate}} บาท/ชม.',
    distanceFare: 'ค่าบริการตามระยะทาง',
    timeFare: 'ค่าบริการตามระยะเวลาทำงาน',
    tierUnitBasis: '{{quantity}} {{unit}} × {{rate}} บาท/{{unit}}',
    tierFlatBasis: 'ช่วง {{from}}–{{to}} {{unit}}: {{rate}} บาท',
    noCharge: 'ไม่มีค่าบริการ',
    totalFare: 'รวมค่าบริการทั้งหมด',
    baht: 'บาท',
    placeAndTime: 'สถานที่และวันเวลา',
    meetingPoint: 'จุดนัดหมาย',
    pricingPackage: 'แพกเกจค่าบริการ',
    routeShareLabel: 'แบ่งปันเส้นทาง',
    routeShareAllow: 'อนุญาต',
    routeShareDeny: 'ไม่อนุญาต',
    startDateTime: 'วันและเวลาเริ่มงาน',
    endDateTime: 'วันและเวลาเสร็จงาน',
    invalidBookingTime: 'กรุณาเลือกเวลาเริ่มในอนาคต และให้เวลาสิ้นสุดอยู่หลังเวลาเริ่ม',
    additionalInfo: 'ข้อมูลเพิ่มเติม',
    followerCount: 'จำนวนผู้ติดตาม',
    none: 'ไม่มี',
    equipmentLabel: 'อุปกรณ์',
    legOut: 'ขาไป',
    legBack: 'ขากลับ',
    rights: '{{n}} สิทธิ์',
    unlimitedRights: 'ไม่จำกัด',
    entitlementExhausted: 'ใช้สิทธิ์เต็มแล้ว',
    instantBadge: 'ทันที',
    bookingTiming: 'รูปแบบเวลา',
    bookingInstant: 'ทันที',
    bookingAdvance: 'ล่วงหน้า',
    bookingNowHint: 'เริ่มทันที',
    bookingRecipientChoice: 'ผู้รับบริการ',
    roundingNote: 'ค่าบริการแต่ละรายการปัดเป็นบาทเต็ม และจัดสรรเศษให้ตรงกับยอดรวม',
    bookingRecipientSelf: 'ผู้รับบริการเป็นผู้จอง',
    bookingRecipientOther: 'จองให้ผู้อื่น',
    bookingRecipientName: 'ชื่อผู้รับบริการจริง',
    bookingRecipientPhone: 'เบอร์โทรผู้รับบริการจริง',
    bookingRecipientRequired: 'กรุณาระบุชื่อและเบอร์โทรผู้รับบริการจริงให้ครบถ้วน',
    bookingRecipientOwnerHint: 'บัญชีผู้จองยังรับแจ้งเตือน ชำระเงิน และใช้สิทธิ์ตามกฎเดิม',
    bookingAccountLabel: 'ผู้จอง',
    bookingRecipientLabel: 'ผู้รับบริการจริง',
    bookingNoteLabel: 'หมายเหตุ',
    bookingNotePlaceholder: 'ข้อมูลเพิ่มเติมสำหรับเจ้าหน้าที่ (ถ้ามี)',
    bookOutOfAreaWarning: 'จุดรับอยู่นอกพื้นที่ให้บริการของบริการนี้ กดยืนยันเพื่อจองนอกพื้นที่ ระบบจะบันทึกไว้ในประวัติการเดินทาง',
    bookOutOfAreaConfirm: 'ยืนยันจองนอกพื้นที่',

    // step 3 — assignment
    assignAuto: 'มอบหมายงานอัตโนมัติ',
    chooseSelf: 'เลือกพนักงานเอง',
    searchingStaffSpinner: 'กำลังค้นหาพนักงาน',
    assignManual: 'มอบหมายงานด้วยตัวเอง',
    autoAssign: 'มอบหมายอัตโนมัติ',
    confirmAutoTitle: 'เริ่มมอบหมายอัตโนมัติหรือไม่',
    confirmAutoBody: 'ระบบจะส่งข้อเสนอให้พนักงานหลังจากยืนยันเท่านั้น',
    confirmAutoAssign: 'ยืนยันมอบหมายอัตโนมัติ',
    // confirm assigning a driver who is not currently available (presence ∉ FREE/ON_DUTY)
    confirmAssignTitle: 'ยืนยันการมอบหมายงาน',
    confirmAssignUnavailableBody:
      '{{name}} ขณะนี้ไม่ว่างรับงาน (สถานะ: {{status}}) ต้องการมอบหมายงานให้พนักงานคนนี้ต่อไปหรือไม่',
    confirmAssignAnyway: 'มอบหมายต่อไป',
    // MANUAL assign rejected by the hard skill gate (stale data / direct API call)
    assignSkillDenied: 'ไม่สามารถมอบหมายงานได้ เนื่องจากพนักงานขาดทักษะ: {{skills}}',
    assignSkillDeniedGeneric: 'ไม่สามารถมอบหมายงานได้ เนื่องจากพนักงานมีทักษะไม่ครบตามที่งานกำหนด',
    assignTimeConflict: 'ไม่สามารถมอบหมายได้ เนื่องจากพนักงานมีงานในช่วงเวลานี้แล้ว',
    assignDriverUnavailable: 'ไม่สามารถมอบหมายได้ เนื่องจากพนักงานกำลังปฏิบัติงานอื่น',
    assignmentStateChanged: 'สถานะงานเปลี่ยนแล้ว กรุณารอการตรวจสอบข้อมูลล่าสุด',
    assignTripAlreadyWon: 'งานนี้ถูกมอบหมายให้พนักงานคนอื่นแล้ว',
    candidateTimeConflict: 'ติดงานช่วงเวลานี้',
    candidateTimeConflictRange: '{{start}} – {{end}}',
    editTimeConflict: 'ไม่สามารถบันทึกได้ เนื่องจากพนักงานมีงานในช่วงเวลานี้แล้ว',
    // presence labels for the confirm dialog
    presenceOnDuty: 'กำลังทำงาน',
    presenceFree: 'ว่าง',
    presenceBreak: 'พัก',
    presenceOffline: 'ออฟไลน์',
    presenceUnknown: 'ไม่ทราบสถานะ',
    candidateAvailable: 'ว่าง',
    candidateReasonACTIVE_TRIP: 'กำลังปฏิบัติงาน',
    candidateReasonSCHEDULE_OVERLAP: 'ตารางงานซ้อน',
    candidateReasonSTALE_LOCATION: 'ไม่ได้รับตำแหน่งล่าสุด',
    candidateListUpdated: 'รายชื่อพนักงานมีการเปลี่ยนแปลง กรุณาเลือกพนักงานอีกครั้ง',
    candidateRefreshFailed: 'อัปเดตรายชื่อไม่สำเร็จ กรุณาลองอีกครั้ง',
    candidateSelectionStale: '{{name}} ไม่ว่างแล้ว กรุณารีเฟรชหรือเลือกพนักงานคนอื่น',
    candidateSearchLabel: 'ค้นหาพนักงาน',
    candidateSearchPlaceholder: 'ชื่อ นามสกุล หรือเบอร์โทรบางส่วน',
    candidateSearchScope: 'ค้นรวมพนักงานที่ไม่ผ่านเงื่อนไขภายในขอบเขตสิทธิ์ โดยไม่ใช้ตัวกรองออนไลน์และว่าง',
    candidateSearchClear: 'กลับไปรายชื่อแนะนำ',
    candidateSearchLoading: 'กำลังค้นหาพนักงาน',
    candidateSearchCount: 'พบ {{count}} คน',
    candidateSearchEmpty: 'ไม่พบพนักงานที่ตรงกับคำค้นในขอบเขตสิทธิ์ ลองชื่อ นามสกุล หรือเบอร์โทรส่วนอื่น',
    candidateSearchPrevious: 'หน้าก่อน',
    candidateSearchNext: 'หน้าถัดไป',
    candidateSearchSelect: 'เลือก {{name}}',
    candidateSearchReasons: 'เหตุผลที่ส่งงานให้ {{name}} ไม่ได้',
    candidateSearchDetails: 'ดูรายละเอียดการประเมินของ {{name}}',
    candidateSearchInactive: 'ปิดใช้งาน',
    candidateSearchCanOffer: 'ส่งข้อเสนอได้ — รอพนักงานยืนยันรับงาน',
    candidateSearchReasonUnknown: 'ไม่ผ่านเงื่อนไขเพิ่มเติม กรุณารีเฟรชเพื่อตรวจสอบ',
    candidateSearchReasonEVALUATION_REQUIRED: 'ต้องรีเฟรชผลประเมินก่อนส่งงาน',
    candidateSearchReasonCURRENT_ASSIGNEE: 'เป็นผู้รับงานปัจจุบัน',
    candidateSearchReasonINCUMBENT_DRIVER: 'เป็นผู้รับงานปัจจุบัน',
    candidateSearchReasonCANDIDATE_REVISION_STALE: 'ข้อมูลเปลี่ยนแล้ว ต้องรีเฟรชผลประเมิน',
    candidateSearchUnknown: 'ไม่มีข้อมูล',
    candidateSearchCheckedAt: 'ตรวจสถานะและตารางงานล่าสุดเมื่อ {{time}}',
    candidateSearchShortfallUnderMinute: 'ขาดไม่ถึง 1 นาที',
    candidateSearchMinutes: '{{value}} นาที',
    candidateSearchEvidenceUnavailable: 'ยังไม่มีหลักฐานการประเมินที่ใช้ส่งงานได้ กรุณารีเฟรช',
    candidateSearchAmendmentHold: 'กันเวลาไว้สำหรับคำขอแก้ไขการจอง',
    candidateSearchWorkload: 'ตารางงานล่าสุด',
    candidateSearchOrigin: 'จุดเริ่มที่ใช้ประเมิน',
    candidateSearchOriginDEVICE_LOCATION: 'ตำแหน่งจากอุปกรณ์',
    candidateSearchOriginHOME_LOCATION: 'ตำแหน่งบ้านสำหรับประเมิน',
    candidateSearchOriginPREVIOUS_JOB_ASSIGNED: 'ปลายทางของงานก่อนหน้าที่รับแล้ว',
    candidateSearchOriginPREVIOUS_JOB_ACTIVE: 'ปลายทางของงานก่อนหน้าที่กำลังทำ',
    candidateSearchOriginPREVIOUS_JOB_UNKNOWN: 'งานก่อนหน้า โดยไม่ทราบตำแหน่งปลายทาง',
    candidateSearchOriginRECENTLY_COMPLETED: 'ปลายทางของงานที่เพิ่งเสร็จ',
    candidateSearchOriginUNKNOWN: 'ไม่ทราบจุดเริ่มที่ใช้ประเมิน',
    candidateSearchDistance: 'ระยะถึงจุดรับ / รัศมีที่กำหนด',
    candidateSearchTransfer: 'เวลาเดินทางถึงจุดรับ',
    candidateSearchBefore: 'การเดินทางจากงานก่อนหน้า',
    candidateSearchAfter: 'การเดินทางไปงานถัดไป',
    candidateSearchTravelComparison: 'ใช้รวมเวลาเผื่อ {{required}} · เวลาเหลือหลังหักแล้ว {{slack}}',
    candidateSearchThreshold: 'คะแนน {{score}} / เกณฑ์ขั้นต่ำ {{threshold}}',
    workloadExpand: 'ดูงานทั้งหมด',
    workloadCollapse: 'แสดงน้อยลง',
    dataAsOf: 'คำนวณข้อมูลเมื่อ {{t}}',
    onlineOnly: 'เฉพาะที่ออนไลน์',
    freeOnly: 'เฉพาะที่ว่าง',
    suitability: 'ความเหมาะสม',
    colPlate: 'ทะเบียนรถ',
    colDistance: 'ระยะห่าง',
    colPrevJob: 'งานก่อนหน้า',
    colNextJob: 'งานถัดไป',
    shareBadge: 'แบ่งปัน',
    successTitle: 'การเดินทางของคุณได้รับการยืนยันแล้ว 🎉',
    scheduledInstant: 'ทันที',
    createdAtSummary: 'สร้างเมื่อ: {{time}}',
    scheduledForSummary: 'นัดหมาย: {{time}}',
    failTitle: 'ขออภัยที่เราไม่สามารถจองการเดินทางให้ท่านได้ในเวลานี้',
    tryAgain: 'กรุณาลองอีกครั้ง',
    createReturn: 'สร้างการเดินทางขากลับ',
    done: 'เสร็จสิ้น',
    km: 'กม.',
    selectPassengerFirst: 'กรุณาเลือกผู้โดยสารก่อน',
  },
  dashboard: {
    // left-rail label for the analytics (ChartPie) icon
    menuAnalytics: 'อะนาไลติกส์',
    // page chrome
    realtimeTitle: 'เรียลไทม์แดชบอร์ด',
    analyticsTitle: 'อะนาไลติกส์',
    exportCsv: 'ดาวน์โหลด CSV',
    totalTrips: 'การเดินทางทั้งหมด',
    totalJobs: 'ข้อมูลจากงานทั้งหมด',
    realtimeAsOf: 'ข้อมูลเรียลไทม์ วันที่ {{date}}',
    // filters
    filterProvider: 'ผู้ให้บริการ',
    filterArea: 'พื้นที่ให้บริการ',
    filterGroup: 'กลุ่มการให้บริการ',
    filterDate: 'วันที่',
    filterButton: 'ตัวกรอง',
    filterSheetTitle: 'ตัวกรองข้อมูล',
    applyFilters: 'ใช้ตัวกรอง',
    noActiveFilters: 'ยังไม่ได้เลือกตัวกรอง',
    activeFilterSummary: 'ใช้งาน {{count}} ตัวกรอง',
    activeFiltersLabel: 'ตัวกรองที่ใช้งานอยู่',
    clearFilter: 'ล้างตัวกรอง {{name}}',
    // realtime sections
    secTripStatus: 'สถานะการเดินทาง',
    secDriverStatus: 'สถานะพนักงาน',
    secEfficiency: 'ประสิทธิภาพการทำงาน',
    secVolume: 'ปริมาณการทำงาน',
    // trip status tiles
    tripEnRouteDropoff: 'ไปจุดส่งตัว',
    tripEnRoutePickup: 'ไปจุดรับตัว',
    tripDelayed: 'ล่าช้า',
    tripCompleted: 'เสร็จสิ้น',
    tripCancelled: 'ยกเลิก',
    tripMissed: 'พลาดการเดินทาง',
    tripScheduled: 'นัดหมายล่วงหน้า',
    tripUnassigned: 'ยังไม่มอบหมาย',
    // driver status tiles
    driverOnDuty: 'ปฏิบัติงาน',
    driverFree: 'ว่าง',
    driverOffline: 'ออฟไลน์',
    driverUnknown: 'ไม่ทราบสถานะ',
    // efficiency tiles
    effOnTime: 'รับตรงเวลา',
    effWorkRate: 'อัตราการทำงาน',
    effJobsPerPerson: 'จำนวนงานต่อคน',
    effAvgRating: 'เรทติ้งเฉลี่ย',
    unitJobs: 'งาน',
    // volume tiles
    volTotalDistance: 'ระยะทางวิ่งทั้งหมด',
    volAvgPerJob: 'ระยะทางเฉลี่ยต่องาน',
    volAvgPerPerson: 'ระยะทางเฉลี่ยต่อคน',
    volTotalTime: 'เวลาทำงานทั้งหมด',
    volAvgWait: 'เวลารอเฉลี่ย',
    volAvgTravel: 'เวลาเดินทางเฉลี่ย',
    unitKm: 'กม.',
    unitMin: 'นาที',
    // analytics — trend chart
    trendTripTime: 'เวลาในการเดินทางรวม',
    trendDistance: 'ระยะทางในการเดินทางรวม',
    trendWorkRate: 'อัตราการทำงานรวม',
    trendByType: 'การเดินทางตามประเภท',
    trendWait: 'เวลารอ',
    trendTravel: 'เวลาเดินทาง',
    trendTotal: 'รวม',
    // analytics — KPI cards
    cardTotalTrips: 'จำนวนการเดินทางทั้งหมด',
    cardSuccessCancel: 'จำนวนงานสำเร็จและยกเลิก',
    cardTimeDistribution: 'การกระจายตัวของเวลา',
    cardOnTimeRate: 'อัตราการทำงานตรงเวลา',
    cardLeaderboard: 'พนักงาน',
    cardDistanceDistribution: 'การกระจายตัวของระยะทาง',
    cardAreaVolume: 'ปริมาณงานในพื้นที่',
    cardTimeOfDay: 'ปริมาณงานในแต่ละช่วงเวลา',
    unitTimes: 'ครั้ง',
    labelSuccess: 'สำเร็จ',
    labelCompleted: 'สำเร็จ',
    labelCancelled: 'ยกเลิก',
    labelOnTime: 'ตรงเวลา',
    distInRange: 'อยู่ระหว่าง {{range}}',
    distributionTooltipValue: '{{count}} {{unit}} ({{pct}}%)',
    heatmapTooltip: '{{day}} {{band}}: {{jobs}} {{unit}}',
    dayMon: 'จันทร์',
    dayTue: 'อังคาร',
    dayWed: 'พุธ',
    dayThu: 'พฤหัสบดี',
    dayFri: 'ศุกร์',
    daySat: 'เสาร์',
    daySun: 'อาทิตย์',
    // service modes (การเดินทางตามประเภท)
    modeRideAndCare: 'รับส่ง+ดูแล',
    modeCare: 'ดูแล',
    modeRide: 'รับส่ง',
    modeTravel: 'เดินทาง',
    // leaderboard
    colName: 'ชื่อ',
    colJobs: 'จำนวนงาน',
    // empty states
    noDrivers: 'ไม่มีพนักงานในพื้นที่นี้',
  },

  passengers: {
    reasonCurrentWording: 'ข้อความเหตุผลปัจจุบัน',
    title: 'ผู้โดยสาร',
    totalPassengers: 'ผู้โดยสารทั้งหมด',
    provider: 'ผู้ให้บริการ',
    passengerGroup: 'กลุ่มผู้โดยสาร',
    peopleCount: '{{n}} คน',

    // date-range presets (วันที่)
    dateLabel: 'วันที่',

    // directory columns
    colName: 'ชื่อผู้โดยสาร',
    colProvince: 'จังหวัด',
    colPhone: 'โทรศัพท์',
    colAge: 'อายุ',
    colTrips: 'การเดินทาง',
    colDistance: 'ระยะทาง',
    colDuration: 'ระยะเวลา',
    colRatingReceived: 'เรทติ้งที่ได้รับ',
    colSpark7: 'สถิติ 7 วัน',
    tripsCount: '{{n}} ครั้ง',
    tripsLabel: '{{n}} การเดินทาง',
    noActivity: 'ไม่มีการเดินทาง',
    ageYearsMonths: '{{y}} ปี {{m}} เดือน',

    // summary cards
    cardTrips: 'จำนวนการเดินทาง',
    cardDistance: 'ระยะทางทั้งหมด',
    cardDuration: 'ระยะเวลาทั้งหมด',
    cardRating: 'เรทติ้งที่ได้รับ / ให้',
    unitTimes: 'ครั้ง',
    unitKm: 'กม.',
    unitHours: 'ชั่วโมง',

    // trip-history columns
    histDate: 'วันที่',
    histOrigin: 'จุดเริ่มต้น',
    histDestination: 'จุดหมาย',
    histStaff: 'พนักงาน',
    histStatus: 'สถานะ',

    // detail panel
    aboutTitle: 'เกี่ยวกับผู้โดยสารรายนี้',
    tabOverview: 'ภาพรวม',
    tabEntitlements: 'สิทธิสวัสดิการ',
    sectionPersonal: 'ข้อมูลส่วนตัว',
    sectionWelfare: 'สิทธิ์การใช้บริการ',
    sectionFavoritePlaces: 'สถานที่โปรด',
    sectionFavoriteTrips: 'การเดินทางโปรด',
    sectionMobileApp: 'โมบาย แอปพลิเคชั่น',
    ratingWithCount: '{{avg}} ({{count}})',

    // personal-info fields
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    address: 'ที่อยู่',
    subDistrictDistrict: 'แขวง / เขต',
    province: 'จังหวัด',
    postcode: 'รหัสไปรษณีย์',
    phone: 'หมายเลขโทรศัพท์',
    userCode: 'รหัสผู้ใช้',
    memberSince: 'วันเริ่มต้นการเป็นสมาชิก',

    // favorite place kinds
    kindHome: 'บ้าน',
    kindWork: 'ที่ทำงาน',
    kindGeneral: 'ทั่วไป',
    viewMap: 'ดูแผนที่',
    viewRoute: 'ดูเส้นทาง',

    // welfare access
    perWeek: 'ต่อสัปดาห์',
    perMonth: 'ต่อเดือน',
    unlimited: 'ไม่จำกัด',
    remainingOf: 'เหลือ {{remaining}} จาก {{cap}}',

    // ยอดสิทธิปัจจุบันและประวัติการใช้แบบแก้ย้อนหลังไม่ได้
    entitlementCurrent: 'สิทธิปัจจุบัน',
    entitlementHistory: 'ประวัติการใช้บริการ',
    entitlementTotal: 'สิทธิทั้งหมด',
    entitlementUsable: 'ใช้ได้ขณะนี้',
    entitlementExhausted: 'ใช้ครบแล้ว',
    entitlementComputedAt: 'ข้อมูล ณ {{value}}',
    entitlementStatusAvailable: 'ใช้ได้',
    entitlementStatusLow: 'ใกล้หมด',
    entitlementStatusExhausted: 'ใช้ครบแล้ว',
    entitlementStatusUnlimited: 'ไม่จำกัด',
    entitlementUsedOf: 'ใช้แล้ว {{used}} จาก {{cap}}',
    entitlementRemaining: 'เหลือ {{remaining}} ครั้ง',
    entitlementPeriodRange: '{{from}} ถึง {{to}}',
    entitlementResetAt: 'เริ่มรอบใหม่ {{value}}',
    currentDerived: 'คำนวณจากข้อมูลปัจจุบัน',
    bookingSnapshot: 'ข้อมูล ณ เวลาจอง',
    bookingEvidence: 'หลักฐาน ณ เวลาจอง',
    snapshotVersionProvenance: 'Snapshot v{{version}} · {{provenance}}',
    snapshotCapturedAt: 'บันทึกเมื่อ {{value}}',
    snapshotProviderEvidence: 'หน่วยงาน: {{name}} · {{id}}',
    snapshotServiceEvidence: 'บริการ: {{shortName}} · {{fullName}} · {{id}}',
    snapshotModeEvidence: 'รูปแบบบริการ: {{mode}}',
    snapshotStatusBefore: 'สถานะก่อนจอง: {{status}}',
    snapshotLimitingPeriod: 'รอบที่จำกัดสิทธิขณะจอง: {{period}}',
    snapshotMatchedGroups: 'กลุ่มที่ให้สิทธิ: {{groups}}',
    snapshotWeeklyEvidence: 'รายสัปดาห์ก่อนจอง: เพดาน {{cap}} · ใช้แล้ว {{used}} · เหลือ {{remaining}}',
    snapshotMonthlyEvidence: 'รายเดือนก่อนจอง: เพดาน {{cap}} · ใช้แล้ว {{used}} · เหลือ {{remaining}}',
    snapshotPeriodEvidence: 'รอบ {{from}} ถึง {{to}} · เริ่มใหม่ {{reset}}',
    noneRecorded: 'ไม่มีข้อมูล',
    limitingPeriod: 'รอบที่จำกัดสิทธิ',
    matchedGroups: 'กลุ่มผู้โดยสารที่ให้สิทธิ',
    historyDate: 'วันที่ใช้บริการ',
    historyService: 'สิทธิ',
    historyRoute: 'เส้นทาง',
    historyAgent: 'พนักงาน',
    historyLifecycle: 'ผลการใช้สิทธิ',
    historyMode: 'รูปแบบบริการ',
    modeRideAndCare: 'รับส่งและดูแล',
    modeCare: 'ดูแล',
    modeRide: 'รับส่ง',
    modeTravel: 'เดินทาง',
    historyTrip: 'เที่ยวเดินทาง',
    historyStatusConsumed: 'ใช้สิทธิแล้ว',
    historyStatusRestoredCancelled: 'คืนสิทธิหลังยกเลิก',
    historyStatusRestoredMissed: 'คืนสิทธิหลังพลาดการเดินทาง',
    restoredAt: 'คืนสิทธิ',
    entitlementUsageAmount: 'ใช้สิทธิ {{count}} ครั้ง',
    entitlementConsumedAt: 'ใช้สิทธิเมื่อ {{value}}',
    entitlementRestoreActor: 'คืนสิทธิโดย {{actor}}',
    legacyDerived: 'ข้อมูลเดิม · คำนวณจากข้อมูลปัจจุบัน',
    viewTrip: 'ดูเที่ยวเดินทาง',
    noEntitlements: 'ไม่มีสิทธิสวัสดิการที่ใช้งานอยู่',
    noEntitlementHistory: 'ไม่มีประวัติการใช้สิทธิในช่วงนี้',

    // device
    osVersion: '{{os}} Version: {{version}}',
    appVersion: 'App Version: {{version}}',
    noDevice: 'ยังไม่มีการเข้าใช้งานผ่านแอป',

    // create / edit modal
    createTitle: 'สร้างผู้โดยสารใหม่',
    editTitle: 'แก้ไขข้อมูลผู้โดยสาร',
    userCodeLabel: 'รหัสผู้ใช้',
    personalInfo: 'ข้อมูลส่วนตัว',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    dob: 'วันเดือนปีเกิด',
    userGroups: 'กลุ่มผู้ใช้',
    createButton: 'สร้างผู้ใช้ใหม่',
    duplicatePhone: 'หมายเลขโทรศัพท์ซ้ำ',
    phoneCheckTitle: 'ตรวจสอบหมายเลขโทรศัพท์',
    phoneCheckHint: 'กรอกหมายเลขโทรศัพท์ให้ครบเพื่อค้นหาผู้โดยสารในระบบ',
    phoneChecking: 'กำลังตรวจสอบหมายเลขโทรศัพท์…',
    existingPassengerHint: 'พบผู้โดยสารในระบบแล้ว สามารถเพิ่มเข้ารายชื่อลูกค้าของผู้ให้บริการได้โดยไม่สร้างข้อมูลซ้ำ',
    linkButton: 'เพิ่มเข้ารายชื่อลูกค้า',
  },

  drivers: {
    title: 'พนักงาน',
    totalDrivers: 'พนักงานทั้งหมด',
    provider: 'ผู้ให้บริการ',
    status: 'สถานะ',
    peopleCount: '{{n}} คน',
    driverSubtitle: 'พนักงาน',

    // status filter (อนุญาต / ไม่อนุญาต)
    statusActive: 'อนุญาต',
    statusSuspended: 'ไม่อนุญาต',
    statusPending: 'รออนุมัติ',
    statusRejected: 'ใบสมัครถูกปฏิเสธ',

    // account-status management (อนุมัติ / ระงับ / เปิดใช้งานใหม่)
    accountStatus: 'สถานะบัญชี',
    manageStatus: 'จัดการ',
    manageStatusTitle: 'จัดการสถานะบัญชี',
    manageStatusHint: 'กำหนดว่าจะอนุญาตให้ {{name}} ทำงานหรือไม่',
    rejectionReason: 'เหตุผลที่ปฏิเสธ',
    rejectionReasonHint: 'ระบุเหตุผลที่ปลอดภัยสำหรับแสดงแก่ผู้สมัคร (1–500 ตัวอักษร)',

    // date-range presets (วันที่)
    dateLabel: 'วันที่',

    // directory columns
    colName: 'ชื่อพนักงาน',
    colProvider: 'ผู้ให้บริการ',
    colPhone: 'เบอร์โทรศัพท์',
    colPlate: 'เลขทะเบียน',
    colProvince: 'จังหวัด',
    colTrips: 'การเดินทาง',
    colCareCount: 'งานดูแล',
    colDistance: 'ระยะทาง',
    colDuration: 'ระยะเวลา',
    colRatingReceived: 'เรทติ้งที่ได้รับ',
    colSpark7: 'สถิติ 7 วัน',
    colStatus: 'สถานะ',
    tripsCount: '{{n}} ครั้ง',
    jobsCount: '{{n}} งาน',
    unitKm: 'กม',
    unitHours: 'ชั่วโมง',

    // presence (สถานะการทำงาน)
    presenceOnDuty: 'ทำงาน',
    presenceFree: 'ว่าง',
    presenceBreak: 'เบรก',
    presenceOffline: 'ออฟไลน์',
    presenceUnknown: 'ไม่ทราบสถานะ',

    // center-pane มุมมอง views
    viewLabel: 'มุมมอง',
    view_today: 'การเดินทางวันนี้',
    view_schedule: 'ตารางการเดินทาง',
    view_past: 'การเดินทางที่ผ่านมา',
    view_dashboard: 'แดชบอร์ด',
    comingSoon: 'เร็วๆ นี้',

    // today view (route + trips table)
    routeOrigin: 'จุดเริ่มต้น',
    routeDestination: 'จุดหมาย',
    noTripsToday: 'ไม่มีการเดินทางวันนี้',
    todayColDate: 'วัน-เวลา',
    todayColGroup: 'กลุ่มบริการ',
    todayColPassenger: 'ผู้โดยสาร',
    todayColStatus: 'สถานะ',

    // about pane
    aboutTitle: 'เกี่ยวกับพนักงานคนนี้',
    currentStatus: 'สถานะปัจจุบัน',
    updatedAgo: 'อัพเดทเมื่อ {{t}} ที่แล้ว',
    driverLocation: 'ตำแหน่งพนักงาน',
    todayWorkload: 'ปริมาณงานวันนี้',
    jobProgress: 'ความคืบหน้างาน',
    jobStatus: 'สถานะของงานวันนี้',
    onSchedule: 'ตามแผน (เสร็จสิ้นเวลา {{time}})',
    behindSchedule: 'ล่าช้า',
    duration: 'ระยะเวลา',
    distance: 'ระยะทาง',
    nextJob: 'งานถัดไป',
    noNextJob: 'ไม่มี',

    // vehicle / contact / skills
    vehicleInfo: 'ข้อมูลรถ',
    plate: 'เลขทะเบียน',
    callName: 'ชื่อเรียกรถ',
    makeModel: 'ยี่ห้อ / รุ่น',
    noVehicle: 'ยังไม่มีรถที่กำหนด',
    contactInfo: 'ข้อมูลติดต่อ',
    email: 'อีเมล',
    province: 'จังหวัด',
    licenseNumber: 'เลขที่ใบขับขี่',
    phone: 'หมายเลขโทรศัพท์',
    skills: 'ทักษะ',
    serviceAreas: 'พื้นที่ให้บริการ',
    serviceAreasUnconstrained: 'ไม่ได้กำหนด — รับงานได้ทุกพื้นที่',
    editAreasTitle: 'แก้ไขพื้นที่ให้บริการ',
    editAreasHint: 'เลือกพื้นที่ที่พนักงานคนนี้รับงาน ถ้าไม่เลือกเลย = รับงานได้ทุกพื้นที่',
    skillDrive: 'ขับรถ',
    skillCare: 'ดูแล',

    // self-registration documents (FR-D-AUTH-010 review)
    documents: 'เอกสารการสมัคร',
    docProfile: 'รูปถ่ายพนักงาน',
    docLicense: 'รูปใบขับขี่',
    docVehicle: 'รูปถ่ายรถ',
    noDocuments: 'ยังไม่มีเอกสาร',
    documentPolicySnapshot: 'Snapshot นโยบายตอนส่งใบสมัคร: เวอร์ชัน {{version}}',
    documentStatus_ACTIVE: 'ใช้งานอยู่',
    documentStatus_DISABLED: 'ปิดใช้งาน',
    documentRevision: 'ฉบับแก้ไข',
    documentNumber: 'เลขที่เอกสาร',
    documentIssuedDate: 'วันที่ออกเอกสาร',
    documentExpiryDate: 'วันหมดอายุ',
    documentIssuer: 'ผู้ออกเอกสาร',
    documentRevisionHistory: 'ประวัติ {{count}} revision แบบแก้ไขย้อนหลังไม่ได้',
    bankAccountSection: 'บัญชีรับเงิน',
    bankAccountNone: 'ยังไม่มีข้อมูลบัญชีรับเงิน',
    bankName: 'ธนาคาร',
    otherBankName: 'ชื่อธนาคารอื่น',
    bankAccountName: 'ชื่อบัญชี',
    bankAccountNumber: 'เลขที่บัญชี',
    bankBookImage: 'รูปหน้าสมุดบัญชี',
    bankAccountHistory: 'ประวัติ {{count}} revision แบบแก้ไขย้อนหลังไม่ได้',
    addBankAccount: 'เพิ่มบัญชีรับเงิน',
    replaceBankAccount: 'เปลี่ยนบัญชีรับเงิน',
    viewBankBook: 'ดูรูปหน้าสมุดบัญชี',
    disableDocument: 'ปิดใช้งาน',
    disableDocumentConfirm: 'ปิดใช้งานเอกสารนี้หรือไม่ ประวัติ revision จะยังคงอยู่',
    addDocument: 'เพิ่มเอกสาร',
    replaceDocument: 'แทนที่เอกสาร',
    replaceDocumentConfirm: 'แทนที่เอกสารนี้ด้วย revision ใหม่ที่แก้ไขย้อนหลังไม่ได้หรือไม่',
    documentType: 'ประเภทเอกสาร',
    documentImages: 'ภาพเอกสาร (JPEG/PNG สูงสุด 5 ภาพ)',
    documentCoverageStart: 'วันเริ่มคุ้มครอง',

    // driver document viewer
    documentViewerTitle: 'ตรวจสอบเอกสาร',
    docViewerRotateLeft: 'หมุนซ้าย 90°',
    docViewerRotateRight: 'หมุนขวา 90°',
    docViewerZoomIn: 'ซูมเข้า',
    docViewerZoomOut: 'ซูมออก',
    docViewerReset: 'รีเซ็ต',
    docViewerOpenOriginal: 'เปิดรูปต้นฉบับในแท็บใหม่',
    docViewerPrev: 'เอกสารก่อนหน้า',
    docViewerNext: 'เอกสารถัดไป',
    docViewerCounter: 'เอกสารที่ {{current}} จาก {{total}}',
    docViewerNoImage: 'ไม่พบรูปภาพเอกสาร',
    docViewerLoadingImage: 'กำลังโหลดรูปภาพ...',
    docViewerAllDocuments: 'รายการเอกสารทั้งหมด',

    // section-edit modals (name/gender field labels reuse the passengers namespace)
    editDriverTitle: 'แก้ไขข้อมูลพนักงาน',
    editSkillsTitle: 'แก้ไขทักษะ',
    editVehicleTitle: 'แก้ไขข้อมูลรถ',

    // schedule view (ตารางการเดินทาง)
    weekDaySun: 'อา',
    weekDayMon: 'จ',
    weekDayTue: 'อ',
    weekDayWed: 'พ',
    weekDayThu: 'พฤ',
    weekDayFri: 'ศ',
    weekDaySat: 'ส',
    weekThis: 'สัปดาห์นี้',
    weekRangeCount: '{{range}} ({{count}})',
    noTripsWeek: 'ไม่มีการเดินทางในสัปดาห์นี้',

    // past trips view (การเดินทางที่ผ่านมา)
    filterGroup: 'กลุ่มการให้บริการ',
    filterStatus: 'สถานะ',
    statusCompleted: 'สำเร็จ',
    statusCancelled: 'ยกเลิก',
    statusMissed: 'พลาด',
    kpiTotal: 'งานทั้งหมด',
    kpiCompleted: 'สำเร็จ',
    kpiCompletionRate: 'อัตราสำเร็จ',
    kpiAvgPerDay: 'ค่าเฉลี่ย',
    unitJobs: 'งาน',
    noPastTrips: 'ไม่มีการเดินทางที่ผ่านมา',

    // dashboard view (แดชบอร์ด)
    chartLabel: 'กราฟ',
    metricJobs: 'จำนวนงานทั้งหมด',
    metricDistance: 'ระยะทางทั้งหมด',
    metricDuration: 'ระยะเวลาทั้งหมด',
    metricRating: 'เรตติ้งที่ได้รับทั้งหมด',
    granDay: 'รายวัน',
    granMonth: 'รายเดือน',
    granYear: 'รายปี',
    // segment labels
    segCompleted: 'สำเร็จ',
    segCancelled: 'ยกเลิก',
    segMissed: 'พลาด',
    segWithPassenger: 'มีผู้โดยสาร',
    segEmpty: 'ไม่มีผู้โดยสาร',
    segIdle: 'ไม่มีงาน',
    segWorking: 'ทำงาน',
    segNoRating: 'ไม่ให้ดาว',
    segS12: '1–2 ดาว',
    segS3: '3 ดาว',
    segS4: '4 ดาว',
    segS5: '5 ดาว',
    // summary / breakdown derived figures
    sumTotalJobs: 'งานทั้งหมด',
    sumTotalDistance: 'ระยะทางทั้งหมด',
    sumAvg: 'ค่าเฉลี่ย',
    sumTotalDuration: 'ระยะเวลารวม',
    sumAvgDuration: 'ระยะเวลาเฉลี่ย',
    durationCompactMinutes: '{{minutes}} นาที',
    durationCompactHours: '{{hours}} ชม.',
    durationCompactHoursMinutes: '{{hours}} ชม. {{minutes}} นาที',
    sumCompletionRate: 'อัตราสำเร็จ',
    sumEfficiency: 'ประสิทธิภาพ',
    sumAvgRating: 'เฉลี่ย',
    unitKmShort: 'กม.',
    unitStars: 'ดาว',
    breakdownGroup: 'กลุ่มบริการ',
    breakdownTotal: 'ทั้งหมด',
    breakdownAvg: 'ค่าเฉลี่ย',
    breakdownRate: 'อัตราสำเร็จ',
    breakdownEfficiency: 'ประสิทธิภาพ',
    breakdownAvgRating: 'เฉลี่ย',
    breakdownShare: '({{share}}%)',
    noDashboardData: 'ไม่มีข้อมูล',
  },
  dispatchPolicy: {
    title: 'นโยบายการกระจายงาน',
    scope: 'ระดับนโยบาย',
    area: 'พื้นที่ให้บริการ',
    scopeProvider: 'ผู้ให้บริการ',
    scopeArea: 'พื้นที่ให้บริการ',
    scopeSystem: 'ระบบ',
    scopePROVIDER: 'ผู้ให้บริการ',
    scopeAREA: 'พื้นที่ให้บริการ',
    scopeSYSTEM: 'ระบบ',
    scopeSource: 'ค่าจาก: {{scope}}',
    activeVersion: 'ปัจจุบัน v{{version}}',
    draftVersion: 'ฉบับร่างล่าสุด v{{version}}',
    saveDraft: 'บันทึกฉบับร่าง',
    activate: 'เปิดใช้ฉบับล่าสุด',
    saved: 'บันทึกฉบับร่างแบบแก้ย้อนหลังไม่ได้เป็นเวอร์ชันใหม่แล้ว',
    activated: 'เปิดใช้เวอร์ชันล่าสุดสำหรับการค้นหางานใหม่แล้ว',
    v3EvidenceRetention: 'ระยะเก็บหลักฐาน (วัน)',
    v3EditorTitle: 'ตัวแก้ไข Dispatch Policy v3',
    v3EditorHint: 'แก้ไขนโยบายระบบแบบเต็ม หรือกำหนดค่าเฉพาะส่วนของผู้ให้บริการ/พื้นที่ โดยรายการจะทดแทนค่าที่สืบทอดมาทั้งชุด',
    v3SourceSummary: 'แหล่งที่มาของค่า: ระบบ {{system}} · ผู้ให้บริการ {{provider}} · พื้นที่ {{area}}',
    v3GlobalSettings: 'หลักฐานและการยืนยันส่วนกลาง',
    v3PreviewTtlMinutes: 'อายุการยืนยัน Impact Preview',
    v3OriginSettings: 'จุดเริ่มต้นเชิงคาดการณ์',
    v3RoutingSettings: 'การหาเส้นทางและค่าทดแทน',
    v3RoutingMode: 'โหมดเส้นทางสำหรับจัดสรรคนขับ',
    routingModePROVIDER: 'ผู้ให้บริการเส้นทางที่เลือก (Google / Mapbox)',
    routingModeCOORDINATE: 'ประมาณจากพิกัด',
    v3RoutingModeHint:
      'ใช้เฉพาะการเดินทางต่อของคนขับ รวมถึงจากงานก่อนหน้าและไปงานถัดไป โหมดผู้ให้บริการใช้ Google / Mapbox ที่เลือกไว้ส่วนกลาง โหมดพิกัดประมาณระยะทางและเวลาโดยไม่เรียกบริการเส้นทางภายนอก โดยยังตรวจสอบความเป็นไปได้ของตารางงานก่อนและหลังด้วยค่าประมาณ เส้นทางผู้โดยสาร รูปเส้นทาง ค่าโดยสาร และข้อมูลช่วงเดินทางของผู้โดยสารในข้อเสนองานยังใช้ผู้ให้บริการเส้นทาง',
    v3FeasibilitySettings: 'เวลาเผื่อความเป็นไปได้ของตารางงาน',
    v3NearTermLeadTimeMinutes: 'เกณฑ์งานตามกำหนดเวลาใกล้เริ่ม',
    v3PreviousJobContinuityGapMinutes: 'ช่วงต่อเนื่องจากงานก่อนหน้า',
    v3CompletedJobOriginMaxAgeMinutes: 'อายุสูงสุดของจุดจบงานที่เสร็จแล้ว',
    v3DeviceIdealAgeMinutes: 'อายุพิกัดอุปกรณ์ที่ดีที่สุด',
    v3DeviceDecayUntilMinutes: 'ความเชื่อมั่นพิกัดลดลงจนถึง',
    v3DeviceDiscardAfterMinutes: 'ทิ้งพิกัดอุปกรณ์หลังจาก',
    v3HomeConfidence: 'ความเชื่อมั่นตำแหน่งบ้าน',
    v3AssignedCommitmentConfidence: 'ความเชื่อมั่นจุดหมายงานที่มอบหมายแล้ว',
    v3ActiveCommitmentConfidence: 'ความเชื่อมั่นจุดหมายงานที่กำลังทำ',
    v3CompletedCommitmentConfidence: 'ความเชื่อมั่นจุดหมายงานที่เสร็จแล้ว',
    v3UnknownConfidence: 'ความเชื่อมั่นเมื่อไม่ทราบจุดเริ่มต้น',
    v3UnknownTransferEtaMinutes: 'ETA การเดินทางเมื่อไม่ทราบข้อมูล',
    v3UnknownTravelScore: 'คะแนนการเดินทางเมื่อไม่ทราบข้อมูล',
    v3FallbackFeasibilityMultiplier: 'ตัวคูณความเป็นไปได้เมื่อใช้ค่าทดแทน',
    v3RouteConfidenceMultiplier: 'ตัวคูณความเชื่อมั่นคะแนนเมื่อใช้ค่าทดแทน',
    v3TotalBudgetMs: 'งบเวลาหาเส้นทางรวม',
    v3RequestTimeoutMs: 'เวลารอคำขอเส้นทาง',
    v3BatchSize: 'จำนวนเส้นทางต่อชุด',
    v3Concurrency: 'จำนวนชุดเส้นทางพร้อมกัน',
    v3MaxRetries: 'จำนวนรอบลองเส้นทางซ้ำ',
    v3BeforeMinimumMinutes: 'เวลาเผื่อขั้นต่ำก่อนงาน',
    v3BeforeEtaPercent: 'เวลาเผื่อตาม ETA ก่อนงาน',
    v3AfterMinimumMinutes: 'เวลาเผื่อขั้นต่ำหลังงาน',
    v3AfterEtaPercent: 'เวลาเผื่อตาม ETA หลังงาน',
    v3WindowBeforeMinutes: 'ช่วงภาระงานก่อนเวลารับ',
    v3WindowAfterMinutes: 'ช่วงภาระงานหลังเวลารับ',
    v3PriorSuccesses: 'จำนวนสำเร็จตั้งต้นของอัตรารับงาน',
    v3PriorSampleSize: 'ขนาดตัวอย่างตั้งต้นของอัตรารับงาน',
    v3PriorRating: 'ค่าเฉลี่ยตั้งต้นของคะแนน',
    v3PriorReviewCount: 'จำนวนรีวิวตั้งต้น',
    v3TieTolerancePoints: 'ช่วงคะแนนที่ถือว่าเสมอกัน',
    warningConfirmationTitle: 'นโยบายนี้มีคำเตือนที่ต้องตรวจสอบ',
    confirmWarning: 'รับทราบคำเตือนและดำเนินการต่อ',
    warningDistanceSaturation:
      '{{profile}}: ค่าแย่ที่สุดของปัจจัยระยะทางต่ำกว่ารัศมีค้นหา ทำให้คะแนนระยะทางของผู้สมัครในรัศมีอิ่มตัว',
    warningDistanceBufferPercent: 'ระยะเผื่อแบบเปอร์เซ็นต์เกิน 100%',
    warningEtaBufferPercent: 'เวลาเผื่อแบบเปอร์เซ็นต์เกิน 100%',
    warningFixedDistance: 'ระยะเผื่อคงที่เกิน 50 กม.',
    warningFixedTime: 'เวลาเผื่อคงที่เกิน 180 นาที',
    copyId: 'คัดลอก ID',
    idCopied: 'คัดลอก ID แล้ว',
    unknownName: 'ไม่พบชื่อ',
    inherit: 'ใช้ค่าเริ่มต้น',
    enabled: 'เปิด',
    disabled: 'ปิด',
    strategyDefaults: 'รูปแบบเริ่มต้น',
    strategyNow: 'งานทันที',
    strategyScheduled: 'งานตามกำหนดเวลา',
    strategyNOW: 'งานทันที',
    strategySCHEDULED: 'งานตามกำหนดเวลา',
    strategySequential: 'ทีละราย',
    strategyBroadcast: 'พร้อมกัน',
    strategySEQUENTIAL: 'ทีละราย',
    strategyBROADCAST: 'พร้อมกัน',
    searchLifecycle: 'การค้นหา เส้นทาง และวงจรคำขอ',
    fanout: 'จำนวนที่ส่งข้อเสนอพร้อมกัน',
    redispatchAttempts: 'จำนวนครั้งการส่งต่อ',
    offerTimeoutSec: 'เวลารอคำตอบ (วินาที)',
    reofferRejectedCooldownSec: 'ช่วงพักก่อนเสนอซ้ำหลังปฏิเสธ (วินาที)',
    radiusKm: 'รัศมีค้นหา (กม.)',
    etaRoadFactor: 'ตัวคูณถนนเมื่อใช้ค่าประมาณ',
    etaAverageSpeedKph: 'ความเร็วเฉลี่ยเมื่อใช้ค่าประมาณ (กม./ชม.)',
    etaNoCoordinateMinutes: 'เวลาเมื่อไม่มีพิกัด (นาที)',
    buffers: 'ระยะและเวลาเผื่อ',
    distancePercent: 'ระยะเผื่อแบบเปอร์เซ็นต์',
    distanceFixedKm: 'ระยะเผื่อคงที่ (กม.)',
    etaPercent: 'เวลาเผื่อแบบเปอร์เซ็นต์',
    etaFixedMinutes: 'เวลาเผื่อคงที่ (นาที)',
    candidateInclusion: 'การรวมผู้สมัคร',
    sequentialRequiresOnline: 'การกระจายทีละรายกำหนดให้ต้องออนไลน์',
    freshnessCutoffMinutes: 'อายุพิกัดสดสูงสุด (นาที)',
    sequentialIncludeStaleLocation: 'การกระจายทีละรายรวมผู้ที่มีพิกัดเก่า',
    sequentialIncludeNoLocation: 'การกระจายทีละรายรวมผู้ไม่มีพิกัด',
    broadcastIncludeOffline: 'การกระจายพร้อมกันรวมผู้ที่ออฟไลน์',
    broadcastIncludeStaleLocation: 'การกระจายพร้อมกันรวมผู้ที่มีพิกัดเก่า',
    broadcastIncludeNoLocation: 'การกระจายพร้อมกันรวมผู้ไม่มีพิกัด',
    rankingFactors: 'ปัจจัยจัดอันดับ',
    factorPRESENCE: 'สถานะออนไลน์',
    factorLOCATION_FRESHNESS: 'ความสดของพิกัด',
    factorDISTANCE: 'ระยะทาง',
    factorPICKUP_ETA: 'เวลาไปถึงจุดรับ',
    factorSCHEDULE_SLACK_BEFORE: 'เวลาว่างก่อนงาน',
    factorSCHEDULE_SLACK_AFTER: 'เวลาว่างหลังงาน',
    factorWORKLOAD: 'ปริมาณงาน',
    factorLAST_ASSIGNED_AGE: 'เวลาตั้งแต่ได้รับงานล่าสุด',
    factorACCEPTANCE_RATE: 'อัตราการตอบรับ',
    factorRATING: 'คะแนน',
    factorORIGIN_CONFIDENCE: 'ความเชื่อมั่นจุดเริ่มต้น',
    factorEnabled: 'เปิดใช้',
    factorWeight: 'น้ำหนัก',
    factorIdeal: 'ค่าดีที่สุด',
    factorWorst: 'ค่าแย่ที่สุด',
    factorThreshold: 'เกณฑ์ขั้นต่ำ (เว้นว่างคือไม่มี)',
    factorMissingScore: 'คะแนนเมื่อไม่มีข้อมูล',
    factorPenaltyScore: 'คะแนนลงโทษ',
    lookbackDays: 'ช่วงย้อนหลัง (วัน)',
    tieBreakers: 'ลำดับตัดสินเมื่อคะแนนเท่ากัน',
    tiePICKUP_ETA: 'เวลาไปรับน้อยกว่า',
    tieWORKLOAD: 'งานน้อยกว่า',
    tieLAST_ASSIGNED_AGE: 'ได้รับงานล่าสุดนานกว่า',
    tieDISTANCE: 'ระยะทางน้อยที่สุด',
    tieORIGIN_CONFIDENCE: 'ความเชื่อมั่นจุดเริ่มต้นสูงที่สุด',
    tieSCHEDULE_SLACK_BEFORE: 'เวลาว่างก่อนงานมากที่สุด',
    tieSCHEDULE_SLACK_AFTER: 'เวลาว่างหลังงานมากที่สุด',
    tieACCEPTANCE_RATE: 'อัตรารับงานสูงที่สุด',
    tieRATING: 'คะแนนสูงที่สุด',
    tieDRIVER_ID: 'รหัสพนักงาน',
    driverIdLast: 'ระบบเติมรหัสพนักงานเป็นเกณฑ์สุดท้ายเสมอเพื่อให้ผลคงที่',
    moveUp: 'เลื่อนขึ้น',
    moveDown: 'เลื่อนลง',
    remove: 'นำออก',
    addTie: 'เพิ่ม {{name}}',
    simulatorTitle: 'จำลองนโยบายปัจจุบันเทียบฉบับร่าง',
    simulatorHint: 'อ่านอย่างเดียว ไม่สร้างคำขอ การแจ้งเตือน บันทึกตรวจสอบ เปลี่ยนสถานะ หรือบันทึกนโยบาย',
    resolutionMode: 'โหมดการจำลองนโยบาย',
    resolutionModeScopeOnly: 'ทดสอบระดับที่กำลังแก้',
    resolutionModeScopeOnlyHint: 'เปรียบเทียบค่าปัจจุบันกับฉบับร่างของระดับนี้ โดยไม่ให้ระดับลูก เช่น พื้นที่ บังค่า',
    resolutionModeEffective: 'ตามผลจริงของงาน',
    resolutionModeEffectiveHint: 'ใช้ลำดับจริง พื้นที่ > ผู้ให้บริการ > ระบบ ตามจุดรับของงาน',
    purpose: 'วัตถุประสงค์',
    strategy: 'รูปแบบการกระจายงาน',
    purposeInitial: 'จัดงานครั้งแรก',
    purposeReassignment: 'เปลี่ยนพนักงาน',
    trip: 'การเดินทางจริง',
    simulate: 'เริ่มจำลอง',
    dataAsOf: 'ข้อมูล ณ {{value}}',
    current: 'ปัจจุบัน',
    draft: 'ฉบับร่าง',
    delta: 'ความแตกต่าง',
    deltaAdded: 'มีเฉพาะในฉบับร่าง: {{value}}',
    deltaRemoved: 'ถูกฉบับร่างตัดออก: {{value}}',
    fanoutValue: 'รอพร้อมกันสูงสุด {{count}}',
    budgetValue: 'งบคำขอ {{count}}',
    valuesUsed: 'ค่าที่ใช้จริง',
    simulationInputSource: 'ค่าจาก: ตัวเลือกจำลอง',
    rankingValuesUsed: 'ค่าปัจจัยจัดอันดับที่ใช้',
    factorUsedValue:
      'เปิด · น้ำหนัก {{weight}}% · ดีที่สุด {{ideal}} {{unit}} · แย่ที่สุด {{worst}} {{unit}} · เกณฑ์ {{threshold}} {{unit}}',
    factorNotUsed: 'ปิด — ไม่ใช้คำนวณคะแนน',
    roundValue: 'รอบตรวจสอบ {{count}}',
    noCandidates: 'ไม่มีผู้สมัครที่ผ่าน',
    included: 'รวม',
    excluded: 'ตัดออก',
    scoreValue: 'คะแนน {{score}}',
    reasons: 'เหตุผล',
    routeSource: 'ที่มาของเส้นทาง',
    routeSourceROUTING: 'ข้อมูลเส้นทางจริง',
    routeSourceROUTE_PROVIDER: 'ข้อมูลเส้นทางจริง',
    routeSourceHAVERSINE_FALLBACK: 'ประมาณจากระยะเส้นตรง',
    routeSourceESTIMATED_FALLBACK: 'ประมาณจากพิกัดเมื่อบริการเส้นทางล้มเหลว',
    routeSourceCOORDINATE_ESTIMATE: 'ประมาณจากพิกัดตามโหมดที่เลือก',
    routeSourceCONSERVATIVE_FALLBACK: 'ค่าประมาณแบบเผื่อความเสี่ยง',
    routeSourceUNKNOWN: 'ไม่ทราบ',
    presenceFREE: 'ว่าง',
    presenceON_DUTY: 'กำลังทำงาน',
    presenceBREAK: 'พัก',
    presenceOFFLINE: 'ออฟไลน์',
    minutesShort: 'นาที',
    factorEvidence:
      'ข้อมูล {{raw}} · ปรับแล้ว {{normalized}} · น้ำหนัก {{weight}} · ผลรวม {{contribution}} · เกณฑ์ {{threshold}}',
    helpLabel: 'คำอธิบาย',
    helpExample: 'ตัวอย่าง',
    helpHowTitle: 'วิธีคำนวณ',
    helpImpactTitle: 'ผลกระทบเมื่อปรับค่านี้',
    helpFormulaTitle: 'สูตรที่ใช้',
    scoreFormula:
      'คะแนนปัจจัยย่อย = คะแนนลงโทษ + (ค่าที่วัดได้ clamp ระหว่างดีที่สุด–แย่ที่สุด → แปลงเป็น 0–100) × (100 − คะแนนลงโทษ) ÷ 100\n\nคะแนนรวม = Σ (คะแนนปัจจัยย่อย × น้ำหนัก ÷ 100) — คนที่คะแนนรวมสูงสุดได้อันดับ 1',
    helpClose: 'เข้าใจแล้ว',
    unitKm: 'กม.',
    unitMinutes: 'นาที',
    unitSeconds: 'วินาที',
    unitHours: 'ชม.',
    unitDays: 'วัน',
    unitPercent: '%',
    unitDrivers: 'คน',
    unitTrips: 'งาน',
    unitRounds: 'รอบ',
    unitTimes: 'เท่า',
    unitKph: 'กม./ชม.',
    unitPoints: 'คะแนน',
    unitRating: 'ดาว',
    unitMilliseconds: 'มิลลิวินาที',
    unitRoutes: 'เส้นทาง',
    dirLowerBetter: 'ค่าต่ำ = ดี ({{unit}})',
    dirHigherBetter: 'ค่าสูง = ดี ({{unit}})',
    dirCategorical: 'ตามสถานะ (ออนไลน์ = ดีที่สุด)',
    fanoutHelp:
      'คำอธิบาย: จำนวนพนักงานสูงสุดที่ได้รับข้อเสนองาน "พร้อมกัน" ในหนึ่งรอบ\n\nวิธีคำนวณ: ระบบจัดอันดับผู้สมัครตามคะแนนรวม แล้วส่งข้อเสนอให้จำนวนเท่ากับค่านี้ในรอบแรก\n\nตัวอย่าง: ตั้ง 3 → อันดับ 1–3 ได้รับข้อเสนอพร้อมกัน ใครกดรับก่อนได้งาน ที่เหลือหมดอายุ\n\nผลกระทบ: ค่ามาก = เติมงานเร็ว แต่หลายคนเสียเวลารับแจ้งเตือนที่ไม่ได้งาน ค่าน้อย = ควบคุมง่ายแต่หาคนช้าลง',
    radiusKmHelp:
      'คำอธิบาย: ระยะสูงสุดจากจุดรับที่ถือว่าเป็น "ผู้สมัคร"\n\nวิธีคำนวณ: วัดจากพิกัดล่าสุดของพนักงานถึงจุดรับ (เส้นทางจริงถ้ามี ไม่งั้นระยะตรง) เกินค่านี้ = ตัดทิ้ง\n\nตัวอย่าง: ตั้ง 10 → คนห่าง 8 กม. เข้ารอบ คนห่าง 12 กม. ถูกตัด\n\nผลกระทบ: ค่ามาก = หาคนง่ายแต่ ETA ยาว ค่าน้อย = งานเร็วแต่เสี่ยงหาคนไม่ได้',
    offerTimeoutSecHelp:
      'คำอธิบาย: เวลาที่ข้อเสนอรอคำตอบก่อนหมดอายุ\n\nวิธีคำนวณ: นับจากวินาทีที่ส่งข้อเสนอ ครบกำหนดโดยไม่ยอมรับ = หมดอายุ เริ่มรอบถัดไปทันที\n\nตัวอย่าง: ตั้ง 45 → ส่ง 10:00:00 ไม่มีใครรับถึง 10:00:45 → ส่งรอบถัดไป\n\nผลกระทบ: ค่ามาก = มีเวลาตัดสินใจแต่งานเริ่มช้า ค่าน้อย = วนรอบเร็วแต่คนอาจพลาดแจ้งเตือน',
    reofferRejectedCooldownSecHelp:
      'คำอธิบาย: ระยะเวลาที่จะไม่เสนอซ้ำให้พนักงานซึ่งกดปฏิเสธงานนี้อย่างชัดเจน ภายในข้อมูลสำคัญชุดเดิม\n\nการหมดเวลาและการหยุดค้นหาโดยเจ้าหน้าที่ไม่เริ่มช่วงพักนี้\n\nค่าเริ่มต้น: 1,800 วินาที (30 นาที)',
    redispatchAttemptsHelp:
      'คำอธิบาย: จำนวนรอบสูงสุดก่อนประกาศหาคนไม่ได้\n\nวิธีคำนวณ: แต่ละรอบส่งให้กลุ่มถัดไปตามลำดับคะแนน รอบหมด = trip ค้างจัดมือ\n\nตัวอย่าง: fanout 3 × ส่งต่อ 4 = ลองได้สูงสุด 12 คน\n\nผลกระทบ: ค่ามาก = โอกาสได้คนสูงแต่ผู้โดยสารรอนาน ค่าน้อย = รู้ผลไวแต่จัดมือบ่อย',
    etaRoadFactorHelp:
      'คำอธิบาย: ตัวคูณแปลงระยะตรงเป็นระยะถนนเมื่อไม่มีเส้นทางจริง\n\nวิธีคำนวณ: ระยะถนน ≈ ระยะตรง (haversine) × ตัวคูณ\n\nตัวอย่าง: ตรง 10 กม. × 1.3 ≈ 13 กม.\n\nผลกระทบ: ค่ามาก = ETA สูงขึ้น เลือกคนไกลน้อยลง ค่าน้อย = มองโลกในแง่ดี เสี่ยง ETA เกินจริง',
    etaAverageSpeedKphHelp:
      'คำอธิบาย: ความเร็วสมมติสำหรับคิด ETA เมื่อไม่มีเส้นทางจริง\n\nวิธีคำนวณ: ETA (นาที) = ระยะ (กม.) ÷ ความเร็ว (กม./ชม.) × 60\n\nตัวอย่าง: 13 กม. ÷ 30 ≈ 26 นาที\n\nผลกระทบ: ค่ามาก = ETA ต่ำ เลือกคนไกลได้ ค่าน้อย = อนุรักษนิยม เหมาะเขตรถติด',
    etaNoCoordinateMinutesHelp:
      'คำอธิบาย: ETA คงที่เมื่อพนักงานไม่มีพิกัด\n\nวิธีคำนวณ: ใช้ค่านี้ตรง ๆ แทนการคิดจากระยะ\n\nตัวอย่าง: ตั้ง 8 → คนปิด GPS ถือว่าไปถึงใน 8 นาทีเสมอ\n\nผลกระทบ: ค่ามาก = คนไม่มีพิกัดแพ้ในอันดับ ค่าน้อย = แข่งเทียบคนมีพิกัดใกล้ได้',
    strategyHelp:
      'คำอธิบาย: วิธีแจกข้อเสนอในแต่ละรอบ\n\nทีละราย (Sequential): ส่งให้อันดับ 1 คนเดียว หมดเวลาค่อยส่งคนถัดไป — งบคำขอ = จำนวนรอบส่งต่อ\n\nพร้อมกัน (Broadcast): ส่งให้หลายคนตาม "จำนวน Broadcast พร้อมกัน" — งบคำขอ = fanout × จำนวนรอบ\n\nตัวอย่าง: fanout 3 + รอบ 4 → Broadcast สูงสุด 12 ข้อเสนอ / Sequential 4 ข้อเสนอ\n\nผลกระทบ: Broadcast เร็วแต่ใช้งบเร็วและหลายคนโดนแจ้งเตือนฟรี Sequential ช้ากว่าแต่เป็นธรรมกับพนักงาน',
    bufferHelp:
      'คำอธิบาย: ระยะ/เวลาเผื่อบนค่าประมาณเส้นทาง\n\nวิธีคำนวณ: ค่าที่ใช้ = ค่าคำนวณ × (1 + เปอร์เซ็นต์) + ค่าคงที่\n\nตัวอย่าง: ETA 20 นาที + 10% + 5 นาที = 27 นาที\n\nผลกระทบ: ค่ามาก = เผื่อเยอะ จัดงานต่อเนื่องได้น้อย (ปลอดภัยแต่ความจุต่ำ) ค่าน้อย = จัดแน่นแต่เสี่ยงมาสาย',
    inclusionHelp:
      'คำอธิบาย: เงื่อนไข "ใครเข้ารอบเป็นผู้สมัคร" ก่อนจัดอันดับ\n\nวิธีคำนวณ: เป็นตัวกรองตรง ๆ ไม่ผ่านเงื่อนไขใด = ตัดทิ้งทันที\n\nตัวอย่าง: "Sequential ต้องออนไลน์" เปิด → คนออฟไลน์ถูกตัดก่อนนับคะแนน\n\nผลกระทบ: เปิดเยอะ = pool แคบแต่คนพร้อมงานจริง ปิดเยอะ = pool กว้างแต่เสี่ยงส่งงานให้คนปิดแอป/พิกัดเก่า',
    factorPRESENCEHelp:
      'คำอธิบาย: ให้คะแนนตามสถานะพร้อมรับงาน\n\nวิธีคำนวณ: FREE/ON_DUTY → "ค่าดีที่สุด" สถานะอื่น → "คะแนนลงโทษ"\n\nตัวอย่าง: ดีที่สุด 100, ลงโทษ 30, น้ำหนัก 10 → ออนไลน์ contribution 10.0 / ออฟไลน์ 3.0\n\nผลกระทบ: น้ำหนักมาก = จ่ายงานให้คนที่กดออนไลน์จริงก่อนเสมอ',
    factorLOCATION_FRESHNESSHelp:
      'คำอธิบาย: อายุพิกัดล่าสุด (นาที)\n\nวิธีคำนวณ: อายุ = ตอนนี้ − เวลาส่งพิกัดล่าสุด แปลงเชิงเส้นดีที่สุด→แย่ที่สุด เกินแย่ที่สุด = คะแนนลงโทษ\n\nตัวอย่าง: ดี 1 / แย่ 30 → อายุ 15 นาที ได้ ~50/100 อายุ 45 นาที = ลงโทษ\n\nผลกระทบ: น้ำหนักมาก = เชื่อคนพิกัดสด ลดปัญหา "ใกล้แต่พิกัดเก่า" แต่คนเน็ตอ่อนถูกลงโทษ',
    factorDISTANCEHelp:
      'คำอธิบาย: ระยะจากพนักงานถึงจุดรับ (กม.)\n\nวิธีคำนวณ: เส้นทางจริงถ้ามี ไม่งั้นตรง × ตัวคูณถนน แปลงเชิงเส้นดีที่สุด→แย่ที่สุด\n\nตัวอย่าง: ดี 0 / แย่ 10, น้ำหนัก 15 → 4 กม. ได้ 60/100 → contribution 9.0\n\nผลกระทบ: น้ำหนักมาก = งานไปคนใกล้เสมอ (ประหยัดเวลา) แต่คนใกล้ได้งานซ้ำ คนไกลแทบไม่มีรายได้',
    factorPICKUP_ETAHelp:
      'คำอธิบาย: เวลาโดยประมาณถึงจุดรับ (นาที)\n\nวิธีคำนวณ: ETA = ระยะ ÷ ความเร็ว (หรือเส้นทางจริง) + buffer แปลงเชิงเส้นเหมือนระยะ\n\nตัวอย่าง: ดี 0 / แย่ 60, น้ำหนัก 20 → ETA 12 นาที ได้ 80/100 → contribution 16.0\n\nผลกระทบ: น้ำหนักมาก = ผู้โดยสารรอน้อยลง — ปกติน้ำหนักสูงสุดเพราะกระทบประสบการณ์ผู้โดยสารตรงที่สุด',
    factorSCHEDULE_SLACK_BEFOREHelp:
      'คำอธิบาย: เวลาว่างก่อนงานเริ่ม (นาที)\n\nวิธีคำนวณ: ว่าง = เริ่มงานนี้ − จบงานก่อนหน้า (ไม่มีงานก่อน = ว่างมาก)\n\nตัวอย่าง: ดี 120, น้ำหนัก 15 → ว่าง 60 นาที ได้ 50/100 → 7.5\n\nผลกระทบ: น้ำหนักมาก = เลี่ยงคนตารางแน่น ลดเสี่ยงมาสายจากงานก่อนล่าช้า',
    factorSCHEDULE_SLACK_AFTERHelp:
      'คำอธิบาย: เวลาว่างหลังงานจบ (นาที)\n\nวิธีคำนวณ: ว่าง = เริ่มงานถัดไป − จบงานนี้ (รวมเวลาเดินทางไปงานถัดไป)\n\nตัวอย่าง: ดี 120, น้ำหนัก 15 → ว่าง 30 นาที ได้ 25/100 → 3.75\n\nผลกระทบ: น้ำหนักมาก = ไม่บีบคนงานชนกัน ลดการบริหารเวลาแบบเสี่ยง',
    factorWORKLOADHelp:
      'คำอธิบาย: จำนวนงานในช่วงย้อนหลัง — กระจายงานสมดุล\n\nวิธีคำนวณ: นับงานใน lookbackDays งาน 0 = เต็ม, เท่า "แย่ที่สุด" = 0\n\nตัวอย่าง: ดี 0 / แย่ 5, น้ำหนัก 5 → มี 2 งาน ได้ 60/100 → 3.0\n\nผลกระทบ: น้ำหนักมาก = รายได้สมดุลทั่วถึง แต่อาจจ่ายคนไกลกว่าเพราะคนใกล้ทำเยอะแล้ว',
    factorLAST_ASSIGNED_AGEHelp:
      'คำอธิบาย: ชั่วโมงนับแต่ได้งานล่าสุด — คนว่างนานได้ก่อน\n\nวิธีคำนวณ: อายุ = ตอนนี้ − เวลาได้งานล่าสุด ว่างเท่า "ดีที่สุด" = เต็ม\n\nตัวอย่าง: ดี 24, น้ำหนัก 4 → ว่าง 12 ชม. ได้ 50/100 → 2.0\n\nผลกระทบ: น้ำหนักมาก = หมุนเวียนต่อคิว (fairness สูง) แต่อาจเพิกเฉยความใกล้',
    factorACCEPTANCE_RATEHelp:
      'คำอธิบาย: สัดส่วนยอมรับ (%) ในช่วง lookbackDays\n\nวิธีคำนวณ: อัตรา = ยอมรับ ÷ (ยอมรับ+ปฏิเสธ+หมดอายุ) ไม่เคยได้รับ = "คะแนนเมื่อไม่มีข้อมูล"\n\nตัวอย่าง: รับ 8/10 = 80%, น้ำหนัก 3 → 2.4\n\nผลกระทบ: น้ำหนักมาก = งานไปคนตอบรับเสมอ แต่คนใหม่/เคยปฏิเสธบ่อยตามไม่ทัน',
    factorRATINGHelp:
      'คำอธิบาย: คะแนนเฉลี่ยจากผู้โดยสาร (1–5)\n\nวิธีคำนวณ: ค่าเฉลี่ยดาว ไม่มีประวัติ = "คะแนนเมื่อไม่มีข้อมูล" ต่ำกว่า "แย่ที่สุด" = ลงโทษ\n\nตัวอย่าง: ดี 5 / แย่ 1, น้ำหนัก 3 → 4.8 ดาว ได้ 95/100 → 2.85\n\nผลกระทบ: น้ำหนักมาก = งานไปคนคุณภาพดี แต่มือใหม่ได้งานยาก — ควรตั้ง "คะแนนเมื่อไม่มีข้อมูล" สูงพอสมควร',
    purposeHelp:
      'จัดงานครั้งแรก (INITIAL): จำลองการหาพนักงานให้งานใหม่\n\nเปลี่ยนตัวพนักงาน (REASSIGNMENT): จำลองหาคนใหม่แทนคนปัจจุบัน — incumbent ถูกถอดจากผู้สมัครเสมอ\n\nผลกระทบ: เลือกมุมมองให้ตรงสถานการณ์ เช่น จะเปลี่ยนคน trip ที่มีคนแล้ว ต้องใช้ REASSIGNMENT จึงเห็นว่าใครเป็นตัวแทน',
    tripPickerTitle: 'เลือกการเดินทางจริง',
    tripPickerSearch: 'ค้นหา: รหัส trip, ชื่อ/เบอร์ผู้โดยสาร, จุดรับ-จุดส่ง…',
    tripPickerEmpty: 'ไม่พบรายการ',
    tripPickerHint: 'การเปลี่ยนตัวพนักงานต้องเป็น trip ตามกำหนดเวลาที่มีพนักงานอยู่แล้ว',
    tripOptionalHint: 'ไม่บังคับ — เลือกการเดินทางจริงเมื่อต้องการเติมรายละเอียดด้านล่างให้อัตโนมัติ',
    factorContributionTitle: 'คะแนนแยกตามปัจจัย (ค่า raw → ผลรวม)',
    factorContributionNote: 'แท่ง = สัดส่วน contribution ต่อคะแนนรวม · แดง = คะแนนลบ · แสดงเฉพาะปัจจัยที่เปิดใช้',
    reasonOffline: 'ออฟไลน์ — Broadcast ไม่รวมผู้ออฟไลน์',
    reasonStaleLocation: 'พิกัดเก่าเกินเกณฑ์ความสด',
    simMode: 'การเดินทางที่จำลอง',
    simModeReal: 'การเดินทางจริง',
    simModeHypothetical: 'กำหนดรายละเอียดเอง',
    hypoHint:
      'จำลองการจ่ายงานใหม่จากรายละเอียดที่กำหนดโดยไม่สร้างข้อมูลจริง การเดินทางจริงมีไว้ช่วยเติมข้อมูลเท่านั้น ส่วนการเปลี่ยนตัวพนักงานยังใช้เพื่อระบุพนักงานคนเดิม',
    hypoPrefill: 'เติมจากการเดินทางที่เลือก',
    hypoServiceGroup: 'กลุ่มการให้บริการ',
    hypoPickup: 'จุดรับ (lat, lng)',
    hypoDropoff: 'จุดส่ง (lat, lng)',
    hypoTiming: 'เวลา',
    hypoInstant: 'ทันที',
    hypoScheduled: 'ตามกำหนดเวลา',
    purposeLockedHint: 'การเดินทางนี้มีพนักงานแล้ว — จำลองได้เฉพาะ "เปลี่ยนตัวพนักงาน"',
    purposeInitialLockedHint: 'การเดินทางนี้ยังไม่มีพนักงาน — จำลองได้เฉพาะ "จัดงานครั้งแรก"',
    reasonTARGET_TRIP_INELIGIBLE: 'การเดินทางนี้จ่ายงานโหมดนี้ไม่ได้ (สถานะการจัดงานไม่ตรงกับวัตถุประสงค์)',
    reasonMISSING_REQUIRED_SKILLS: 'ทักษะไม่ครบตามที่กลุ่มบริการนี้ต้องการ',
    reasonPROVIDER_MISMATCH: 'ผู้ให้บริการของพนักงานไม่ตรงกับการเดินทาง',
    reasonDRIVER_INACTIVE: 'บัญชีพนักงานไม่ได้อยู่ในสถานะใช้งาน',
    reasonSKILLS_MISMATCH: 'ทักษะไม่ครบตามที่กลุ่มบริการนี้ต้องการ',
    reasonPRESENCE_REQUIRED: 'นโยบายกำหนดให้พนักงานต้องออนไลน์และพร้อมรับงาน',
    reasonLOCATION_REQUIRED: 'ไม่มีพิกัดที่ใช้ตรวจสอบการกระจายงานได้',
    reasonLOCATION_STALE: 'พิกัดล่าสุดเก่าเกินเกณฑ์ที่กำหนด',
    reasonSERVICE_AREA_MISMATCH: 'พื้นที่ให้บริการของพนักงานไม่ตรงกับพื้นที่รับงาน',
    reasonTARGET_NOT_DISPATCHABLE: 'สถานะการเดินทางหรือกลุ่มบริการยังไม่พร้อมกระจายงาน',
    reasonBASE_GATE_FAILED: 'ไม่ผ่านเงื่อนไขพื้นฐานของการกระจายงาน',
    reasonINVALID_TRIP_SCHEDULE: 'เวลาเริ่มหรือระยะเวลาของการเดินทางไม่ถูกต้อง',
    reasonDISTANCE_OUT_OF_RANGE: 'อยู่นอกรัศมีค้นหาที่กำหนด',
    reasonACTIVE_JOB_CONFLICT: 'มีงานที่กำลังดำเนินอยู่และชนกับการเดินทางนี้',
    reasonTIME_OVERLAP: 'ช่วงเวลาชนกับงานอื่นที่ได้รับมอบหมาย',
    reasonTRANSFER_ETA_TOO_LONG: 'เวลาเดินทางและเวลาเผื่อไม่เพียงพอก่อนหรือหลังงาน',
    reasonOFFLINE_NOT_INCLUDED: 'นโยบายไม่รวมพนักงานที่ออฟไลน์',
    reasonSTALE_LOCATION_NOT_INCLUDED: 'นโยบายไม่รวมพิกัดที่เก่าเกินกำหนด',
    reasonNO_LOCATION_NOT_INCLUDED: 'นโยบายไม่รวมพนักงานที่ไม่มีพิกัด',
    reasonTHRESHOLD_NOT_MET: 'คะแนนปัจจัยอย่างน้อยหนึ่งรายการต่ำกว่าเกณฑ์',
    reasonROUTING_FALLBACK: 'ไม่มีเส้นทางจริง — ETA ประมาณจากระยะตรง',
    reasonREJECT_COOLDOWN: 'พนักงานเคยปฏิเสธงานนี้และยังอยู่ในช่วงพักที่กำหนด',
  },
  dispatch: {
    evidenceExpired: 'หลักฐานหมดอายุ',
    // page
    title: 'ห้องทดสอบวงจรคำขอ',
    subtitle: 'เครื่องมือสำหรับนักพัฒนา/ทดสอบ — ตรวจคำขอที่บันทึกไว้และทดสอบการรับ ปฏิเสธ และหมดเวลา',
    devOnly: 'หน้านี้ใช้ได้เฉพาะสภาพแวดล้อมที่ไม่ใช่การใช้งานจริงเท่านั้น',
    unassignedTrips: 'การเดินทางที่รอพนักงาน',
    tripsCount: '{{n}} รายการ',
    selectTripHint: 'เลือกการเดินทางจากรายการเพื่อดูคำขอ',
    noUnassigned: 'ไม่มีการเดินทางที่รอพนักงาน',

    // list columns
    colTrip: 'การเดินทาง',
    colPassenger: 'ผู้โดยสาร',
    colRoute: 'เส้นทาง',

    // detail header
    tripRef: 'รหัสการเดินทาง',
    status: 'สถานะ',
    strategy: 'รูปแบบการกระจายงาน',
    strategySequential: 'ทีละราย',
    strategyBroadcast: 'พร้อมกัน',
    strategyPolicyDefault: 'ใช้ค่าเริ่มต้นจาก Dispatch Policy',
    advancedOptions: 'ตัวเลือกขั้นสูง',
    searching: 'กำลังค้นหาพนักงาน',
    idle: 'ไม่มีคำขอที่รอตอบ',
    searchFailed: 'จัดสรรไม่สำเร็จ — ไม่พบพนักงาน',
    failedAt: 'ล้มเหลวเมื่อ {{time}}',
    failureTimeLoading: 'กำลังโหลดเวลาที่จัดสรรไม่สำเร็จ',
    failureTimeUnavailable: 'ไม่สามารถโหลดเวลาที่จัดสรรไม่สำเร็จได้',
    assignedTo: 'มอบหมายให้',

    // start
    startDispatch: 'เริ่มค้นหาพนักงาน',
    noOffersYet: 'ยังไม่มีการส่งคำขอ',
    startHint: 'กดปุ่มเพื่อเริ่มการกระจายงานแบบอัตโนมัติ (ส่งคำขอให้พนักงาน)',

    // offer card
    offers: 'คำขอที่ส่ง',
    offersCount: 'คำขอ {{n}} รายการ',
    rank: 'อันดับ',
    round: 'รอบ',
    plate: 'ทะเบียน',
    distance: 'ระยะทาง',
    expiresIn: 'เหลือเวลา',
    secondsShort: 'วิ',
    timedOut: 'หมดเวลา',

    // offer statuses
    statusPending: 'รอตอบรับ',
    statusAccepted: 'ยอมรับแล้ว',
    statusRejected: 'ปฏิเสธ',
    statusExpired: 'หมดเวลา',
    statusSuperseded: 'ถูกแทนที่',
    statusCancelled: 'ยกเลิก',

    // actions
    accept: 'ยอมรับ',
    reject: 'ปฏิเสธ',
    tick: 'จำลองหมดเวลา / Tick',
    rejectNote: 'จำลองการปฏิเสธจากพนักงาน',
    loadError: 'โหลดข้อมูลคำขอไม่สำเร็จ',

    // operator-facing (trip detail card + create-trip modal)
    cardTitle: 'การจัดส่งงาน',
    viewHistory: 'ดูประวัติ',
    assigned: 'จัดพนักงานแล้ว',
    offerMethod: 'วิธีส่งข้อเสนอ',
    historyTitle: 'ประวัติการกระจายงาน',
    historyOffersTab: 'ข้อเสนอที่ส่ง',
    historyEvaluationsTab: 'ผลประเมินพนักงาน',
    historyEvaluationHint: 'เหตุผลจากผลประเมินที่บันทึกไว้ในเวลานั้น ชื่อและเบอร์โทรใช้ข้อมูลบัญชีปัจจุบัน ไม่ประเมินเงื่อนไขใหม่',
    historyAttemptFilter: 'ครั้งที่ประเมิน',
    historyAttemptOption: 'ครั้งที่ {{revision}} · {{time}}',
    historyEvaluatedAt: 'ประเมินเมื่อ {{time}}',
    historyEvaluationCount: 'พบผลประเมิน {{count}} รายการในครั้งที่เลือก',
    historyEvaluationLoading: 'กำลังโหลดผลประเมินย้อนหลัง',
    historyEvaluationRetry: 'โหลดผลประเมินใหม่',
    historyEvaluationMissing: 'ไม่มีผลประเมินที่บันทึกไว้สำหรับรอบค้นหานี้ ไม่สามารถระบุเหตุผลที่ไม่ได้ส่งงานได้',
    historyEvaluationEmpty: 'ไม่พบผลประเมินที่ตรงกับคำค้นในครั้งนี้ การไม่มีข้อมูลไม่ได้หมายความว่าพนักงานไม่ผ่านเงื่อนไข',
    historyAttemptsLimited: 'รายการแสดงเฉพาะผลประเมินล่าสุดตามขีดจำกัดของระบบ',
    historyOutcomeEVIDENCE_UNAVAILABLE: 'ไม่มีหลักฐานผลประเมิน',
    historyEvidenceUnavailableHint: 'ข้อมูลเดิมไม่มีหลักฐานเพียงพอที่จะยืนยันเงื่อนไขหรือเหตุผล',
    historyOutcomeEXCLUDED: 'ไม่ผ่านเงื่อนไข ณ ตอนประเมิน',
    historyOutcomeOFFERED: 'มีข้อเสนอที่บันทึกไว้',
    historyOutcomeELIGIBLE_NOT_OFFERED: 'ผ่านเงื่อนไข แต่ไม่พบข้อเสนอที่เชื่อมโยง',
    historyOutcomeEVIDENCE_EXPIRED: 'หลักฐานผลประเมินหมดอายุ',
    historyNoOfferCauseUnknown: 'ผ่านเงื่อนไขในครั้งนี้ แต่ไม่พบข้อเสนอที่เชื่อมโยงกับผลประเมิน ไม่ได้บันทึกเหตุผลเฉพาะที่ไม่ส่งไว้',
    historyEvidenceExpiredHint: 'หลักฐานถูกล้างตามอายุการเก็บข้อมูล จึงไม่สามารถยืนยันเงื่อนไขหรือเหตุผลเดิมได้',
    historyUnknownReason: 'เหตุผลที่บันทึกไว้: {{reason}}',
    historyEvaluationDetails: 'รายละเอียดผลประเมินของ {{name}}',
    historyEvaluationScore: 'คะแนนที่บันทึก',
    historyEvaluationId: 'รหัสผลประเมิน',
    historyUnknownTrigger: 'ผลประเมินที่บันทึกไว้',
    historyTriggerINITIAL: 'ประเมินครั้งแรก',
    historyTriggerRETRY: 'ประเมินเพื่อส่งซ้ำ',
    historyTriggerREFILL: 'ประเมินเพื่อส่งรอบถัดไป',
    historyTriggerMANUAL_REFRESH: 'ผู้จัดสรรขอประเมินใหม่',
    historyClearSearch: 'ล้างคำค้น',
    historyEmployeeMatches: 'พบ {{count}} คำขอในรอบที่เลือก',
    historyEmployeeEmpty: 'ไม่พบประวัติการส่งงานของพนักงานที่ตรงกับคำค้นในรอบที่เลือก',
    historySearchFilter: 'ครั้งที่ค้นหา',
    historySearchNumber: 'ครั้งที่ {{n}}',
    historyAllSearches: 'ทั้งหมด · {{n}} ครั้ง',
    historyAllHint: 'แยกครั้งที่ค้นหาและรอบส่ง รวมครั้งที่ยังไม่ได้ส่งคำขอ',
    historyWaveFilter: 'รอบส่งคำขอ',
    historyAllWaves: 'ทุกรอบ',
    historyWaveCount: 'รอบ {{n}} · {{count}} คำขอ',
    historyTimezone: 'เวลาไทย (UTC+7) · เรียงตามอันดับ ↑',
    historyModeAUTO: 'อัตโนมัติ',
    historyModeMANUAL: 'เลือกเอง',
    historyPurposeINITIAL: 'จัดพนักงานครั้งแรก',
    historyPurposeREASSIGNMENT: 'เปลี่ยนพนักงาน',
    historyStateACTIVE: 'กำลังค้นหา',
    historyStateASSIGNED: 'มีผู้รับงาน',
    historyStateEXHAUSTED: 'ไม่มีผู้รับงาน',
    historyStateCANCELLED: 'ยกเลิก',
    historyStateSUPERSEDED: 'ถูกแทนที่',
    historyLegacy: 'ประวัติจากระบบเดิม',
    historyLegacyHint: 'คำขอในอดีต ไม่มีข้อมูลบริบทการค้นหาเดิม',
    historyStarted: 'เริ่ม',
    historyEnded: 'จบ',
    historyEmployee: 'พนักงาน',
    historySentExpires: 'ส่ง / หมดเวลา',
    historyResult: 'ผลลัพธ์ / เวลาบันทึก',
    historySent: 'ส่ง',
    historyExpires: 'หมดเวลา',
    historyWorkerResponse: 'พนักงานตอบกลับ',
    historySystemResult: 'ระบบบันทึกผล',
    historyDetails: 'รายละเอียด',
    historyOfferId: 'รหัสคำขอ',
    historyReasonNote: 'หมายเหตุเหตุผลที่บันทึกไว้',
    historyNoSearches: 'ยังไม่มีประวัติการค้นหาพนักงาน',
    historySentDisclaimer: 'เวลาส่งคือเวลาสร้างคำขอในระบบ ไม่ใช่หลักฐานว่าส่งถึงหรือเปิดอ่านแล้ว',
    historyMissingTime: '— หมายถึงไม่มีค่าที่บันทึกไว้ กำหนดหมดเวลาไม่ใช่เวลาตอบกลับ',
    staffingSearchExhausted: 'ยังไม่มีพนักงานตอบรับในการค้นหาครั้งนี้',
    staffingSearchExhaustedHint: 'งานยังอยู่ในคิวจัดพนักงาน คุณสามารถค้นหาอัตโนมัติอีกครั้ง เลือกพนักงานเอง หรือทำภายหลัง',
    doLater: 'ทำภายหลัง',
    stopReasonPrompt: 'ระบุเหตุผลที่หยุดการค้นหานี้',
    stopConfirm: 'หยุดการค้นหาและเปลี่ยนวิธีจัดพนักงานหรือไม่?',
    activeSearchConflict: 'มีการค้นหาพนักงานที่ยังดำเนินอยู่',
    activeSearchConflictHint: 'หยุดการค้นหาปัจจุบันก่อนเริ่มรูปแบบที่เลือก',
    stopSearchAndRetry: 'หยุดการค้นหาแล้วลองอีกครั้ง',
    rejectCooldownOverrideReason: 'ระบุเหตุผลที่ต้องเสนอใหัพนักงานคนนี้ซ้ำในช่วงพัก',
    rejectCooldownOverrideConfirm: 'ยืนยันข้ามช่วงพักหลังพนักงานปฏิเสธหรือไม่?',
  },
  tracking: {
    title: 'การติดตามการเดินทาง',
    asOf: 'อัพเดทเมื่อ {{time}}',

    // view switch (FR-W-LIVE-010: Current operations / Map view / Driver view)
    viewLabel: 'มุมมอง',
    viewToday: 'งานที่ต้องติดตาม',
    viewMap: 'มุมมองแผนที่',
    viewAgents: 'มุมมองพนักงาน',

    // left rail — agents by presence
    tabWorking: 'ปฏิบัติงาน',
    tabFree: 'ว่าง',
    tabOffline: 'ออฟไลน์',
    noAgents: 'ไม่มีพนักงานในสถานะนี้',
    todayShort: 'วันนี้',

    // left rail — current operational jobs
    noJobsToday: 'ไม่มีงานที่ต้องติดตาม',

    // right panel — job queues
    ongoing: 'ดำเนินการ',
    unassigned: 'รอมอบหมาย',
    noOngoing: 'ไม่มีงานที่กำลังดำเนินการ',
    noUnassigned: 'ไม่มีงานรอมอบหมาย',
    openJob: 'เปิดรายละเอียด',
    queueButton: 'งาน {{count}}',
    queueTitle: 'รายการงานปฏิบัติการ',

    // right panel — selected agent live detail
    backToQueues: 'กลับไปที่รายการงาน',
    viewProfile: 'ดูโปรไฟล์',
    currentJob: 'งานที่กำลังทำ',

    // location freshness (FR-W-LIVE-010 / issue #480)
    noLocationData: 'ไม่มีข้อมูลตำแหน่ง',
    locationStale: 'ตำแหน่งไม่อัปเดต',
    staleMarkerTooltip: 'ตำแหน่งไม่อัปเดต (อัปเดตล่าสุด {{time}})',
    staleLocationWithTime: 'ตำแหน่งไม่อัปเดต · อัปเดตเมื่อ {{time}}',
  },
  reports: {
    ...reportBaseTranslations.th,
    ...cancelledServicesTranslations.th,
    ...dailyDriverServiceTranslations.th,
    ...dailyServiceFrequencyTranslations.th,
    ...driverAssignmentDetailTranslations.th,
    ...missedServicesTranslations.th,
    ...serviceFrequencyTodayTranslations.th,
    ...serviceUsersTranslations.th,
    navLabel: 'รายงาน',
    title: 'ศูนย์รวมรายงาน',
    serviceJobDetail: 'รายละเอียดงานบริการ',
    cancelledServices: 'บริการที่ถูกยกเลิก',
    missedServices: 'บริการที่ไม่สำเร็จ',
    dailyServiceFrequency: 'บริการรายวัน',
    serviceFrequencyToday: 'จำนวนครั้งบริการวันนี้',
    dailyDriverService: 'บริการรายวันของพนักงาน',
    driverAssignmentDetail: 'การกระจายงานขับรถ',
    serviceUsers: 'ผู้ใช้บริการทั้งหมด',
    serviceJobDetailDesc: 'หนึ่งแถวต่อ Trip สำหรับตรวจสอบค่าโดยสารและการรับชำระ',
    reportList: 'รายงานทั้งหมด',
    dateBasis: 'อ้างอิงวันที่ให้บริการ',
    dataAsOf: 'ข้อมูล ณ {{date}}',
    dictionary: 'คำอธิบายข้อมูล',
    columns: 'คอลัมน์',
    columnsTitle: 'คอลัมน์ที่แสดง',
    columnsIntro: 'เลือก {{count}} คอลัมน์ คอลัมน์เดียวกันนี้จะอยู่ในไฟล์ CSV',
    columnsSelectAll: 'เลือกทั้งหมด',
    columnsReset: 'คืนค่าเริ่มต้น',
    createExport: 'สร้างไฟล์ CSV',
    exportHistory: 'ประวัติไฟล์ส่งออก',
    exportHistoryHint: 'ไฟล์สร้างจากตัวกรองปัจจุบันและเก็บไว้ไม่เกิน 7 วัน',
    exportStatusQUEUED: 'รอดำเนินการ',
    exportStatusRUNNING: 'กำลังสร้าง',
    exportStatusCOMPLETED: 'พร้อมดาวน์โหลด',
    exportStatusFAILED: 'ไม่สำเร็จ',
    exportStatusEXPIRED: 'หมดอายุ',
    exportRows: '{{count}} แถว',
    exportRows_other: '{{count}} แถว',
    exportProviderCount: 'ผู้ให้บริการ {{count}} แห่ง',
    exportProviderCount_other: 'ผู้ให้บริการ {{count}} แห่ง',
    exportAdditionalFilterCount: 'ตัวกรองเพิ่ม {{count}} รายการ',
    exportAdditionalFilterCount_other: 'ตัวกรองเพิ่ม {{count}} รายการ',
    exportExpiresAt: 'ดาวน์โหลดได้ถึง {{date}}',
    exportExpiredAt: 'หมดอายุเมื่อ {{date}}',
    exportShowing: 'แสดง {{shown}} จากทั้งหมด {{total}}',
    exportLoadMore: 'โหลดเพิ่มเติม',
    exportLoadingMore: 'กำลังโหลดประวัติไฟล์ส่งออกเพิ่มเติม',
    exportAllTimeConfirmTitle: 'สร้างไฟล์ทุกช่วงเวลาหรือไม่',
    exportAllTimeWarning: 'ไฟล์นี้จะรวมข้อมูลทุกช่วงเวลา',
    exportConfirmScope: '{{rows}} · {{providers}}',
    downloadExport: 'ดาวน์โหลด',
    noExports: 'ยังไม่มีไฟล์ส่งออก',
    exportCreateError: 'ส่งคำขอสร้างไฟล์ไม่สำเร็จ กรุณาลองใหม่',
    exportHistoryError: 'โหลดประวัติไฟล์ส่งออกไม่สำเร็จ',
    exportDownloadError: 'ดาวน์โหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่',
    filterDate: 'ช่วงวันที่',
    filterProvider: 'ผู้ให้บริการ',
    filterArea: 'พื้นที่',
    filterGroup: 'กลุ่มบริการ',
    filterStatus: 'สถานะงาน',
    filterPayment: 'การชำระเงิน',
    filterSearch: 'ค้นหา',
    filterSearchPlaceholder: 'ค้นหา...',
    clearFilters: 'ล้างตัวกรอง',
    allProviders: 'ทุก Provider',
    allAreas: 'ทุกพื้นที่',
    allGroups: 'ทุกกลุ่มบริการ',
    allStatuses: 'ทุกสถานะ',
    allPayments: 'ทุกสถานะชำระเงิน',
    paymentFREE: 'เที่ยวฟรี',
    paymentFINANCE_REVIEW: 'ต้องตรวจสอบการเงิน',
    paymentNOT_BILLABLE: 'ไม่เรียกเก็บ',
    paymentUNBILLED: 'ยังไม่วางบิล',
    paymentOUTSTANDING: 'ค้างชำระ',
    paymentPARTIAL: 'ชำระบางส่วน',
    paymentSETTLED: 'ชำระครบ',
    emptyTitle: 'ไม่พบข้อมูลตามตัวกรอง',
    emptyBody: 'ลองเปลี่ยนช่วงวันที่หรือยกเลิกตัวกรองบางรายการ',
    errorTitle: 'โหลดรายงานไม่สำเร็จ',
    errorBody: 'กรุณาลองใหม่อีกครั้ง',
    refreshError: 'รีเฟรชรายงานไม่สำเร็จ กำลังแสดงข้อมูลล่าสุดที่โหลดได้',
    deniedTitle: 'คุณไม่มีสิทธิ์ดูรายงานนี้',
    deniedBody: 'ติดต่อผู้ดูแล Provider เพื่อขอสิทธิ์เข้าถึงรายงาน',
    rowsShown: 'แสดง {{from}}–{{to}} จาก {{total}} รายการ',
    summaryTrips: 'Trip ทั้งหมด',
    summaryFare: 'ค่าโดยสาร',
    summaryBilled: 'ยอดเรียกเก็บ',
    summaryReceived: 'รับชำระแล้ว',
    summaryOutstanding: 'ยอดค้างชำระ',
    summaryReview: 'ต้องตรวจสอบ',
    tableTitle: 'รายการ Trip',
    tableHint: 'เลื่อนตารางในแนวนอนเพื่อดูรายละเอียดทั้งหมด',
    colTripRef: 'Trip ref',
    colServiceDate: 'วันที่ให้บริการ',
    colStatus: 'สถานะ',
    colPassenger: 'ผู้โดยสาร',
    colAgent: 'พนักงาน',
    colProvider: 'ผู้ให้บริการ',
    colArea: 'พื้นที่',
    colGroup: 'กลุ่มบริการ',
    colQuoted: 'ราคาตอนจอง',
    colFinal: 'ราคาสุดท้าย',
    colBilled: 'เรียกเก็บ',
    colReceived: 'รับชำระ',
    colOutstanding: 'ค้างชำระ',
    colPayment: 'สถานะชำระเงิน',
    colReview: 'ตรวจสอบ',
    yes: 'ใช่',
    no: 'ไม่',
    dictionaryTitle: 'คำอธิบายคอลัมน์',
    dictionaryIntro: 'ชื่อคอลัมน์ในหน้าจอแปลตามภาษา โดยชื่อข้อมูลใน API ยังคงที่',
    piiLabel: 'ข้อมูลส่วนบุคคล',
    moneyLabel: 'จำนวนเต็มหน่วยบาท',
    dictionarySource: 'ที่มา: {{source}}',
    dictionaryTypeUnit: 'ชนิด: {{type}}{{unit}}',
    dictionaryEmpty: 'เมื่อค่าว่าง: {{meaning}}',
    dictionaryMeaning: 'ความหมาย: {{meaning}}',
    dictionarySourceName_trip: 'ข้อมูล Trip',
    dictionarySourceName_passenger: 'ข้อมูลผู้โดยสาร ณ เวลารายงาน',
    dictionarySourceName_agent: 'ข้อมูลพนักงานที่ได้รับมอบหมาย ณ เวลารายงาน',
    dictionarySourceName_vehicle: 'ข้อมูลรถที่ได้รับมอบหมาย ณ เวลารายงาน',
    dictionarySourceName_provider: 'ข้อมูล Provider ณ เวลารายงาน',
    dictionarySourceName_service: 'ข้อมูลตั้งค่าบริการ ณ เวลารายงาน',
    dictionarySourceName_route: 'เส้นทางและตัวชี้วัดของ Trip',
    dictionarySourceName_fare: 'ผลคำนวณค่าโดยสารมาตรฐาน',
    dictionarySourceName_payment: 'รายการชำระเงินมาตรฐาน',
    dictionarySourceName_derived: 'ค่าที่รายงานคำนวณ',
    dictionaryTypeName_identifier: 'รหัสระบุ',
    dictionaryTypeName_text: 'ข้อความ',
    dictionaryTypeName_enum: 'สถานะที่กำหนดไว้',
    dictionaryTypeName_timestamp: 'เวลา ISO-8601 พร้อมเขตเวลา Bangkok +07:00',
    dictionaryTypeName_number: 'ตัวเลข',
    dictionaryTypeName_boolean: 'true/false',
    dictionaryTypeName_list: 'รายการ',
    dictionaryUnit_m: ' · เมตร',
    dictionaryFieldMeaning_locationExceptionPresence:
      'หนึ่งแถวต่อเที่ยว เป็นจริงเมื่อมีเหตุการณ์คำเตือน OUTSIDE_RADIUS, LOCATION_UNAVAILABLE หรือ LOW_ACCURACY อย่างน้อยหนึ่งครั้ง เป็นเท็จเมื่อไม่มี คำเตือนแบบสเกลาร์ยังคงอยู่หลังลบพิกัด ยอดการเงินนับครั้งเดียวต่อเที่ยว',
    dictionaryFieldMeaning_locationExceptionCount:
      'จำนวนเหตุการณ์คำเตือนที่เข้าเกณฑ์ในเที่ยวนี้ ไม่ใช่จำนวนเที่ยว ศูนย์หมายถึงไม่มีข้อยกเว้น ค่าที่คำนวณนี้ไม่เป็น null การลบพิกัดยังเก็บหลักฐานสเกลาร์ที่นับที่นี่',
    dictionaryFieldMeaning_latestLocationException:
      'จากข้อยกเว้นที่เข้าเกณฑ์ล่าสุด เรียงตามเวลาเหตุการณ์แล้วรหัสเหตุการณ์ ตัวกรองคำเตือนและเหตุผลใช้กับข้อยกเว้นล่าสุดเดียวกัน ไม่ใช่เหตุการณ์เก่า สเกลาร์ยังอยู่หลังลบพิกัด null หมายถึงไม่มีข้อยกเว้นหรือไม่ได้บันทึกค่านี้ ศูนย์เป็นค่าตัวเลขที่บันทึกไว้ ไม่รวมพิกัดหรือบันทึกข้อความอิสระ',
    dictionaryUnit_none: '',
    dictionaryUnit_thb: ' · บาทจำนวนเต็ม',
    dictionaryUnit_km: ' · กม.',
    dictionaryUnit_min: ' · นาที',
    dictionaryEmptyMeaning_never: 'ไม่ควรว่าง เนื่องจากมีค่าเสมอ',
    dictionaryEmptyMeaning_notRecorded: 'ยังไม่มีการบันทึกเหตุการณ์หรือค่านี้',
    dictionaryEmptyMeaning_notAssigned: 'ยังไม่ได้มอบหมายพนักงานหรือรถ',
    dictionaryEmptyMeaning_notApplicable: 'ข้อมูลนี้ไม่เกี่ยวข้องกับ Trip นี้',
    dictionaryEmptyMeaning_unavailable: 'ไม่มีหลักฐานจากแหล่งข้อมูล ห้ามตีความว่าเป็นศูนย์',
    dictionaryFieldMeaning_direct: 'ค่าตามชื่อจากแหล่งข้อมูลที่ระบุ',
    dictionaryFieldMeaning_requestedAtAlias: 'ปัจจุบันใช้ค่าเดียวกับ created_at ของ Trip ไม่ใช่เวลาขอใช้บริการที่บันทึกแยก',
    dictionaryFieldMeaning_tripMilestone:
      'เหตุการณ์สถานะ Trip ที่ตรงรายการครั้งแรก โดย accepted_at ใช้ ASSIGNED หรือ REASSIGNED และไม่ใช่เวลาที่พนักงานปัจจุบันรับงาน',
    dictionaryFieldMeaning_agentCodeUnavailable: 'ช่อง CSV ที่สำรองไว้ ปัจจุบัน API ส่งค่าว่างแม้มีพนักงานรับงานแล้ว',
    dictionaryFieldMeaning_serviceDateBasis: 'ระบุว่า service_date ใช้ scheduled_start หรือใช้ created_at แทน',
    dictionaryFieldMeaning_pipeSeparated: 'หลายค่าคั่นด้วย | โดยลำดับรหัสและชื่อตรงกัน',
    dictionaryFieldMeaning_actualMetricSource: 'ระบุหลักฐานที่ใช้หาค่าระยะทางหรือระยะเวลาจริง',
    dictionaryFieldMeaning_fareState:
      'NONE, PROVISIONAL, FINAL หรือ CANCELLED_SNAPSHOT เพื่อบอกวงจรชีวิตค่าโดยสารปัจจุบัน',
    dictionaryFieldMeaning_quoteProvenance:
      'BOOKING_SNAPSHOT เมื่อเก็บราคาตอนจอง หรือ UNAVAILABLE เมื่อไม่มีหลักฐานราคาเสนอ',
    dictionaryFieldMeaning_quotedTotal: 'ราคาที่เสนอ ณ เวลาจอง ไม่เปลี่ยนตามการคำนวณภายหลัง',
    dictionaryFieldMeaning_currentTotal: 'ค่าโดยสารมาตรฐานปัจจุบันที่ใช้ในสรุปรายงาน ทั้งแบบชั่วคราวและสุดท้าย',
    dictionaryFieldMeaning_finalTotal: 'ค่าโดยสารสุดท้ายที่ปิดยอดแล้วเท่านั้น ว่างจนกว่าจะมีการปิดยอดสุดท้าย',
    dictionaryFieldMeaning_fareAdjustmentDelta:
      'current_total ลบ quoted_total รวมถึงช่วงที่ค่าโดยสารยังเป็น PROVISIONAL',
    dictionaryFieldMeaning_billingMetricSource: 'ระบุหลักฐานตัวชี้วัดที่การคำนวณค่าโดยสารมาตรฐานใช้',
    dictionaryFieldMeaning_paymentComponent: 'ส่วนชำระเงิน BASE หรือ OVERAGE ว่างเมื่อไม่มีส่วนนั้น',
    dictionaryFieldMeaning_billedTotal: 'ผลรวมยอดเรียกเก็บ BASE และ OVERAGE มาตรฐานของ Trip นี้',
    dictionaryFieldMeaning_completedRefundsTotal:
      'ยอดคืนเงินจริงที่ยืนยันแล้ว รวม BASE, OVERAGE และ amendment ไม่รวมยอดกันไว้คืนหรือยอดยกเว้น',
    dictionaryFieldMeaning_netRetainedTotal: 'ยอดรับเงินจริงหักยอดคืนแล้ว ยอดรอคืนยังเป็นเงินคงเหลือจนกว่าจะยืนยันการคืน',
    dictionaryFieldMeaning_pendingRefundsTotal:
      'ภาระคืนเงินที่บันทึกแล้วหักยอดคืนแล้ว รวมคำตัดสินคืนเงินล่าสุดของ Partner ไม่ถือว่าข้อเสนอที่ยังรอหรือราคาที่ลดลงเป็นภาระคืนเงินโดยอัตโนมัติ',
    dictionaryFieldMeaning_reconciliationCashTotal:
      'เงินในบัญชีรอตรวจสอบที่ยังไม่ได้กันไว้คืน แยกจากภาระรอคืนเงิน และไม่ถือเป็นภาระคืนเงินโดยอัตโนมัติ',
    dictionaryFieldMeaning_receivedTotal: 'ผลรวมยอดรับชำระ BASE และ OVERAGE มาตรฐาน รวมสถานะคืนเงินปลายทาง',
    dictionaryFieldMeaning_outstandingTotal: 'ยอดเรียกเก็บมาตรฐานที่ยังค้างหลังหักยอดรับชำระ และไม่ติดลบ',
    dictionaryFieldMeaning_paymentState:
      'สถานะชำระเงินมาตรฐานที่คำนวณขึ้น ยอดรับชำระที่ REFUNDED ครบถือเป็นสถานะสิ้นสุด ไม่ใช่ต้องตรวจสอบอย่างเดียว',
    dictionaryFieldMeaning_financeReview:
      'เป็น true เมื่อหลักฐานค่าโดยสารหรือการชำระเงินมาตรฐานต้องให้ผู้ปฏิบัติงานตรวจ ยอดคืนเงินที่สิ้นสุดครบแล้วไม่ถูกตั้งธง',
    dictionaryFieldLabel_trip_id: 'รหัส Trip',
    dictionaryFieldLabel_trip_ref: 'เลขอ้างอิง Trip',
    dictionaryFieldLabel_trip_status: 'สถานะ Trip',
    dictionaryFieldLabel_trip_leg: 'ขาเดินทาง',
    dictionaryFieldLabel_service_mode: 'รูปแบบบริการ',
    dictionaryFieldLabel_dispatch_mode: 'รูปแบบกระจายงาน',
    dictionaryFieldLabel_created_at: 'เวลาสร้าง',
    dictionaryFieldLabel_requested_at: 'เวลาขอใช้บริการ',
    dictionaryFieldLabel_service_date: 'วันที่ให้บริการ',
    dictionaryFieldLabel_date_basis: 'หลักอ้างอิงวันที่ให้บริการ',
    dictionaryFieldLabel_scheduled_start: 'เวลาเริ่มตามแผน',
    dictionaryFieldLabel_scheduled_end: 'เวลาสิ้นสุดตามแผน',
    dictionaryFieldLabel_accepted_at: 'เวลารับงาน',
    dictionaryFieldLabel_started_at: 'เวลาเริ่มงาน',
    dictionaryFieldLabel_picked_up_at: 'เวลารับผู้โดยสาร',
    dictionaryFieldLabel_completed_at: 'เวลาทำงานเสร็จ',
    dictionaryFieldLabel_passenger_id: 'รหัสผู้โดยสาร',
    dictionaryFieldLabel_passenger_code: 'โค้ดผู้โดยสาร',
    dictionaryFieldLabel_passenger_name: 'ชื่อผู้โดยสาร',
    dictionaryFieldLabel_passenger_phone: 'โทรศัพท์ผู้โดยสาร',
    dictionaryFieldLabel_agent_id: 'รหัสพนักงาน',
    dictionaryFieldLabel_agent_code: 'โค้ดพนักงาน',
    dictionaryFieldLabel_agent_name: 'ชื่อพนักงาน',
    dictionaryFieldLabel_agent_phone: 'โทรศัพท์พนักงาน',
    dictionaryFieldLabel_vehicle_id: 'รหัสรถ',
    dictionaryFieldLabel_vehicle_plate: 'ทะเบียนรถ',
    dictionaryFieldLabel_provider_id: 'รหัส Provider',
    dictionaryFieldLabel_provider_name: 'ชื่อ Provider',
    dictionaryFieldLabel_service_area_ids: 'รหัสพื้นที่บริการ',
    dictionaryFieldLabel_service_area_names: 'ชื่อพื้นที่บริการ',
    dictionaryFieldLabel_service_group_id: 'รหัสกลุ่มบริการ',
    dictionaryFieldLabel_service_group_name: 'ชื่อกลุ่มบริการ',
    dictionaryFieldLabel_origin_label: 'ชื่อจุดต้นทาง',
    dictionaryFieldLabel_destination_label: 'ชื่อจุดปลายทาง',
    dictionaryFieldLabel_planned_distance_km: 'ระยะทางตามแผน',
    dictionaryFieldLabel_planned_duration_min: 'ระยะเวลาตามแผน',
    dictionaryFieldLabel_actual_distance_km: 'ระยะทางจริง',
    dictionaryFieldLabel_actual_duration_min: 'ระยะเวลาจริง',
    dictionaryFieldLabel_actual_distance_source: 'ที่มาระยะทางจริง',
    dictionaryFieldLabel_actual_duration_source: 'ที่มาระยะเวลาจริง',
    dictionaryFieldLabel_currency: 'สกุลเงินค่าโดยสาร',
    dictionaryFieldLabel_fare_state: 'สถานะค่าโดยสาร',
    dictionaryFieldLabel_quote_provenance: 'ที่มาราคาเสนอ',
    dictionaryFieldLabel_quoted_total: 'ราคาที่เสนอตอนจอง',
    dictionaryFieldLabel_current_total: 'ค่าโดยสารปัจจุบัน',
    dictionaryFieldLabel_final_total: 'ค่าโดยสารสุดท้าย',
    dictionaryFieldLabel_fare_adjustment_delta: 'ผลต่างค่าโดยสาร',
    dictionaryFieldLabel_fare_base: 'ค่าโดยสารพื้นฐาน',
    dictionaryFieldLabel_fare_overage_distance: 'ค่าเกินระยะทาง',
    dictionaryFieldLabel_fare_overage_time: 'ค่าเกินเวลา',
    dictionaryFieldLabel_fare_surcharge_total: 'ค่าบริการเพิ่มรวม',
    dictionaryFieldLabel_fare_computed_at: 'เวลาคำนวณค่าโดยสาร',
    dictionaryFieldLabel_billing_distance_source: 'ที่มาระยะทางเรียกเก็บ',
    dictionaryFieldLabel_billing_duration_source: 'ที่มาระยะเวลาเรียกเก็บ',
    dictionaryFieldLabel_billable_distance_km: 'ระยะทางที่เรียกเก็บ',
    dictionaryFieldLabel_billable_duration_min: 'ระยะเวลาที่เรียกเก็บ',
    dictionaryFieldLabel_fare_is_free: 'ธงค่าโดยสารฟรี',
    dictionaryFieldLabel_base_payment_status: 'สถานะชำระ BASE',
    dictionaryFieldLabel_base_amount_due: 'ยอด BASE ที่ต้องชำระ',
    dictionaryFieldLabel_base_amount_received: 'ยอด BASE ที่รับแล้ว',
    dictionaryFieldLabel_base_outstanding: 'ยอด BASE ค้างชำระ',
    dictionaryFieldLabel_base_due_by: 'กำหนดชำระ BASE',
    dictionaryFieldLabel_base_verified_at: 'เวลาตรวจสอบ BASE',
    dictionaryFieldLabel_overage_payment_status: 'สถานะชำระ OVERAGE',
    dictionaryFieldLabel_overage_amount_due: 'ยอด OVERAGE ที่ต้องชำระ',
    dictionaryFieldLabel_overage_amount_received: 'ยอด OVERAGE ที่รับแล้ว',
    dictionaryFieldLabel_overage_outstanding: 'ยอด OVERAGE ค้างชำระ',
    dictionaryFieldLabel_overage_due_by: 'กำหนดชำระ OVERAGE',
    dictionaryFieldLabel_overage_verified_at: 'เวลาตรวจสอบ OVERAGE',
    dictionaryFieldLabel_billed_total: 'ยอดเรียกเก็บรวม',
    dictionaryFieldLabel_waived_outstanding_total: 'ยอดคงค้างที่ยกเว้น',
    dictionaryFieldLabel_overage_review_status: 'สถานะตรวจสอบส่วนเกิน',
    dictionaryFieldLabel_completed_refunds_total: 'คืนเงินแล้ว',
    dictionaryFieldLabel_net_retained_total: 'เงินรับสุทธิคงเหลือ',
    dictionaryFieldLabel_pending_refunds_total: 'รอคืนเงิน',
    dictionaryFieldLabel_reconciliation_cash_total: 'เงินรอตรวจสอบบัญชี',
    dictionaryFieldLabel_received_total: 'ยอดรับชำระรวม',
    dictionaryFieldLabel_outstanding_total: 'ยอดค้างชำระรวม',
    dictionaryFieldLabel_payment_state: 'สถานะชำระเงิน',
    confirmation_NOT_REQUIRED: 'ไม่ต้องยืนยัน',
    confirmation_OVERRIDE: 'ยอมรับการยืนยันข้อยกเว้น',
    confirmation_LEGACY_NO_CONFIRMATION: 'ไคลเอนต์รุ่นเดิมไม่มีการยืนยัน',
    exceptionExportNotReady:
      'ยังไม่สามารถส่งออกข้อยกเว้นได้ ลบตัวกรองข้อยกเว้นและใช้คอลัมน์เริ่มต้นเพื่อส่งออกตอนนี้ คอลัมน์และตัวกรองข้อยกเว้นต้องใช้บริการส่งออกที่รองรับ',
    filterLocationException: 'ข้อยกเว้นตำแหน่ง',
    allLocationExceptions: 'ทุกเที่ยว',
    withLocationException: 'มีข้อยกเว้น',
    withoutLocationException: 'ไม่มีข้อยกเว้น',
    filterLatestWarning: 'คำเตือนข้อยกเว้นล่าสุด',
    allLatestWarnings: 'ทุกคำเตือนล่าสุด',
    filterLatestOverride: 'เหตุผลยืนยันข้อยกเว้นล่าสุด',
    allLatestOverrides: 'ทุกเหตุผลยืนยันล่าสุด',
    override_GPS_INACCURATE: 'GPS ไม่แม่นยำ',
    override_MEETING_POINT_INCORRECT: 'จุดนัดพบไม่ถูกต้อง',
    override_PASSENGER_REQUESTED_DIFFERENT_POINT: 'ผู้โดยสารขอเปลี่ยนจุด',
    override_EMERGENCY: 'เหตุฉุกเฉิน',
    override_OTHER: 'อื่น ๆ',
    dictionaryFieldLabel_has_location_exception: 'มีข้อยกเว้นตำแหน่ง',
    dictionaryFieldLabel_exception_count: 'จำนวนข้อยกเว้นตำแหน่ง',
    dictionaryFieldLabel_latest_exception_at: 'เวลาข้อยกเว้นล่าสุด',
    dictionaryFieldLabel_latest_exception_event: 'เหตุการณ์ข้อยกเว้นล่าสุด',
    dictionaryFieldLabel_latest_exception_warning: 'คำเตือนข้อยกเว้นล่าสุด',
    dictionaryFieldLabel_latest_exception_override_reason: 'เหตุผลยืนยันข้อยกเว้นล่าสุด',
    dictionaryFieldLabel_latest_exception_confirmation: 'การยืนยันข้อยกเว้นล่าสุด',
    dictionaryFieldLabel_latest_exception_source: 'แหล่งข้อมูลข้อยกเว้นล่าสุด',
    dictionaryFieldLabel_latest_exception_accuracy_m: 'ความแม่นยำข้อยกเว้นล่าสุด (ม.)',
    dictionaryFieldLabel_latest_exception_distance_to_target_m: 'ระยะถึงเป้าหมายข้อยกเว้นล่าสุด (ม.)',
    dictionaryFieldLabel_latest_exception_radius_m: 'รัศมีข้อยกเว้นล่าสุด (ม.)',
    dictionaryFieldLabel_requires_finance_review: 'ต้องตรวจสอบการเงิน',
    filterAreaSearch: 'ค้นหาตัวเลือกพื้นที่',
    filterGroupSearch: 'ค้นหาตัวเลือกกลุ่มบริการ',
    filterOptionSearchPlaceholder: 'ค้นหาตัวเลือก',
    filterOptionsLoadMore: 'โหลดตัวเลือกเพิ่มเติม',
    filterOptionsError: 'โหลดตัวเลือกไม่สำเร็จ',
    selectedOptionLoading: 'กำลังโหลดตัวเลือก {{id}}',
    selectedOptionUnavailable: 'ตัวเลือกที่ใช้ไม่ได้ {{id}}',
    selectedOptionsLoading: 'กำลังตรวจสอบตัวเลือกที่เลือก…',
    selectedOptionsUnavailable: 'ตัวเลือกบางรายการใช้ไม่ได้ในขอบเขต Provider ปัจจุบัน สามารถนำออกเพื่อเปลี่ยนรายงานได้',
    registryError: 'โหลดสิทธิ์รายงานไม่สำเร็จ ระบบไม่ได้ขอข้อมูลรายงาน',
    unavailableTitle: 'รายงานนี้ยังไม่พร้อมใช้งาน',
    unavailableBody: 'เลือกรายงานที่พร้อมใช้งานจากรายการ',
    retainedLoading: 'กำลังอัปเดตตัวกรอง แถวและสรุปด้านล่างยังเป็นข้อมูลจากตัวกรองก่อนหน้า',
    retainedError: 'รีเฟรชไม่สำเร็จ แถวและสรุปด้านล่างยังเป็นตัวกรองก่อนหน้า ไม่ใช่ตัวกรองปัจจุบัน',
    retainedBadge: 'ตัวกรองก่อนหน้า',
    colCurrentFare: 'ค่าโดยสารปัจจุบัน',
    prototypeBadge: 'ต้นแบบสำหรับรีวิว · ข้อมูลจำลอง',
    prototypeNotice: 'หน้านี้ใช้ข้อมูลจำลองในเครื่องเพื่อรีวิวหน้าตาและการใช้งาน ยังไม่มีการเรียก Report API',
    serviceFrequencyTodayDesc: 'ภาพรวมจำนวนงานและยอดเรียกเก็บของวันนี้',
    dailyServiceFrequencyDesc: 'แนวโน้มงานรายวันพร้อมสถานะและยอดการเงิน',
    cancelledServicesDesc: 'งานที่ถูกยกเลิก เหตุผล ผู้ดำเนินการ และรายการที่ต้องตรวจสอบ',
    missedServicesDesc: 'งานที่เข้าสู่สถานะไม่สำเร็จพร้อมหลักฐานการกระจายงานล่าสุด',
    driverAssignmentDetailDesc: 'ประวัติ Offer, Manual confirmation และ Reassignment จาก Dispatch V2',
    serviceUsersDesc: 'ผู้โดยสารที่มีความสัมพันธ์การให้บริการกับ Provider',
    dailyDriverServiceDesc: 'ผลงานรายวันและยอดวางบิลลูกค้าที่ผูกกับ Trip ของพนักงาน',
    creatingExport: 'กำลังสร้างรายการ…',
    providerLogHealth: 'LogHealth',
    providerFoundation: 'มูลนิธิเส้นด้าย',
    areaBangkok: 'กรุงเทพมหานคร',
    areaNonthaburi: 'นนทบุรี',
    groupRide: 'รับส่งผู้ป่วย',
    groupCare: 'ดูแลผู้สูงอายุ',
    paymentPaid: 'ชำระครบ',
    paymentPartial: 'ชำระบางส่วน',
    paymentOutstanding: 'ค้างชำระ',
    paymentFree: 'เที่ยวฟรี',
    reviewState: 'สถานะสำหรับรีวิว',
    stateReady: 'ข้อมูลปกติ',
    stateLoading: 'กำลังโหลด',
    stateEmpty: 'ไม่มีข้อมูล',
    stateError: 'เกิดข้อผิดพลาด',
    stateDenied: 'ไม่มีสิทธิ์',
    stateLong: 'ข้อมูลยาว/ตารางกว้าง',
    colDate: 'วันที่',
    colRequests: 'คำขอ',
    colCompleted: 'สำเร็จ',
    colCancelled: 'ยกเลิก',
    colMissed: 'ไม่สำเร็จ',
    colReason: 'เหตุผล',
    colOffers: 'Offer',
    colAccepted: 'รับงาน',
    colRejected: 'ปฏิเสธ',
    colName: 'ชื่อ',
    colPhone: 'โทรศัพท์',
    colTrips: 'จำนวน Trip',
    openTrip: 'เปิดรายละเอียด Trip',
    exportTitle: 'ประวัติการส่งออก CSV',
    exportIntro: 'รายการจำลองนี้แสดงวงจรงานแบบ asynchronous และไฟล์หมดอายุใน 7 วัน',
    exportQueued: 'รอประมวลผล',
    exportRunning: 'กำลังประมวลผล',
    exportCompleted: 'พร้อมดาวน์โหลด',
    exportFailed: 'ไม่สำเร็จ',
    exportExpired: 'หมดอายุ',
    download: 'ดาวน์โหลด',
    expiresIn: 'หมดอายุใน 7 วัน',
    rowCount: '{{count}} รายการ',
    customerBillingNote: 'ตัวเลขการเงินเป็นยอดวางบิลลูกค้าที่ผูกกับ Trip ไม่ใช่ค่าตอบแทนพนักงาน',
  },
} as const;
